{"https://schema.org/":"schema",
"https://w3id.org/tss#":"tss",
"https://w3id.org/conn#":"conn",
"http://www.loc.gov/mads/rdf/v1#":"madsrdf",
"http://id.loc.gov/ontologies/bflc/":"bflc",
"http://xmlns.com/foaf/0.1/":"foaf",
"http://www.w3.org/1999/02/22-rdf-syntax-ns#":"rdf",
"http://dbpedia.org/ontology/":"dbo",
"http://www.w3.org/2000/01/rdf-schema#":"rdfs",
"http://yago-knowledge.org/resource/":"yago",
"http://purl.org/dc/elements/1.1/":"dc",
"http://dbpedia.org/property/":"dbp",
"http://www.w3.org/2002/07/owl#":"owl",
"http://www.w3.org/2004/02/skos/core#":"skos",
"http://purl.org/goodrelations/v1#":"gr",
"http://www.opengis.net/ont/geosparql#":"geo",
"http://data.ordnancesurvey.co.uk/ontology/spatialrelations/":"spacerel",
"http://www.w3.org/2001/XMLSchema#":"xsd",
"http://www.w3.org/ns/org#":"org",
"http://www.w3.org/ns/dcat#":"dcat",
"http://purl.org/dc/terms/":"dct",
"http://example.org/":"ex",
"http://purl.org/linked-data/cube#":"qb",
"http://www.w3.org/ns/prov#":"prov",
"http://rdfs.org/sioc/ns#":"sioc",
"http://purl.org/xtypes/":"xtypes",
"http://dbpedia.org/resource/":"dbpedia",
"http://rdfs.org/ns/void#":"void",
"http://purl.org/net/ns/ontology-annot#":"ont",
"http://www.ontotext.com/":"onto",
"http://semanticscience.org/resource/":"sio",
"http://purl.obolibrary.org/obo/":"obo",
"http://schema.org/":"schema",
"http://id.loc.gov/ontologies/bibframe/":"bf",
"http://sindice.com/vocab/search#":"search",
"http://www.w3.org/ns/sparql-service-description#":"sd",
"http://fliqz.com/":"urn",
"http://purl.org/vocab/frbr/core#":"frbr",
"http://www.w3.org/ns/posix/stat#":"stat",
"http://www.w3.org/2006/vcard/ns#":"vcard",
"http://www.holygoat.co.uk/owl/redwood/0.1/tags/":"tag",
"http://eample.com/test#":"ttp",
"http://purl.org/commerce#":"commerce",
"http://purl.org/ontology/bibo/":"bibo",
"http://www.productontology.org/id/":"pto",
"http://purl.org/rss/1.0/":"rss",
"http://purl.org/openorg/":"oo",
"http://www.w3.org/ns/people#":"gldp",
"http://purl.org/vocab/vann/":"vann",
"http://www.geonames.org/ontology#":"geonames",
"http://purl.org/rss/1.0/modules/content/":"content",
"http://rdf.freebase.com/ns/":"fb",
"http://purl.org/NET/c4dm/event.owl#":"event",
"http://purl.org/gen/0.1#":"gen",
"http://www.wikidata.org/entity/":"wd",
"http://purl.org/dc/dcmitype/":"dcmit",
"http://creativecommons.org/ns#":"cc",
"http://www.w3.org/2011/http#":"http",
"http://usefulinc.com/ns/doap#":"doap",
"http://www.w3.org/ns/r2rml#":"rr",
"http://swrc.ontoware.org/ontology#":"swrc",
"https://www.w3.org/ns/activitystreams#":"as",
"http://www.semanticdesktop.org/ontologies/2007/01/19/nie#":"nie",
"https://cuzin.com/":"leaks",
"http://www.w3.org/ns/md#":"md",
"http://www4.wiwiss.fu-berlin.de/drugbank/resource/drugbank/":"drugbank",
"http://www.w3.org/2005/xpath-functions#":"fn",
"http://rdfs.org/resume-rdf/":"cv",
"http://xmlns.com/wot/0.1/":"wot",
"http://purl.org/prog/":"prog",
"http://purl.org/vocab/aiiso/schema#":"aiiso",
"http://www.w3.org/ns/ma-ont#":"ma",
"http://purl.uniprot.org/uniprot/":"uniprot",
"http://purl.org/NET/c4dm/timeline.owl#":"tl",
"http://purl.org/ontology/daia/":"daia",
"http://data.semanticweb.org/ns/swc/ontology#":"swc",
"http://www.aktors.org/ontology/portal#":"akt",
"http://www.w3.org/2002/12/cal/ical#":"ical",
"http://www.w3.org/1999/xhtml#":"xhtml",
"http://purl.org/vocab/relationship/":"rel",
"http://www.cidoc-crm.org/cidoc-crm/":"crm",
"http://purl.org/vocab/bio/0.1/":"bio",
"http://www.w3.org/ns/earl#":"earl",
"http://qudt.org/vocab/unit/":"unit",
"http://purl.org/ontology/mo/":"mo",
"http://rdf.data-vocabulary.org/#":"dv",
"http://id.loc.gov/vocabulary/relators/":"marcrel",
"http://open.vocab.org/terms/":"ov",
"http://www.w3.org/2004/03/trix/rdfg-1/":"rdfg",
"http://www.w3.org/1999/xhtml/vocab#":"xhv",
"http://purl.org/vocab/changeset/schema#":"cs",
"http://jena.apache.org/ARQ/function#":"afn",
"http://schemas.talis.com/2005/address/schema#":"ad",
"http://purl.org/ontology/co/core#":"co",
"http://www.w3.org/2003/06/sw-vocab-status/ns#":"vs",
"http://opengraphprotocol.org/schema/":"og",
"http://dig.csail.mit.edu/TAMI/2007/amord/air#":"air",
"http://mu.semte.ch/vocabularies/core/":"mu",
"http://www.rdfabout.com/rdf/schema/usbill/":"bill",
"http://this.invalid/test2#":"test2",
"http://gmpg.org/xfn/11#":"xfn",
"http://purl.org/NET/book/vocab#":"book",
"http://www.w3.org/2000/10/swap/log#":"log",
"http://purl.org/ontology/similarity/":"musim",
"http://wifo5-04.informatik.uni-mannheim.de/factbook/ns#":"factbook",
"http://search.yahoo.com/searchmonkey/media/":"media",
"http://purl.org/dc/qualifiers/1.0/":"dcq",
"http://purl.org/ontomedia/core/expression#":"ome",
"http://www.w3.org/2002/xforms/":"xf",
"http://qudt.org/schema/qudt/":"qudt",
"http://purl.org/cld/terms/":"cld",
"http://www.wiwiss.fu-berlin.de/suhl/bizer/D2RQ/0.1#":"d2rq",
"http://www.ontologydesignpatterns.org/cp/owl/informationrealization.owl#":"ir",
"http://purl.org/net/biblio#":"biblio",
"http://purl.org/stuff/rev#":"rev",
"http://purl.org/reco#":"reco",
"http://purl.oclc.org/NET/sism/0.1/":"sism",
"http://www.ordnancesurvey.co.uk/ontology/AdministrativeGeography/v2.0/AdministrativeGeography.rdf#":"osag",
"http://ontologi.es/days#":"days",
"http://ontology.cybershare.utep.edu/dbowl/relational-to-ontology-mapping-primitive.owl#":"dbowl",
"http://purl.org/NET/biol/botany#":"botany",
"http://purl.org/ontology/af/":"af",
"http://commontag.org/ns#":"ctag",
"http://www.w3.org/2007/rif#":"rif",
"http://schemas.talis.com/2005/dir/schema#":"dir",
"http://okkam.org/terms#":"ok",
"http://www.w3.org/2006/timezone#":"tzont",
"http://www.ontologydesignpatterns.org/cp/owl/componency.owl#":"cmp",
"http://www.openrdf.org/config/repository/sail#":"sr",
"http://www.w3.org/2000/10/swap/math#":"math",
"http://purl.org/procurement/public-contracts#":"pc",
"http://webns.net/mvcb/":"admin",
"http://ontologies.smile.deri.ie/2009/02/27/memo#":"memo",
"http://ontologi.es/giving#":"giving",
"http://purl.org/linked-data/sdmx#":"sdmx",
"http://purl.org/ontology/myspace#":"myspace",
"http://ltsc.ieee.org/rdf/lomv1p0/vocabulary#":"lomvoc",
"http://sw.deri.org/2005/08/conf/cfp.owl#":"cfp",
"http://www.w3.org/2007/uwa/context/deliverycontext.owl#":"dcn",
"http://ns.adobe.com/xap/1.0/":"xmp",
"http://purl.org/linkingyou/":"lyou",
"http://purl.org/swan/1.2/qualifiers/":"swanq",
"http://d2rq.org/terms/jdbc/":"jdbc",
"http://www.w3.org/2006/time#":"time",
"http://www.ontotext.com/trree/owlim#":"owlim",
"http://open-multinet.info/ontology/omn#":"omn",
"http://purl.org/swan/1.2/discourse-elements/":"swande",
"http://purl.org/dc/dcam/":"dcam",
"http://persistence.uni-leipzig.org/nlp2rdf/ontologies/nif-core#":"nif",
"http://www.w3.org/2008/05/skos-xl#":"skosxl",
"http://www.w3.org/2000/10/swap/pim/contact#":"con",
"http://sw.opencyc.org/concept/":"cyc",
"http://www.w3.org/ns/adms#":"adms",
"http://www.w3.org/ns/oa#":"oa",
"http://publications.europa.eu/ontology/cdm#":"cdm",
"http://vocab.getty.edu/ontology#":"gvp",
"http://www.openlinksw.com/schemas/virtrdf#":"openlinks",
"http://www.w3.org/ns/shacl#":"sh",
"http://purl.org/linked-data/sdmx/2009/dimension#":"sdmxdim",
"http://dbpedia.org/":"db",
"http://teste.com/teste/":"type",
"http://iflastandards.info/ns/isbd/elements/":"isbd",
"http://opendata.caceres.es/def/ontomunicipio#":"om",
"http://www.eat.rl.ac.uk/#":"eat",
"http://ns.adobe.com/photoshop/1.0/":"photoshop",
"http://lemon-model.net/lemon#":"lemon",
"http://vocab.getty.edu/aat/":"aat",
"http://schemas.opengis.net/wfs/":"wfs",
"http://vocab.deri.ie/rooms#":"room",
"http://www.wikidata.org/prop/direct/":"wdt",
"http://vocab.getty.edu/tgn/":"tgn",
"http://www.w3.org/2003/12/exif/ns#":"exif",
"http://purl.org/spar/fabio/":"fabio",
"http://vocab.getty.edu/ulan/":"ulan",
"http://umbel.org/umbel/ac/":"ac",
"https://test4.example.com/":"test",
"http://www.openarchives.org/ore/terms/":"ore",
"http://www.w3.org/2001/XMLSchema-instance#":"xsi",
"http://vivoweb.org/ontology/core#":"core",
"http://www.w3.org/ns/auth/cert#":"cert",
"http://prismstandard.org/namespaces/basic/2.0/":"prism",
"http://purl.org/linked-data/sdmx/2009/attribute#":"sdmxa",
"http://www.w3.org/2005/11/its/rdf#":"itsrdf",
"http://prefix.cc/nsogi:":"nsogi",
"http://www.w3.org/2011/content#":"cnt",
"http://fise.iks-project.eu/ontology/":"fise",
"http://www.opengis.net/ont/sf#":"sf",
"http://www.ontologydesignpatterns.org/ont/dul/DUL.owl#":"dul",
"http://purl.org/lobid/lv#":"lv",
"http://purl.org/vocommons/voaf#":"voaf",
"http://www.morelab.deusto.es/ontologies/swrcfe#":"swrcfe",
"http://www.europeana.eu/schemas/edm/":"edm",
"http://www.w3.org/2003/11/swrl#":"swrl",
"http://www.example.org/":"eg",
"http://d-nb.info/standards/elementset/gnd#":"gndo",
"http://vocab.gtfs.org/terms#":"gtfs",
"http://dbpedia.org/resource/Category:":"dbc",
"http://purl.org/wf4ever/ro#":"ro",
"http://www.w3.org/ns/ssn/":"ssn",
"http://www.semanticdesktop.org/ontologies/2007/03/22/nfo#":"nfo",
"http://www.w3.org/XML/1998/namespace/":"xml",
"http://www.w3.org/2003/11/swrlb#":"swrlb",
"http://data.linkedmdb.org/resource/movie/":"movie",
"http://musicontology.com/":"music",
"http://www.openlinksw.com/schemas/bif#":"bif",
"http://maco.com/":"leak",
"http://purl.obolibrary.org/obo/GO_":"go",
"http://vocabularies.wikipathways.org/":"wp",
"http://purl.org/hpi/patchr#":"pat",
"http://www.ontologyrepository.com/CommonCoreOntologies/":"cco",
"https://linkeddata.cultureelerfgoed.nl/def/ceo#":"ceo",
"https://namso-gen.com/":"ping",
"http://purl.org/olia/penn.owl#":"penn",
"http://dbkwik.webdatacommons.org/":"dbkwik",
"http://id.loc.gov/":"loc",
"http://vocab.deri.ie/am#":"am",
"http://spinrdf.org/sp#":"sp",
"http://ns.inria.fr/sparql-template/":"st",
"http://www.w3.org/ns/ldp#":"ldp",
"http://dblp.uni-trier.de/rdf/schema-2015-01-26#":"dblp",
"http://www.lexinfo.net/ontology/3.0/lexinfo#":"lexinfo",
"http://www.loc.gov/mods/v3#":"mods",
"http://www.semanticdesktop.org/ontologies/2007/03/22/nmo#":"nmo",
"https://w3id.org/security#":"sec",
"http://www.bigdata.com/rdf#":"bd",
"http://purl.obolibrary.org/obo/CHEBI_":"chebi",
"http://www.semanticdesktop.org/ontologies/2007/08/15/nao#":"nao",
"http://purl.org/commerce/product#":"product",
"http://www.example.org/rdf#":"example",
"http://schemas.microsoft.com/imm/":"imm",
"http://rdfs.org/sioc/services#":"siocserv",
"http://geo.linkeddata.es/ontology/":"geoes",
"http://purl.uniprot.org/core/":"up",
"http://www.w3.org/ns/sparql#":"sparql",
"http://d-nb.info/gnd/":"gnd",
"http://rdfs.org/sioc/types#":"sioct",
"http://spi-fm.uca.es/neologism/cerif#":"cerif",
"http://purl.org/ontology/rec/core#":"rec",
"http://www.w3.org/2000/10/swap/list#":"list",
"http://www.w3.org/2009/pointers#":"ptr",
"http://www.rkbexplorer.com/ontologies/coref#":"coref",
"http://www.w3.org/2001/sw/DataAccess/tests/test-manifest#":"mf",
"http://www.kanzaki.com/ns/whois#":"whois",
"http://purl.org/NET/scovo#":"scovo",
"http://purl.org/linked-data/api/vocab#":"api",
"http://www.w3.org/2007/uwa/context/java.owl#":"java",
"http://publications.europa.eu/ontology/euvoc#":"euvoc",
"http://spinrdf.org/spin#":"spin",
"http://purl.org/NET/acc#":"acc",
"http://purl.org/olia/olia.owl#":"olia",
"http://t.me/sirextt/247:":"sirext",
"http://en.wikipedia.org/wiki/":"wiki",
"http://www.w3.org/2000/10/swap/pim/doc#":"doc",
"http://www.w3.org/ns/pim/space#":"space",
"https://cube.link/":"cube",
"http://purl.org/obo/owl/MS#":"ms",
"https://w3id.org/opm#":"opm",
"https://krr.triply.cc/krr/sameas-meta/def/":"meta",
"http://inference-web.org/2.0/pml-justification.owl#":"pmlj",
"http://purl.org/linguistics/gold/":"gold",
"http://www.opengis.net/def/function/geosparql/":"geof",
"http://kaiko.getalp.org/dbnary#":"dbnary",
"https://es.scribd.com/doc/79794476/05-Ejercicios-Resueltos-Caja-Negra-y-Recapitulacion/":"xlink",
"http://www.ontologydesignpatterns.org/cp/owl/timeinterval.owl#":"ti",
"http://rhizomik.net/ontologies/copyrightonto.owl#":"cro",
"http://linkedgeodata.org/triplify/":"lgd",
"http://bing.com/schema/media/":"bing",
"https://rdfsharp.codeplex.com/":"rdfsharp",
"http://www.ontotext.com/proton/protonext#":"pext",
"http://iotschema.org/":"iot",
"http://www.w3id.org/simulation/ontology/":"sim",
"http://rdf.histograph.io/":"hg",
"http://www.semanticdesktop.org/ontologies/2007/03/22/nco#":"nco",
"http://www.biopax.org/release/biopax-level3.owl#":"bp",
"http://www.w3.org/ns/auth/rsa#":"rsa",
"http://purl.obolibrary.org/obo/PO_":"po",
"http://www.aktors.org/ontology/support#":"akts",
"http://www.ontologydesignpatterns.org/ont/framenet/abox/lu/":"lu",
"http://deductions.sf.net/ontology/knowledge_base.owl#":"kb",
"http://www.georss.org/georss/":"georss",
"http://www.w3.org/ns/auth/acl#":"acl",
"http://ns.inria.fr/nicetag/2010/09/09/voc#":"nt",
"http://reference.data.gov.uk/def/central-government/":"cgov",
"http://purl.org/spar/cito/":"cito",
"http://purl.org/ontology/video#":"video",
"http://www.w3.org/2003/01/geo/wgs84_pos#":"wgs",
"https://ontologies.semanticarts.com/o/gistCore#":"gist",
"http://langegger.at/xlwrap/vocab#":"xl",
"http://www.w3.org/ns/sosa/":"sosa",
"https://w3id.org/seas/":"seas",
"http://example.org/name#":"name",
"https://en.wikipedia.org/wiki/":"wikipedia",
"http://dbpedia.org/owl/":"dbpediaowl",
"http://purl.org/ontology/prv/core#":"pr",
"http://www.w3.org/ns/lemon/ontolex#":"ontolex",
"http://data.ordnancesurvey.co.uk/id/postcodeunit/":"postcode",
"http://www.w3.org/2007/uwa/context/web.owl#":"web",
"http://openean.kaufkauf.net/id/":"ean",
"http://purl.org/pav/":"pav",
"http://purl.org/olia/stanford.owl#":"stanford",
"https://w3id.org/role/":"role",
"http://www.rkbexplorer.com/ontologies/acm#":"acm",
"http://eulersharp.sourceforge.net/2003/03swap/log-rules#":"eu",
"https://bag2.basisregistraties.overheid.nl/bag/def/":"bag",
"http://www.example.org/terms/":"exterms",
"http://www.w3.org/2007/ont/httph#":"httph",
"http://info.deepcarbon.net/schema#":"dco",
"https://w3id.org/payswarm#":"ps",
"http://xmlns.com/wordnet/1.6/":"wn",
"http://www.gutenberg.org/2009/pgterms/":"pgterms",
"http://purl.org/net/provenance/ns#":"prv",
"http://purl.org/iso25964/skos-thes#":"iso",
"http://standaarden.overheid.nl/owms/":"overheid",
"https://saref.etsi.org/core/":"saref",
"http://dati.gov.it/onto/dcatapit#":"dcatapit",
"http://purl.org/innovation/ns#":"inno",
"http://www.w3.org/ns/formats/":"formats",
"http://purl.org/ontology/wo/":"wo",
"http://www.w3.org/ns/time/gregorian/":"greg",
"http://data.ordnancesurvey.co.uk/ontology/admingeo/":"admingeo",
"http://www.w3.org/ns/lemon/lime#":"lime",
"http://purl.org/ontology/service#":"service",
"http://uptheasset.org/ontology#":"ass",
"http://collection.britishmuseum.org/id/ontology/":"bmo",
"http://www.w3.org/2007/05/powder-s#":"wdrs",
"http://dati.camera.it/ocd/":"ocd",
"http://www.w3.org/2005/Atom/":"atom",
"http://www4.wiwiss.fu-berlin.de/sider/resource/sider/":"sider",
"http://topbraid.org/sparqlmotionfunctions#":"smf",
"http://www.openlinksw.com/virtrdf-data-formats#":"rdfdf",
"http://www.w3.org/2006/03/wn/wn20/schema/":"wn20schema",
"http://www.loc.gov/premis/rdf/v3/":"premis",
"http://purl.obolibrary.org/obo/IAO_":"iao",
"http://purl.org/NET/biol/zoology#":"zoology",
"http://schemas.ogf.org/nml/2013/05/base#":"ndl",
"http://www.metadata.net/harmony/ABCSchemaV5Commented.rdf#":"abc",
"http://www.daml.org/2001/03/daml+oil#":"daml",
"http://linkedmultimedia.org/sparql-mm/ns/2.0.0/function#":"mm",
"http://rdf-vocabulary.ddialliance.org/xkos#":"xkos",
"http://edamontology.org/":"edam",
"https://w3id.org/won/core#":"won",
"http://www.ontologydesignpatterns.org/schemas/cpannotationschema.owl#":"cpa",
"http://purl.org/foodontology#":"food",
"http://www.w3.org/ns/hydra/core#":"hydra",
"http://linkedevents.org/ontology/":"lode",
"http://www.ontologydesignpatterns.org/ont/web/irw.owl#":"irw",
"http://w3id.org/dt#":"dt",
"http://semanticweb.org/id/":"swid",
"http://pictogram.tokyo/vocabulary#":"hp",
"http://www.semanticweb.org/ontologies/cheminf.owl#":"cheminf",
"http://rdfs.org/scot/ns#":"scot",
"http://spinrdf.org/spl#":"spl",
"http://www.bl.uk/schemas/bibliographic/blterms#":"blt",
"http://purl.org/twc/health/vocab/aggregate/":"agg",
"http://www.rkbexplorer.com/ontologies/resist#":"resist",
"http://purl.org/net/vocab/2004/03/label#":"label",
"http://purl.org/vocab/riro/sdl#":"sdl",
"http://purl.org/ontomedia/ext/common/trait#":"omt",
"http://ns.ontowiki.net/SysOnt/Site/":"site",
"http://purl.org/ontomedia/ext/common/profession#":"omp",
"http://biohackathon.org/resource/faldo#":"faldo",
"http://www.openrdf.org/config/sail/federation#":"fed",
"http://www.semanticdesktop.org/ontologies/2008/05/20/tmo#":"tmo",
"http://datos.gob.es/def/sector-publico/organizacion#":"orges",
"http://tipsy.googlecode.com/svn/trunk/vocab/pmt#":"pmt",
"http://data.ign.fr/def/ignf#":"ignf",
"http://lod.xdams.org/reload/oad/":"oad",
"http://catalogus-professorum.org/cpm/2/":"cpm",
"https://w3id.org/sml/def#":"sml",
"http://www.w3.org/ns/regorg#":"rov",
"http://rdaregistry.info/Elements/u/":"rdau",
"http://www.ebusiness-unibw.org/ontologies/eclass/5.1.4/#":"eco",
"http://www.w3.org/2007/rif-builtin-action#":"act",
"http://schemas.talis.com/2005/user/schema#":"user",
"http://lod.taxonconcept.org/ses/":"ses",
"http://cordis.europa.eu/projects/":"cordis",
"http://wordnet-rdf.princeton.edu/ontology#":"wordnet",
"http://blogs.yandex.ru/schema/foaf/":"ya",
"http://www.daml.org/2001/10/html/airport-ont#":"airport",
"http://rdf.ecs.soton.ac.uk/ontology/ecs#":"ecs",
"http://www.w3.org/2007/ont/link#":"link",
"http://philosurfical.open.ac.uk/ontology/philosurfical.owl#":"phil",
"http://iptc.org/std/rNews/2011-10-07#":"rnews",
"http://www.lehigh.edu/~zhp2/2004/0401/univ-bench.owl#":"ub",
"http://purl.org/stuff/project/":"prj",
"http://purl.org/library/":"library",
"http://purl.uniprot.org/taxonomy/":"taxon",
"http://purl.org/media/audio#":"audio",
"http://datos.localidata.com/def/City#":"city",
"http://bblfish.net/work/atom-owl/2006-06-06/#":"awol",
"http://a9.com/-/spec/opensearch/1.1/":"opensearch",
"http://bio2rdf.org/core#":"biocore",
"http://ns.inria.fr/ludo/v1#":"ludo",
"http://www.ontologydesignpatterns.org/ont/framenet/abox/fe/":"fe",
"http://www.w3.org/2004/09/fresnel#":"fresnel",
"http://purl.org/ns/meteo#":"meteo",
"http://purl.org/rss/1.0/modules/taxonomy/":"taxo",
"http://www.ontologydesignpatterns.org/ont/framenet/abox/frame/":"frame",
"http://www.ontologydesignpatterns.org/cp/owl/situation.owl#":"sit",
"http://rightsstatements.org/vocab/":"rs",
"http://ns.nature.com/terms/":"npg",
"http://www.w3.org/2004/03/trix/swp-2/":"swp",
"http://data.linkedmdb.org/":"linkedmdb",
"http://purl.org/ontology/sport/":"sport",
"http://www.openrdf.org/schema/sesame#":"sesame",
"http://vocab.org/waiver/terms/":"wv",
"http://www.w3.org/2007/uwa/context/network.owl#":"net",
"http://chem.deri.ie/granatum/":"granatum",
"http://purl.org/ASN/schema/core/":"asn",
"http://www.w3.org/2000/10/swap/os#":"os",
"http://www.ebi.ac.uk/efo/":"efo",
"http://purl.org/twc/ontologies/cmo.owl#":"cmo",
"http://buzzword.org.uk/rdf/xhtml-elements#":"xhe",
"https://w3id.org/biolink/vocab/":"bl",
"http://purl.org/uco/ns#":"uco",
"http://eulersharp.sourceforge.net/2003/03swap/organism#":"organism",
"http://spinrdf.org/arg#":"arg",
"http://rdf.freebase.com/ns/location/geocode/":"fbgeo",
"http://bio2rdf.org/":"bio2rdf",
"http://purl.org/twc/vocab/conversion/":"conv",
"http://purl.org/vra/":"vra",
"http://ltsc.ieee.org/rdf/lomv1p0/lom#":"lom",
"https://www.iana.org/assignments/media-types/":"mime",
"http://rdf.ontology2.com/vocab#":"vocab",
"http://umbel.org/umbel/rc/":"umbelrc",
"http://jena.hpl.hp.com/2008/tdb#":"tdb",
"http://purl.org/acco/ns#":"acco",
"http://worldbank.270a.info/dataset/":"worldbank",
"http://ontologi.es/rail/vocab#":"rail",
"http://rdf-vocabulary.ddialliance.org/discovery#":"disco",
"http://datos.bne.es/resource/":"bne",
"https://w3id.org/cdt/":"cdt",
"http://linkedgeodata.org/ontology/":"lgdo",
"http://ramonantonio.net/doac/0.1/#":"doac",
"http://www.openrdf.org/config/repository#":"rep",
"http://purl.org/ontology/pbo/core#":"pbo",
"http://purl.org/ontology/ao/core#":"ao",
"http://purl.org/net/rdf-money/":"money",
"http://lod.taxonconcept.org/ontology/txn.owl#":"txn",
"http://purl.org/net/compass#":"compass",
"http://opencoinage.org/rdf/":"oc",
"http://purl.org/NET/lx#":"lx",
"http://rs.tdwg.org/dwc/terms/":"dwc",
"http://purl.org/ontomedia/core/space#":"spc",
"http://umbel.org/umbel#":"umbel",
"http://protege.stanford.edu/system#":"protege",
"http://purl.org/ontomedia/ext/common/being#":"omb",
"http://www.w3.org/2000/10/swap/crypto#":"crypto",
"http://purl.org/ontology/last-fm/":"lfm",
"http://data.linkedct.org/resource/linkedct/":"ct",
"http://telegraphis.net/ontology/measurement/code#":"code",
"http://purl.org/twc/ontology/frir.owl#":"frir",
"http://www.openrdf.org/config/sail/custom#":"custom",
"http://www.semanticdesktop.org/ontologies/2007/08/15/nrl#":"nrl",
"http://www.w3.org/2007/05/powder#":"powder",
"http://imi.go.jp/ns/core/rdf#":"ic",
"http://rdvocab.info/RDARelationshipsWEMI/":"rdrel",
"http://ontologi.es/lang/core#":"lang",
"http://www.affymetrix.com/community/publications/affymetrix/tmsplice#":"affy",
"http://purl.org/ontomedia/core/media#":"omm",
"http://purl.org/ontology/sco#":"sco",
"http://www.openrdf.org/rdf/2009/object#":"obj",
"http://buzzword.org.uk/rdf/atomix#":"atomix",
"http://purl.org/net/nknouf/ns/bibtex#":"bibtex",
"http://www.rdfabout.com/rdf/schema/usfec/":"fec",
"http://www.ontologydesignpatterns.org/cpont/ire.owl#":"ire",
"http://maven.apache.org/POM/4.0.0#":"pom",
"http://reference.data.gov.uk/def/payment#":"pay",
"http://purl.org/muto/core#":"muto",
"http://www.bbc.co.uk/ontologies/news/":"bbc",
"http://purl.org/NET/decimalised#":"ddc",
"http://purl.org/archival/vocab/arch#":"arch",
"http://purl.org/coo/ns#":"coo",
"http://purl.org/ontology/is/quality/":"isq",
"http://purl.org/net/hdlipcores/ontology/soc#":"soc",
"http://www.opengis.net/ont/gml#":"gml",
"http://www.w3.org/ns/person#":"person",
"http://jicamaro.info/mp#":"mp",
"http://purl.org/NET/yoda#":"yoda",
"http://purl.org/NET/biol/ns#":"biol",
"http://www.w3.org/2004/06/rei#":"rei",
"http://web-semantics.org/ns/mysql/":"mysql",
"http://purl.org/ontology/mo/mit#":"mit",
"http://purl.org/twc/vocab/vsr#":"vsr",
"http://rdaregistry.info/Elements/c/":"rdac",
"http://rdf.muninn-project.org/ontologies/appearances#":"aos",
"http://www.w3.org/ns/locn#":"locn",
"http://vocab.deri.ie/ppo#":"ppo",
"http://purl.org/spar/deo/":"deo",
"http://plugin.org.uk/swh-plugins/":"swh",
"http://inference-web.org/2.0/pml-relation.owl#":"pmlr",
"http://reference.data.gov.uk/def/intervals/":"interval",
"http://data.europa.eu/eli/ontology#":"eli",
"http://www.w3.org/2006/gen/ont#":"gso",
"http://purl.org/vocab/riro/gpt#":"gpt",
"http://geovocab.org/geometry#":"ngeo",
"https://data.elsevier.com/research/schema/rv/":"rv",
"http://persistence.uni-leipzig.org/nlp2rdf/ontologies/rlog#":"rlog",
"http://s.zemanta.com/ns#":"zem",
"http://www.w3.org/2007/uwa/context/hardware.owl#":"hard",
"http://www.rdfabout.com/rdf/schema/usgovt/":"usgov",
"http://zeitkunst.org/bibtex/0.1/bibtex.owl#":"bib",
"http://courseware.rkbexplorer.com/ontologies/courseware#":"courseware",
"https://w3id.org/oac#":"oac",
"http://www.w3.org/ns/ui#":"ui",
"http://www.semanticdesktop.org/ontologies/2007/05/10/nexif#":"nexif",
"http://www.aifb.kit.edu/id/":"aifb",
"http://purl.org/weso/cpv/":"cpv",
"http://purl.org/ontology/is/core#":"is",
"http://www.lotico.com/meetup/":"meetup",
"http://purl.org/provone#":"provone",
"http://purl.org/xro/ns#":"xro",
"http://purl.org/vso/ns#":"vso",
"http://climb.dataincubator.org/vocabs/climb/":"climb",
"http://purl.org/vocommons/bridge#":"bridge",
"http://viaf.org/viaf/":"viaf",
"http://www.w3.org/ns/odrl/2/":"odrl",
"http://www.w3.org/2005/07/aaa#":"states",
"http://opacplus.bsb-muenchen.de/title/":"bsb",
"http://sw.cyc.com/CycAnnotations_v1#":"cycann",
"http://ogp.me/ns/article#":"article",
"https://w3id.org/cdc#":"cdc",
"http://www.cogsci.princeton.edu/~wn/schema/":"wnschema",
"http://semanticweb.cs.vu.nl/2009/11/sem/":"sem",
"http://purl.org/weso/ontology/computex#":"cex",
"http://dd.eionet.europa.eu/vocabulary/common/nuts/":"nuts",
"http://data.totl.net/game/":"game",
"http://ontologies.smile.deri.ie/pdo#":"pdo",
"http://www.junkwork.net/xml/DocumentList#":"doclist",
"https://w3id.org/okn/o/sdm#":"sdm",
"http://proton.semanticweb.org/protonsys#":"psys",
"http://kwijibo.talis.com/":"kwijibo",
"http://linkedscience.org/teach/ns#":"teach",
"http://purl.org/ontology/dso#":"dso",
"http://purl.org/ontomedia/ext/common/bestiary#":"omc",
"http://buzzword.org.uk/rdf/xen#":"xen",
"http://www.rdfabout.com/rdf/schema/vote/":"vote",
"http://www.geneontology.org/formats/oboInOwl#":"oboinowl",
"http://purl.org/NET/uri#":"uri",
"http://www.linkedmodel.org/schema/vaem#":"vaem",
"http://www.proteinontology.info/po.owl#":"prot",
"http://purl.obolibrary.org/obo/agro.owl#":"agro",
"http://purl.org/ontology/wi/core#":"wi",
"http://www.ebu.ch/metadata/ontologies/ebucore/ebucore#":"ebucore",
"http://purl.org/swan/1.2/swan-commons/":"swanco",
"http://purl.oclc.org/NET/muo/muo#":"muo",
"http://ecoinformatics.org/oboe/oboe.1.0/oboe-core.owl#":"oboe",
"http://www.w3.org/2007/uwa/context/software.owl#":"soft",
"http://www.w3.org/2008/turtle#":"ttl",
"http://www.rdfabout.com/rdf/schema/politico/":"politico",
"http://launchpad.net/rdf/launchpad#":"lp",
"http://voag.linkedmodel.org/schema/voag#":"voag",
"http://conserv.deri.ie/ontology#":"conserv",
"http://purl.org/ontology/chord/":"chord",
"http://www.rdaregistry.info/":"rda",
"http://demiblog.org/vocab/oauth#":"oauth",
"http://rdaregistry.info/Elements/p/object/":"rdapo",
"http://vocab.data.gov/def/fea#":"fea",
"http://purl.org/court/def/2009/coin#":"coin",
"http://rdf.myexperiment.org/ontologies/base/":"meb",
"http://linkedrecipes.org/schema/":"recipe",
"http://vitro.mannlib.cornell.edu/ns/vitro/public#":"vitro",
"http://www.eclap.eu/schema/eclap/":"eclap",
"http://www.w3.org/2000/10/swap/string#":"string",
"http://www4.wiwiss.fu-berlin.de/bizer/bsbm/v01/vocabulary/":"bsbm",
"http://www.dotnetrdf.org/leviathan#":"lfn",
"http://purl.org/vocab/lifecycle/schema#":"lifecycle",
"http://www.w3.org/1999/XSL/Format#":"fo",
"http://www.ashutosh.com/test/":"card",
"http://open-services.net/ns/core#":"oslc",
"http://www.isocat.org/ns/dcr.rdf#":"dcr",
"http://mu.semte.ch/vocabularies/ext/":"ext",
"http://www4.wiwiss.fu-berlin.de/dailymed/resource/dailymed/":"dailymed",
"http://schemas.talis.com/2005/service/schema#":"sv",
"http://eulersharp.sourceforge.net/2003/03swap/countries#":"countries",
"http://purl.org/ontology/is/inst/":"isi",
"http://www.mygrid.org.uk/ontology#":"mygrid",
"http://www.w3.org/1999/xhtml/":"html",
"http://vocab.deri.ie/cogs#":"cogs",
"http://spatial.ucd.ie/lod/osn/":"osn",
"http://www.w3.org/ns/csvw#":"csvw",
"http://poshrdf.org/ns/posh/":"posh",
"http://www.openrdf.org/config/sail#":"sail",
"http://www.w3.org/2007/uwa/context/push.owl#":"push",
"http://moat-project.org/ns#":"moat",
"http://purl.org/NET/puc#":"puc",
"http://www.dotnetrdf.org/configuration#":"dnr",
"http://geovocab.org/spatial#":"spatial",
"http://purl.org/b2bo#":"b2bo",
"http://buzzword.org.uk/rdf/h5#":"h5",
"http://bio2rdf.org/pubmed_vocabulary:":"pubmed",
"http://vocab.deri.ie/br#":"br",
"http://online-presence.net/opo/ns#":"opo",
"http://foodable.co/ns/":"fd",
"https://w3id.org/function/ontology#":"fno",
"http://purl.org/NET/dady#":"dady",
"http://www.lotico.com/resource/":"lotico",
"http://lexvo.org/ontology#":"lvont",
"https://w3id.org/example#":"exo",
"http://www.w3.org/2001/04/xmlenc#":"enc",
"http://lukasblaho.sk/football_league_schema#":"fls",
"http://uriplay.org/spec/ontology/#":"play",
"http://data.totl.net/tarot/card/":"tarot",
"http://worldbank.270a.info/property/":"wbp",
"http://purl.org/net/ldap/":"ldap",
"https://w3id.org/ops#":"ops",
"http://rdaregistry.info/Elements/a/":"rdaa",
"http://www.w3.org/2003/g/data-view#":"grddl",
"http://tobyinkster.co.uk/#":"toby",
"http://dsnotify.org/vocab/eventset/0.1/":"evset",
"http://rdf.geospecies.org/ont/geospecies#":"geospecies",
"http://www.agfa.com/w3c/2009/hospital#":"hospital",
"http://eulersharp.sourceforge.net/2003/03swap/care#":"care",
"https://id.parliament.uk/schema/":"parl",
"http://weblab-project.org/core/model/property/processing/":"wlp",
"http://purl.org/wai#":"wai",
"http://purl.obolibrary.org/obo/NCBITaxon_":"ncbitaxon",
"http://www.gsi.dit.upm.es/ontologies/marl/ns#":"marl",
"http://purl.org/twc/vocab/between-the-edges/":"bte",
"http://purl.org/lex#":"lex",
"http://purl.org/weso/uni/uni.html#":"uni",
"http://eventography.org/sede/0.1/":"sede",
"http://filmontology.org/ontology/1.0/":"foo",
"http://eulergui.sourceforge.net/contacts.owl.n3#":"ec",
"http://resex.rkbexplorer.com/ontologies/resex#":"resex",
"http://www.lingvoj.org/ontology#":"lingvoj",
"http://purl.org/swan/1.2/discourse-relationships/":"swandr",
"http://sindice.com/hlisting/0.1/":"hlisting",
"http://www.ontologydesignpatterns.org/cp/owl/informationobjectsandrepresentationlanguages.owl#":"irrl",
"http://users.utcluj.ro/~raluca/ontology/Ontology1279614123500.owl#":"lark1",
"http://data.odw.tw/":"data",
"http://models.okkam.org/ENS-core-vocabulary#":"okkam",
"https://w3id.org/cmd#":"cmd",
"http://www.w3.org/2002/01/p3prdfv1#":"p3p",
"http://purl.org/ontology/is/types/":"ist",
"http://purl.org/uF/hCard/terms/":"hcterms",
"http://callimachusproject.org/rdf/2009/framework#":"calli",
"http://rdfs.org/sioc/actions#":"sioca",
"http://archdesc.info/archEvent#":"archdesc",
"http://www.w3.org/2000/10/annotation-ns#":"ann",
"http://ns.aksw.org/spatialHierarchy/":"shv",
"http://www.nexml.org/2009/":"nex",
"http://www.w3.org/2002/12/cal/icaltzd#":"icaltzd",
"http://www.semanticweb.org/ontologies/2010/6/Ontology1279614123500.owl#":"remus",
"http://www.thomsonreuters.com/":"tr",
"https://ref.gs1.org/voc/":"gs1",
"http://users.utcluj.ro/~raluca/rdf_ontologies_ralu/ralu_modified_ontology_pizzas2_0#":"anca",
"http://ns.inria.fr/probabilistic-shacl/":"psh",
"http://openlinksw.com/schemas/oat/":"oat",
"http://purl.org/ontology/places#":"places",
"http://ontologi.es/like#":"like",
"http://www.inria.fr/acacia/corese#":"cos",
"http://www.openk.org/wscaim.owl#":"wsc",
"http://ontologi.es/profiling#":"profiling",
"http://www.w3.org/ns/rdfa#":"rdfa",
"http://escience.rpi.edu/ontology/semanteco/2/0/pollution.owl#":"pol",
"https://www.w3.org/2019/wot/td#":"td",
"http://purl.org/twc/ontologies/identity.owl#":"identity",
"http://www.wsmo.org/ns/wsmo-lite#":"wl",
"http://securitytoolbox.appspot.com/securityAlgorithms#":"algo",
"http://www.ontologyportal.org/WordNet.owl#":"opwn",
"http://www.infosys.com/":"infosys",
"http://www.w3.org/2006/http#":"httpvoc",
"http://dati.senato.it/osr/":"osr",
"http://data.ign.fr/def/geometrie#":"geom",
"http://cbasewrap.ontologycentral.com/vocab#":"cb",
"http://semantic-mediawiki.org/swivt/1.0#":"swivt",
"http://purl.org/ecos#":"ecos",
"http://www.w3.org/ns/sawsdl#":"sawsdl",
"https://ns.eccenca.com/":"ecc",
"http://ns.poundhill.com/phss/1.0/":"phss",
"http://purl.org/vocab/riro/ddl#":"ddl",
"http://wiss-ki.eu/":"wisski",
"http://www.agfa.com/w3c/2009/drugTherapy#":"drug",
"http://purl.org/vocab/psychometric-profile/":"psych",
"http://def.esd.org.uk/":"esd",
"http://purl.org/NET/schema-org-csv#":"scsv",
"http://purl.org/net/opmv/types/gridworks#":"gridworks",
"http://ogp.me/ns#":"ogp",
"http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/direccion-postal#":"esdir",
"http://purl.org/tio/ns#":"tio",
"http://ns.inria.fr/prissma/v1#":"prissma",
"http://www.w3.org/2004/02/image-regions#":"imreg",
"http://eulersharp.sourceforge.net/2003/03swap/units#":"units",
"http://purl.org/twc/vocab/datafaqs#":"datafaqs",
"http://purl.org/twc/vocab/cross-topix#":"xt",
"http://telegraphis.net/ontology/geography/geography#":"geographis",
"https://triplydb.com/Triply/tp/def/":"tp",
"http://www.irit.fr/recherches/MELODI/ontologies/SAN#":"san",
"http://www.openmobilealliance.org/tech/profiles/UAPROF/ccppschema-20021212#":"prf",
"http://purl.org/net/wf-motifs#":"wfm",
"http://purl.org/fab/ns#":"fab",
"http://users.ugent.be/~bjdmeest/function/grel.ttl#":"grel",
"http://dbpedia.org/resource/Template:":"dbt",
"http://pleiades.stoa.org/places/":"ple",
"http://purl.org/dita/ns#":"dita",
"http://purl.org/net/vocab/2004/07/visit#":"visit",
"http://multimedialab.elis.ugent.be/organon/ontologies/ninsuna#":"nsa",
"http://www.w3.org/TR/2003/PR-owl-guide-20031209/food#":"fowl",
"http://ontologies.ezweb.morfeo-project.org/ezcontext/ns#":"ezcontext",
"http://purl.org/procurement/public-contracts-czech#":"pccz",
"http://qudt.org/schema/quantity#":"quantity",
"http://prismstandard.org/namespaces/pam/2.0/":"pam",
"http://purl.org/adms/sw/":"admssw",
"http://redfoot.net/2005/session#":"session",
"http://knoesis.wright.edu/provenir/provenir.owl#":"provenir",
"http://id.nlm.nih.gov/mesh/":"mesh",
"http://ecb.270a.info/class/1.0/":"ecb",
"http://www.w3.org/2007/uwa/context/common.owl#":"common",
"http://bio2rdf.org/hgnc:":"hgnc",
"http://www.ifomis.org/bfo/1.1/span#":"span",
"http://inference-web.org/2.0/pml-provenance.owl#":"pmlp",
"http://eulersharp.sourceforge.net/2003/03swap/agent#":"agent",
"http://provenanceweb.org/ns/pml#":"pml",
"http://web-semantics.org/ns/opensocial#":"osoc",
"https://w3id.org/valueflows/ont/vf#":"vf",
"http://www.semanlink.net/2001/00/semanlink-schema#":"sl",
"http://eprints.org/ontology/":"eprints",
"http://purl.org/NET/rulz#":"rulz",
"http://trust.utep.edu/visko/ontology/visko-operator-v3.owl#":"visko",
"http://www.smileyontology.com/ns#":"smiley",
"http://advene.org/ns/cinelab/":"cl",
"http://worldbank.270a.info/classification/":"wbc",
"http://vocab.sindice.net/":"sindice",
"http://ontologydesignpatterns.org/":"odp",
"http://purl.org/voc/ling/":"ling",
"http://hxl.humanitarianresponse.info/ns/#":"hxl",
"http://ns.ontowiki.net/SysOnt/":"sysont",
"http://purl.org/nxp/schema/v1/":"nxp",
"http://purl.org/makolab/caont/":"cao",
"http://www.w3.org/1999/XSL/Transform#":"xsl",
"http://www.w3.org/2007/ont/unit#":"un",
"http://www.semanticdesktop.org/ontologies/2007/11/01/pimo#":"pimo",
"http://www.w3.org/2003/05/soap-envelope/":"soap",
"http://stanbol.apache.org/ontology/disambiguation/disambiguation#":"dis",
"http://www.nanopub.org/nschema#":"np",
"http://data.press.net/ontology/stuff/":"pns",
"http://www.padinthecity.com/":"ipad",
"http://purl.org/metainfo/terms/dsp#":"dsp",
"http://ontologies.ezweb.morfeo-project.org/eztag/ns#":"eztag",
"http://data.ign.fr/ontologies/geofla#":"geofla",
"http://skipforward.net/skipforward/resource/":"skip",
"https://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf#":"json",
"http://data.eurecom.fr/ontology/reve#":"reve",
"http://purl.org/spar/doco/":"doco",
"http://vocab.deri.ie/c4n#":"c4n",
"http://eulersharp.sourceforge.net/2003/03swap/human#":"human",
"http://topbraid.org/sparqlmotion#":"sm",
"http://aims.fao.org/aos/geopolitical.owl#":"geop",
"http://purl.org/ontology/ecpo#":"ecpo",
"http://www.ontotext.com/owlim/lucene#":"luc",
"http://purl.org/carfo#":"carfo",
"http://annotation.semanticweb.org/2004/iswc#":"iswc",
"http://purl.org/net/ns/wordmap#":"wordmap",
"http://geni-orca.renci.org/owl/topology.owl#":"orca",
"http://omv.ontoware.org/2005/05/ontology#":"omv",
"http://purl.org/net/provenance/types#":"prvtypes",
"http://www.w3.org/2007/rif-builtin-function#":"func",
"http://zbw.eu/namespaces/zbw-extensions/":"zbwext",
"https://data.omgeving.vlaanderen.be/ns/dossier#":"dossier",
"http://purl.org/swan/1.2/citations/":"swanci",
"http://purl.org/rdo/ns#":"rdo",
"http://data.ordnancesurvey.co.uk/ontology/50kGazetteer/":"gazetteer",
"http://data.nytimes.com/elements/":"nytimes",
"http://purl.org/ibis#":"ibis",
"http://myprefix.org/":"myprefix",
"http://purl.org/ontology/olo/core#":"olo",
"http://ontologies.hypios.com/out#":"out",
"http://ns.inria.fr/ast/sql#":"sql",
"http://linkedwidgets.org/statisticalwidget/ontology/":"sw",
"http://spinrdf.org/spif#":"spif",
"http://purl.org/net/soron/":"sor",
"http://krauthammerlab.med.yale.edu/ontologies/gelo#":"gelo",
"http://purl.org/ontology/storyline/":"nsl",
"http://data.ordnancesurvey.co.uk/id/":"osgb",
"http://diplomski.nelakolundzija.org/LTontology.rdf#":"lt",
"http://www.semanticdesktop.org/ontologies/2007/04/02/ncal#":"ncal",
"http://linkedspending.aksw.org/instance/":"ls",
"http://www.w3.org/2000/10/swap/set#":"set",
"http://www.music-encoding.org/ns/mei/":"mei",
"http://jena.hpl.hp.com/Eyeball#":"eye",
"http://www.kanzaki.com/ns/dpd#":"dpd",
"http://umbel.org/umbel/ne/":"ne",
"http://swat.cse.lehigh.edu/resources/onto/aigp.owl#":"aigp",
"http://purl.org/swan/1.2/pav/":"swanpav",
"http://vocab.linkeddata.es/urbanismo-infraestructuras/territorio#":"muni",
"http://west.uni-koblenz.de/ontologies/2010/07/dgfoaf.owl#":"dgfoaf",
"http://purl.org/NET/cidoc-crm/core#":"cidoccrm",
"http://stanbol.apache.org/ontology/enhancer/enhancer#":"enhancer",
"http://www.oegov.org/core/owl/gc#":"gc",
"http://www.w3.org/ns/dqv#":"dqv",
"http://madskills.com/public/xml/rss/module/trackback/":"trackback",
"http://data.press.net/ontology/event/":"pne",
"http://eulersharp.sourceforge.net/2006/02swap/fcm#":"fcm",
"http://www.linkedmodel.org/1.0/schema/decl#":"decl",
"http://www.linkedmodel.org/schema/dtype#":"dtype",
"http://rdf.alchemyapi.com/rdf/v1/s/aapi-schema#":"aapi",
"http://vocab.ouls.ox.ac.uk/projectfunding#":"arpfo",
"http://wikiba.se/ontology#":"wikibase",
"http://prefix.cc/":"prefix",
"http://lsdis.cs.uga.edu/projects/semdis/opus#":"opus",
"http://eulersharp.sourceforge.net/2003/03swap/prolog#":"prolog",
"http://data.rkd.nl/def#":"rkd",
"http://eulersharp.sourceforge.net/2003/03swap/fl-rules#":"fl",
"http://life.deri.ie/schema/":"life",
"http://rdvocab.info/Elements/":"rdagr1",
"http://www.rdfabout.com/rdf/usgov/geo/us/":"govtrackus",
"http://rdflivenews.aksw.org/ontology/":"rlno",
"http://d-nb.info/standards/elementset/agrelon#":"agrelon",
"http://ns.aksw.org/Evolution/":"evopat",
"http://www.w3.org/1999/xhtml/vocab/":"xhtmlvocab",
"http://obofoundry.org/ro/ro.owl#":"oboro",
"http://inference-web.org/2.0/pml-trust.owl#":"pmlt",
"http://purl.org/net/po#":"plo",
"http://semantictweet.com/":"semtweet",
"http://eulersharp.sourceforge.net/2003/03swap/organization#":"organiz",
"http://commons.psi.enakting.org/def/":"commons",
"http://stats.data-gov.ie/property/":"sdgp",
"http://ifcowl.openbimstandards.org/IFC2X3_Final#":"ifc",
"http://vocab.resc.info/communication#":"comm",
"https://w3id.org/steel/ProcessOntology/":"steel",
"http://eulersharp.sourceforge.net/2003/03swap/bioSKOSSchemes#":"bioskos",
"http://rdaregistry.info/Elements/m/":"rdam",
"http://www.w3.org/2005/01/wai-rdf/GUIRoleTaxonomy#":"wairole",
"http://hello.com/":"dummy",
"http://www.w3.org/ns/rad#":"rad",
"http://www.xbrl.org/2003/instance#":"xbrli",
"http://abs.270a.info/dataset/":"abs",
"http://www4.wiwiss.fu-berlin.de/bizer/r2r/":"r2r",
"http://openlinksw.com/schema/attribution#":"opl",
"http://www.semanticdesktop.org/ontologies/2007/05/10/nid3#":"nid3",
"http://www.w3.org/2005/01/wf/flow#":"wf",
"http://data.linkedct.org/vocab/":"linkedct",
"http://vocab.deri.ie/sad#":"sad",
"http://prov4j.org/w3p/":"w3p",
"http://www.w3.org/TR/owl-time#":"owltime",
"http://purl.org/derecho#":"derecho",
"http://webtlab.it.uc3m.es/2010/10/WebAppsOntology#":"wao",
"http://buzzword.org.uk/rdf/vcardx#":"vcardx",
"http://buzzword.org.uk/rdf/personal-link-types#":"plink",
"http://www.researchspace.org/ontology/":"rso",
"http://purl.org/req/":"req",
"https://www.w3.org/ns/iana/link-relations/relation#":"ianarel",
"http://webtlab.it.uc3m.es/":"webtlab",
"http://code-research.eu/ontology/visual-analytics#":"va",
"http://purl.org/tripfs/2010/02#":"tripfs",
"http://jena.hpl.hp.com/ARQ/property#":"pf",
"http://www.w3.org/2011/http-methods#":"httpm",
"http://models.okkam.org/ENS-core-vocabulary.owl#":"ens",
"http://www.mit.jyu.fi/ai/TRUST_Ontologies/QA.owl#":"qa",
"http://www.agfa.com/w3c/2009/hemogram#":"hemogram",
"http://vocab.org/transit/terms/":"transit",
"http://akonadi-project.org/ontologies/aneo#":"aneo",
"http://www.mygrid.org.uk/mygrid-moby-service#":"moby",
"http://www.w3.org/ns/openannotation/extensions/":"oax",
"http://w3id.org/rml/":"rml",
"http://freedesktop.org/standards/xesam/1.0/core#":"xesam",
"http://ontology.ip.rm.cnr.it/ontologies/DOLCE-Lite#":"dl",
"http://data.nytimes.com/":"nyt",
"http://www.essepuntato.it/2012/04/tvc/":"tvc",
"http://data-gov.tw.rpi.edu/2009/data-gov-twc.rdf#":"dgtwc",
"http://foaf.qdos.com/lastfm/schema/":"qdoslf",
"http://www.freeclass.eu/freeclass_v1#":"fc",
"http://www.ebi.ac.uk/gxa/":"gxa",
"http://purl.org/NET/lindt#":"lindt",
"http://rdaregistry.info/Elements/w/":"rdaw",
"http://aers.data2semantics.org/vocab/":"aersv",
"http://www.agetec.org/":"agetec",
"http://data.press.net/ontology/asset/":"pna",
"http://km.aifb.kit.edu/projects/numbers/number#":"no",
"http://data.kasabi.com/dataset/italy/schema/":"italy",
"http://ns.rww.io/wapp#":"wapp",
"http://data.ordnancesurvey.co.uk/ontology/postcode/":"ospost",
"http://purl.org/theatre#":"theatre",
"http://oecd.270a.info/dataset/":"oecd",
"http://www.purl.org/ontologia/eseduc#":"eseduc",
"http://ontojob.at/":"oj",
"http://purl.org/vocab/frbr/extended#":"frbre",
"http://www.daml.org/services/owl-s/1.2/Service.owl#":"owls",
"http://sw-portal.deri.org/ontologies/swportal#":"swpo",
"http://kwantu.net/kw/":"kw",
"http://rinfo.lagrummet.se/ns/2008/11/rinfo/publ#":"rpubl",
"http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/transporte#":"estrn",
"http://sws.geonames.org/":"geodata",
"http://purl.org/tcga/core#":"tcga",
"http://www.w3.org/ns/solid/terms#":"solid",
"http://purl.org/weso/ontologies/scowt#":"scowt",
"http://salt.semanticauthoring.org/ontologies/sro#":"sro",
"http://aims.fao.org/aos/common/":"aims",
"http://purl.org/momayo/mmo/":"mmo",
"http://vocab.sindice.com/xfn#":"xfnv",
"http://www.metalex.eu/schema/1.0#":"metalex",
"http://open-services.net/ns/crtv#":"crtv",
"http://proton.semanticweb.org/2005/04/protons#":"protons",
"http://purl.org/wf4ever/wfdesc#":"wfdesc",
"http://ns.inria.fr/emoca#":"emotion",
"http://www.ebi.ac.uk/swo/":"swo",
"http://www.w3.org/ns/shex#":"shex",
"http://purl.org/twc/health/vocab/":"health",
"http://dev.w3.org/cvsweb/2000/quacken/vocab#":"quak",
"http://rdf.ebi.ac.uk/resource/atlas/":"atlas",
"http://sweet.jpl.nasa.gov/2.0/mathOperation.owl#":"oper",
"http://ns.nature.com/datasets/":"npgd",
"http://purl.org/tripfs/2010/06#":"tripfs2",
"http://eulersharp.sourceforge.net/2003/03swap/languages#":"languages",
"http://purl.oclc.org/NET/ldr/ns#":"ldr",
"http://purl.org/net/opmv/ns#":"opmv",
"http://purl.org/ontology/iron#":"iron",
"http://opengraph.org/schema/":"ogorg",
"http://www.ics.forth.gr/isl/CRMdig/":"crmdig",
"http://rdf.data-vocabulary.org/":"rich",
"http://purl.obolibrary.org/obo/NCIT_":"ncit",
"http://ns.inria.fr/webmarks#":"wm",
"http://openlinksw.com/services/facets/1.0/":"fct",
"http://purl.org/obo/owl/SO#":"oboso",
"https://api.bloomberg.com/eap/catalogs/bbg/fields/":"bdd",
"http://www.w3.org/2001/sw/hcls/ns/transmed/":"transmed",
"http://purl.oclc.org/NET/ssnx/qu/qu#":"qu",
"http://purl.org/swan/1.2/agents/":"swanag",
"http://www.opmw.org/ontology/":"opmw",
"http://purl.org/spar/c4o/":"c4o",
"http://aims.fao.org/aos/jita/":"jita",
"http://purl.org/ontology/gbv/":"gbv",
"http://purl.org/imbi/ru-meta.owl#":"ru",
"http://purl.org/eis/vocab/daq#":"daq",
"http://eulersharp.sourceforge.net/2003/03swap/humanBody#":"humanbody",
"http://oanda2rdf.appspot.com/xch/":"xch",
"http://mmisw.org/ont/cf/parameter/":"cf",
"http://www.w3.org/2000/10/swap/reason#":"re",
"http://purl.org/net/dssn/":"dssn",
"http://www.tvblob.com/ratings/#":"rating",
"http://govwild.org/0.6/GWOntology.rdf/":"govwild",
"http://rdf.insee.fr/def/geo#":"igeo",
"http://eulersharp.sourceforge.net/2003/03swap/environment#":"environ",
"http://www.openlinksw.com/ski_resorts/schema#":"skiresort",
"http://contextus.net/ontology/ontomedia/misc/date#":"date",
"http://vocab.deri.ie/fingal#":"fingal",
"http://www.onto-med.de/ontologies/gfo.owl#":"gfo",
"http://www.agfa.com/w3c/2009/clinicalEvaluation#":"clineva",
"http://kdo.render-project.eu/kdo#":"kdo",
"http://openskos.org/xmlns#":"openskos",
"http://purl.obolibrary.org/obo/bco.owl#":"bco",
"http://spatial.ucd.ie/2012/08/osmsemnet/":"osmsemnet",
"http://purl.org/telix#":"telix",
"http://eulersharp.sourceforge.net/2003/03swap/event#":"events",
"http://purl.org/twc/vocab/goef#":"goef",
"http://www.w3.org/2001/xml-events/":"ev",
"http://purl.org/microformat/hmedia/":"ufmedia",
"http://purl.org/commerce/creditcard#":"ccard",
"http://purl.org/net/wf4ever/ro#":"wro",
"http://bioinformatics.ua.pt/coeus/":"coeus",
"http://www.w3.org/TR/SVG/":"sgv",
"http://kg.artsdata.ca/resource/":"adr",
"http://richard.cyganiak.de/":"kontakt",
"http://data.totl.net/occult/":"occult",
"http://xmlns.notu.be/aair#":"aair",
"http://simile.mit.edu/2003/10/ontologies/artstor#":"artstor",
"http://manesht.ir/":"mohammad",
"http://purl.org/ipo/core#":"ipo",
"http://purl.org/cld/cdtype/":"cdtype",
"http://purl.org/ctic/empleo/oferta#":"emp",
"https://decision-ontology.googlecode.com/svn/trunk/decision.owl#":"decision",
"http://example.com/clinic#":"clinic",
"https://rankrage.de/":"rankrage",
"http://semanticdiet.com/schema/usda/nndsr/":"nndsr",
"http://purl.org/configurationontology#":"cold",
"http://www.lotico.com/ontology/":"loticoowl",
"http://w3id.org/ost/ns#":"ost",
"http://fr.dbpedia.org/property/":"property",
"http://sites.wiwiss.fu-berlin.de/suhl/bizer/d2r-server/config.rdf#":"d2r",
"http://sites.google.com/site/xgmaitc/":"marshall",
"http://purl.org/signature#":"sig",
"http://pubannotation.org/ontology/tao.owl#":"tao",
"http://dayta.me/resource#":"dayta",
"http://purl.org/ontology/cco/mappings#":"ccom",
"http://www.daml.org/2001/09/countries/iso-3166-ont#":"coun",
"http://purl.org/spar/pso/":"pso",
"http://escience.rpi.edu/ontology/sesf/s2s/4/0/":"s2s",
"http://ns.nature.com/graphs/":"npgg",
"http://www.w3.org/2002/01/bookmark#":"bookmark",
"http://purl.org/restdesc/http-template#":"tmpl",
"http://purl.org/ontology/daia/Service/":"daiaserv",
"http://www.provbook.org/ns/#":"bk",
"http://www.wordnet.dk/owl/instance/2009/03/instances/":"dannet",
"http://purl.org/cerif/frapo/":"frapo",
"http://scubadive.networld.to/dive.rdf#":"dive",
"http://www.isibang.ac.in/ns/mod#":"mod",
"http://linkedspending.aksw.org/ontology/":"lso",
"http://datos.bcn.cl/ontologies/bcn-congress#":"bcncon",
"http://purl.org/ontology/paia#":"paia",
"http://prismstandard.org/namespaces/basic/2.1/":"prism21",
"http://iflastandards.info/ns/fr/frad/":"frad",
"http://sig.uw.edu/fma#":"fma",
"http://www.ordnancesurvey.co.uk/ontology/Datatypes.owl#":"osukdt",
"http://purl.org/amicroformat/arecipe/":"arecipe",
"http://tackbp.org/2013/ontology#":"kbp",
"http://www.e-lico.eu/data/kupkb/":"kupkb",
"http://www.tei-c.org/ns/1.0/":"tei",
"http://harrisons.cc/":"harrisons",
"http://ocean-data.org/schema/":"odo",
"http://securitytoolbox.appspot.com/stac#":"stac",
"http://lod2.eu/schema/":"lod2",
"http://zbw.eu/beta/p20/vocab/":"p20",
"http://www.co-ode.org/ontologies/pizza/pizza.owl#":"pizza",
"https://w3id.org/cc#":"curr",
"http://penis.to/#":"penis",
"http://protege.stanford.edu/plugins/owl/dc/protege-dc.owl#":"protegedc",
"http://labels4all.info/ns/":"l4a",
"http://www.w3.org/2008/05/skos#":"skos08",
"http://purl.org/csm/1.0#":"csm",
"http://eulersharp.sourceforge.net/2003/03swap/genomeAbnormality#":"genab",
"https://w3id.org/verb/":"verb",
"http://deductions.github.io/doas.owl.ttl#":"doas",
"http://hadatac.org/ont/hasco/":"hasco",
"http://w3id.org/art/terms/1.0/":"art",
"http://nl.ijs.si/ME/owl/":"mte",
"http://www4.wiwiss.fu-berlin.de/diseasome/resource/diseasome/":"diseasome",
"http://labs.mondeca.com/vocab/endpointStatus#":"ends",
"http://purl.org/wf4ever/wfprov#":"wfprov",
"http://atomowl.org/ontologies/atomrdf#":"atomrdf",
"http://ns.bergnet.org/tac/0.1/triple-access-control#":"tac",
"http://data.scientology.org/ns/":"sci",
"http://nlp2rdf.lod2.eu/schema/string/":"str",
"http://purl.org/net/VideoGameOntology#":"vgo",
"http://purl.org/eis/vocab/scor#":"scor",
"http://purl.org/oslo/ns/localgov#":"oslo",
"http://purl.org/net/lio#":"lio",
"http://rdvocab.info/termList/RDACarrierType/":"rdacarrier",
"http://lod.gesis.org/lodpilot/ALLBUS/vocab.rdf#":"gesis",
"http://bio2rdf.org/ns/ns/ns/pubchem#":"b2rpubchem",
"http://hospee.org/ontologies/dpc/":"dpc",
"http://www.openlinksw.com/ontology/licenses#":"opllic",
"http://swat.cse.lehigh.edu/onto/univ-bench.owl#":"sbench",
"http://owlrep.eu01.aws.af.cm/fridge#":"of",
"http://purl.org/vocab/cpsv#":"cpsv",
"https://project-open-data.cio.gov/v1.1/schema/#":"pod",
"http://purl.org/ctic/dcat#":"ds",
"http://poderopedia.com/vocab/":"poder",
"http://www.owl-ontologies.com/generations.owl#":"genea",
"http://semweb.mmlab.be/ns/linkedconnections#":"lc",
"http://ns.aksw.org/scms/annotations/":"scms",
"http://def.seegrid.csiro.au/isotc211/iso19156/2011/sampling#":"sam",
"http://ns.cerise-project.nl/energy/def/cim-smartgrid#":"smg",
"http://open-multinet.info/ontology/omn-lifecycle#":"omnlife",
"http://vocab.ox.ac.uk/camelot#":"camelot",
"http://purl.org/net/biordfmicroarray/ns#":"biordf",
"http://dbpedialite.org/things/":"dpl",
"http://vocab.deri.ie/nocal#":"nocal",
"http://www.openlinksw.com/ontology/faq#":"faq",
"http://purl.org/vocommons/bv#":"bv",
"http://purl.org/net/cartCoord#":"cart",
"http://dati.cdec.it/lod/shoah/":"shoah",
"http://rdf.jpostdb.org/ontology/jpost.owl#":"jpo",
"https://www.w3.org/2006/vcard/ns#":"latitude",
"http://musicbrainz.org/ns/mmd-1.0#":"mmd",
"http://resource.geosciml.org/ontology/timescale/thors#":"thors",
"http://ddbj.nig.ac.jp/ontologies/sequence#":"insdc",
"http://purl.org/datanode/ns/":"dn",
"http://ontology.it/itsmo/v1#":"itsmo",
"http://purl.org/hpi/guo#":"guo",
"http://www.ontotext.com/proton/protontop#":"ptop",
"http://data.lirmm.fr/ontologies/osp#":"osp",
"http://rhizomik.net/ontologies/2005/03/Mpeg7-2001.owl#":"mpeg7",
"http://purl.org/ontology/prv/rules#":"prvr",
"http://www.openlinksw.com/campsites/schema#":"campsite",
"http://www.agfa.com/w3c/2009/healthCare#":"healthcare",
"http://www.agfa.com/w3c/2009/clinicalProcedure#":"clinproc",
"http://purl.org/ontology/ssso#":"ssso",
"http://paul.staroch.name/thesis/SmartHomeWeather.owl#":"shw",
"http://nlp2rdf.lod2.eu/schema/sso/":"sso",
"http://dbpedia.org/ontology/Stream/":"stream",
"http://rdf.ebi.ac.uk/terms/chembl#":"chembl",
"http://purl.org/twc/vocab/centrifuge#":"centrifuge",
"http://observedchange.com/tisc/ns#":"tisc",
"http://salt.semanticauthoring.org/ontologies/sao#":"sao",
"http://dbpedia.org/class/yago/":"dbyago",
"http://datashapes.org/dash#":"dash",
"http://orion.tw.rpi.edu/~xgmatwc/refe/":"refe",
"http://www.ontologydesignpatterns.org/ont/dul/IOLite.owl#":"iol",
"http://www.w3.org/2006/time-entry#":"te",
"http://purl.org/net/hifm/data#":"hifm",
"http://securitytoolbox.appspot.com/securityMain#":"security",
"http://ns.ottr.xyz/templates#":"ottr",
"http://gov.genealogy.net/ontology.owl#":"gov",
"http://vocab.inf.ed.ac.uk/library/holdings#":"lh",
"http://xmlns.com/aerols/0.1/":"aerols",
"http://www.w3.org/ns/dpv#":"dpv",
"http://escience.rpi.edu/ontology/vsto/2/0/vsto.owl#":"vsto",
"http://www.w3.org/2004/ql#":"ql",
"http://def.seegrid.csiro.au/ontology/om/om-lite#":"oml",
"http://semantic.eurobau.com/eurobau-utility.owl#":"ebu",
"http://erlangen-crm.org/current/":"ecrm",
"http://purl.org/ontology/cosmo#":"cosmo",
"http://contextus.net/ontology/ontomedia/ext/common/trait#":"trait",
"http://xlime-project.org/vocab/":"xlime",
"http://reference.data.gov.uk/technical-registry/":"pronom",
"http://www.aifb.kit.edu/project/ld-retriever/qrl#":"qrl",
"http://rdaregistry.info/termList/RDAMediaType/":"rdamt",
"http://tw.rpi.edu/schema/":"tw",
"http://purl.org/twc/vocab/aapi-schema#":"twaapi",
"http://docs.oasis-open.org/ns/xri/xrd-1.0#":"xrd",
"http://vocab.lenka.no/geo-deling#":"ngeoi",
"http://www.ordnancesurvey.co.uk/ontology/SpatialRelations/v0.2/SpatialRelations.owl#":"onssprel",
"http://yovisto.com/":"yo",
"http://rdf.ebi.ac.uk/vocabulary/zooma/":"zoomaterms",
"http://bg.dbpedia.org/property/":"bgdbp",
"http://opendepot.org/reference/linked/1.0/":"oarj",
"http://openknowledgegraph.org/ontology/":"okg",
"http://fao.270a.info/dataset/":"fao",
"http://purl.org/NET/cpan-uri/terms#":"cpant",
"http://www.w3.org/2001/02pd/rec54.rdf#":"rec54",
"http://opendata.cz/infrastructure/odcleanstore/":"odcs",
"http://def.seegrid.csiro.au/isotc211/iso19115/2003/lineage#":"li",
"http://purl.org/olia/mte/multext-east.owl#":"mtecore",
"http://data.linkedct.org/vocab/resource/":"lctr",
"http://rdf.geospecies.org/methods/observationMethod#":"obsm",
"http://rdaregistry.info/termList/frequency/":"rdafr",
"http://saxon.sf.net/":"saxon",
"http://purl.org/germplasm/terms#":"germplasm",
"http://rdf.insee.fr/def/demo#":"idemo",
"http://www.agfa.com/w3c/2009/malignantNeoplasm#":"malignneo",
"http://schema.omg.org/spec/CTS2/1.0/":"cts2",
"http://www.w3.org/TR/2003/PR-owl-guide-20031209/wine#":"vin",
"http://linkedscience.org/lsc/ns#":"lsc",
"http://www.w3.org/ns/lemon/vartrans#":"vartrans",
"https://piveau.eu/ns/voc#":"pv",
"http://www.telegraphis.net/ontology/measurement/measurement#":"msr",
"http://eatld.et.tu-dresden.de/rmo#":"rmo",
"http://vocab.deri.ie/raul#":"raul",
"http://datos.bcn.cl/ontologies/bcn-norms#":"bcnnorms",
"http://purl.org/NET/cloudisus#":"cis",
"http://data.ordnancesurvey.co.uk/ontology/geometry/":"osgeom",
"http://www.who.int/vocab/ontology#":"who",
"http://bihap.kb.gov.tr/ontology/":"bihap",
"http://www.openlinksw.com/schemas/cert#":"oplcert",
"http://def.seegrid.csiro.au/isotc211/iso19109/2005/feature#":"gf",
"http://purl.org/twc/vocab/datacarver#":"crv",
"http://def.seegrid.csiro.au/isotc211/iso19108/2002/temporal#":"tm",
"http://schema.theodi.org/odrs#":"odrs",
"http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-data.owl#":"lsmap",
"https://brickschema.org/schema/Brick#":"brick",
"https://data.zendantennes.omgeving.vlaanderen.be/ns/zendantenne#":"antenne",
"http://purl.org/vocab/participation/schema#":"part",
"http://strdf.di.uoa.gr/ontology#":"strdf",
"http://purl.org/spar/scoro/":"scoro",
"http://pokedex.dataincubator.org/pkm/":"pkmn",
"http://www.ics.forth.gr/isl/oae/core#":"oae",
"http://purl.org/NET/ssnext/electricmeters#":"emtr",
"http://data.press.net/ontology/tag/":"pnt",
"http://schema.googleapis.com/":"goog",
"http://purl.org/twc/cabig/model/HINTS2005-1.owl#":"hints2005",
"http://www.mico-project.eu/ns/platform/1.0/schema#":"mico",
"http://richard.cyganiak.de/2007/pubby/config.rdf#":"conf",
"http://rdaregistry.info/termList/FormNoteMus/":"rdafnm",
"http://rdaregistry.info/termList/statIdentification/":"rdasoi",
"http://qudt.org/1.1/schema/qudt#":"qud",
"http://environment.data.gov.au/def/op#":"op",
"http://data.semanticweb.org/conference/ekaw/2012/complete/":"ekaw",
"http://purl.org/swan/2.0/discourse-relationships/":"dr",
"http://semweb.mmlab.be/ns/rml/condition#":"crml",
"http://geovocab.org/":"geovocab",
"http://purl.org/ontology/stories/":"stories",
"http://metadataregistry.org/uri/schema/RDARelationshipsGR2/":"rdarel2",
"http://data.europa.eu/esco/model#":"esco",
"http://ontologi.es/doap-changeset#":"dcs",
"http://linkedmultimedia.org/sparql-mm/ns/1.0.0/function#":"mmf",
"https://www.w3.org/TR/activitystreams-vocabulary/":"activity",
"http://rdfns.org/d2d/":"d2d",
"http://babelnet.org/rdf/":"bn",
"https://id.kb.se/vocab/":"kbv",
"http://ns.inria.fr/l4lod/v2/":"l4lod",
"http://www.lingvoj.org/semio#":"semio",
"http://rdaregistry.info/Elements/e/":"rdae",
"http://data.lirmm.fr/ontologies/oan/":"oan",
"https://bgt.basisregistraties.overheid.nl/bgt/def/":"bgt",
"http://rankrage.de/":"seokoeln",
"http://sparql.cwrc.ca/ontology/cwrc#":"cwrc",
"http://lodlaundromat.org/resource/":"ll",
"http://automotive.eurecom.fr/vsso#":"vsso",
"http://www.w3.org/2001/sw/DataAccess/tests/test-dawg#":"dawgt",
"http://ns.inria.fr/s4ac/v2#":"s4ac",
"https://vg.no/":"namespaces",
"http://data.worldbank.org/":"wb",
"http://wiktionary.dbpedia.org/terms/":"wikterms",
"http://web.resource.org/rss/1.0/modules/syndication/":"rssynd",
"http://name.scigraph.com/ontologies/core/":"sg",
"http://www.ontologydesignpatterns.org/cp/owl/sequence.owl#":"seq",
"http://comicmeta.org/cbo/":"cbo",
"http://bibliograph.net/schemas/":"bgn",
"https://w3id.org/xapi/ontology#":"xapi",
"http://lsq.aksw.org/vocab#":"lsqv",
"http://linkeddata.center/kees/v1#":"kees",
"https://w3id.org/akn/ontology/allot#":"allot",
"http://dbtune.org/musicbrainz/resource/instrument/":"mb",
"http://kwijibo.talis.com/vocabs/puelia#":"puelia",
"http://schema.mobivoc.org/":"mv",
"http://webbox.ecs.soton.ac.uk/ns#":"webbox",
"http://purl.org/ontology/holding#":"holding",
"http://schema.geolink.org/":"gl",
"http://data.press.net/ontology/classification/":"pnc",
"http://auto.schema.org/":"auto",
"http://www.ebsemantics.net/gastro#":"gastro",
"https://triplydb.com/Triply/tg/def/":"tg",
"http://imgpedia.dcc.uchile.cl/resource/":"im",
"http://rdvocab.info/termList/RDAContentType/":"rdacontent",
"http://cookingbigdata.com/linkeddata/ccpricing#":"ccp",
"http://www.w3.org/ns/dx/prof/":"prof",
"http://purl.org/saws/ontology#":"saws",
"http://vocab.ox.ac.uk/projectfunding#":"ox",
"http://eulersharp.sourceforge.net/2003/03swap/quantitiesExtension#":"quantities",
"http://www.agfa.com/w3c/2009/humanDisorder#":"disease",
"http://verticalsearchworks.com/ontology/synset#":"vsws",
"http://rdaregistry.info/termList/trackConfig/":"rdatc",
"http://lod.ac/ns/lodac#":"lodac",
"http://nidm.nidash.org/":"nidm",
"http://teste.com/":"ljkl",
"http://mged.sourceforge.net/ontologies/MGEDOntology.owl#":"mged",
"http://ontologi.es/doap-deps#":"deps",
"http://rdaregistry.info/termList/CollTitle/":"rdacct",
"http://purl.org/finlex/schema/laki/":"finlaw",
"http://www.essepuntato.it/2008/12/pattern#":"pattern",
"http://www.mobile.com/model/":"my",
"http://data.press.net/ontology/identifier/":"pni",
"http://purl.org/omapi/0.2/#":"omapi",
"http://purl.org/net/pingback/":"pingback",
"http://www.opengis.net/def/":"ogc",
"http://purl.org/dqm-vocabulary/v1/dqm#":"dqm",
"http://lod.taxonconcept.org/ontology/sci_people.owl#":"scip",
"http://docs.oasis-open.org/ns/search-ws/xcql#":"xcql",
"http://ndl.go.jp/dcndl/terms/":"dcndl",
"http://def.seegrid.csiro.au/isotc211/iso19107/2003/geometry#":"gm",
"http://spitfire-project.eu/ontology/ns/":"spt",
"http://institutions.publicdata.eu/#":"eui",
"http://data.lirmm.fr/ontologies/laposte#":"laposte",
"http://bio2rdf.org/affymetrix_vocabulary:":"affymetrix",
"http://ontologycentral.com/2010/05/cb/vocab#":"cbase",
"http://data.rvdata.us/":"rvdata",
"http://bg.dbpedia.org/resource/?????????:":"bgcat",
"http://rdvocab.info/termList/RDAMediaType/":"rdamedia",
"http://schema.wolterskluwer.de/":"wkd",
"http://futurios.org/fos/spec/":"fos",
"http://www.w3.org/2004/delta#":"delta",
"http://www.gsi.dit.upm.es/ontologies/onyx/ns#":"onyx",
"http://www.w3.org/People/Berners-Lee/card#":"tblcard",
"http://rdaregistry.info/termList/gender/":"rdagd",
"https://doi.org/":"doi",
"https://www.koerperfettwaage-test.de/":"foam",
"http://jmvanel.free.fr/ontology/software_applications.n3#":"app",
"http://purl.org/rdfstats/stats#":"stats",
"https://w3id.org/fog#":"fog",
"http://opendata.caceres.es/def/ontosemanasanta#":"oss",
"http://origins.link/":"origins",
"http://www.openarchives.org/OAI/2.0/friends/":"friends",
"http://purl.org/captsolo/resume-rdf/0.2/base#":"cvbase",
"https://w3id.org/bot#":"bot",
"http://www.telegraphis.net/ontology/measurement/quantity#":"quty",
"http://observedchange.com/moac/ns#":"moac",
"http://datos.bcn.cl/ontologies/bcn-biographies#":"bcnbio",
"http://rdf.myexperiment.org/ontologies/snarm/":"snarm",
"http://purl.org/telmap/":"telmap",
"http://linkedmultimedia.org/sparql-mm/ns/2.0.0/ontology#":"lmo",
"http://www.employee.com/data#":"employee",
"http://purl.oclc.org/NET/lldr/ns#":"lldr",
"http://purl.org/net/orth#":"orth",
"http://www.isocat.org/datcat/":"isocat",
"http://www.ordnancesurvey.co.uk/ontology/Topography/v0.1/Topography.owl#":"ostop",
"http://vocab.fusepool.info/fam#":"fam",
"http://purl.org/finlex/schema/oikeus/":"fincaselaw",
"http://purl.org/net/evident#":"evident",
"http://www.ft.com/ontology/content/":"ftcontent",
"http://virtual-assembly.org/ontologies/pair#":"pair",
"http://www.daisy.org/z3998/2012/vocab/":"daisy",
"http://purl.org/twc/vocab/opendap#":"od",
"http://data.eurecom.fr/ontology/dvia#":"dvia",
"http://purl.org/spar/biro/":"biro",
"http://www.w3.org/1998/Math/MathML/":"mml",
"http://kmi.open.ac.uk/projects/smartproducts/ontologies/food.owl#":"spfood",
"http://vocab.data.gov/def/drm#":"drm",
"http://purl.oclc.org/NET/mvco.owl#":"mvco",
"http://rdaregistry.info/termList/modeIssue/":"rdami",
"https://mre.zcu.cz/ontology/stroke.owl#":"add",
"http://data.globalchange.gov/gcis.owl#":"gcis",
"http://www.agls.gov.au/agls/terms/":"agls",
"http://www.ics.forth.gr/isl/MarineTLO/v4/marinetlo.owl#":"mtlo",
"http://deductions.github.io/drivers.owl.ttl#":"driver",
"http://data.kasabi.com/dataset/eumida/terms/":"eumida",
"http://wordnet-rdf.princeton.edu/wn31/":"wn31",
"http://jazz.net/ns/lqe/merge/":"merge",
"http://rdf.muninn-project.org/ontologies/military#":"mil",
"http://webofcode.org/wfn/call:":"call",
"http://idi.fundacionctic.org/cruzar/turismo#":"turismo",
"http://vocab.linkeddata.es/datosabiertos/def/turismo/alojamiento#":"esaloj",
"http://purl.org/dao#":"dao",
"http://purl.org/viso/":"viso",
"http://linkedwidgets.org/statisticaldata/ontology/":"lsd",
"http://www.ics.forth.gr/isl/oncm/core#":"onc",
"http://data.semanticweb.org/person/":"swperson",
"http://rdaregistry.info/termList/grooveWidth/":"rdagw",
"https://w3id.org/cwl/salad#":"salad",
"http://www.ontotext.com/proton/protonkm#":"pkm",
"http://nerd.eurecom.fr/ontology#":"nerd",
"http://vocabularies.wikipathways.org/gpml#":"gpml",
"http://intellimind.io/ns/company#":"company",
"http://aers.data2semantics.org/resource/":"aers",
"http://purl.org/twc/vocab/vsr/graffle#":"graffle",
"https://w3id.org/pmd/co/":"pmd",
"http://promsns.org/def/agr#":"agr",
"http://snomed.info/id/":"sct",
"http://www.w3.org/ns/radion#":"radion",
"http://www.ontologydesignpatterns.org/cp/owl/participation.owl#":"odpart",
"http://gawd.atlantides.org/terms/":"gawd",
"http://purl.org/twc/vocab/pvcs#":"pvcs",
"http://rdaregistry.info/termList/RDABaseMaterial/":"rdabm",
"http://www.openlinksw.com/ontology/webservices#":"webservice",
"http://id.loc.gov/vocabulary/iso639-1/":"language",
"http://lodlaundromat.org/ontology/":"llo",
"http://project-haystack.org/hto#":"hto",
"http://elite.polito.it/ontologies/dogont.owl#":"dogont",
"https://opendata.unex.es/def/ontouniversidad#":"ou",
"http://clarin.eu/fcs/resource#":"fcs",
"http://semweb.mmlab.be/ns/oh#":"oh",
"http://trust.utep.edu/visko/ontology/visko-view-v3.owl#":"viskov",
"http://www.linklion.org/lden/":"lden",
"http://vocab.deri.ie/odapp#":"odapp",
"http://www.ipaw.info/ns/picaso#":"pic",
"http://ns.nature.com/extensions/":"npgx",
"https://w3id.org/def/saref4envi#":"s4envi",
"http://dd.eionet.europa.eu/vocabulary/eurostat/":"eurostat",
"https://purl.org/geojson/vocab#":"geojson",
"http://rdfdata.eionet.europa.eu/ramon/ontology/":"ramon",
"https://w3id.org/idsa/core/":"ids",
"http://purl.org/linkedpolitics/vocabulary/eu/plenary/":"lpeu",
"http://www.enakting.org/provenance/voidp/":"voidp",
"http://purl.org/provenance/w3p/w3po#":"w3po",
"http://purl.org/olap#":"qb4o",
"http://www.ontologydesignpatterns.org/ont/lmm/LMM_L1.owl#":"lmm1",
"http://www.icane.es/opendata/vocab#":"icane",
"http://ucuenca.edu.ec/ontology#":"uc",
"http://purl.org/ctic/infraestructuras/organizacion#":"ctorg",
"http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/equipamiento#":"esequip",
"http://www.ontologydesignpatterns.org/ont/dul/ontopic.owl#":"ontopic",
"https://www.w3.org/ns/ldt#":"ldt",
"http://infra.clarin.eu/cmd/":"cmdm",
"http://webofcode.org/wfn/":"wfn",
"http://linkedwidgets.org/ontologies/":"lw",
"http://rdf-vocabulary.ddialliance.org/phdd#":"phdd",
"http://purl.org/net/step#":"step",
"http://spi-fm.uca.es/spdef/models/deployment/swpm/1.0#":"swpm",
"http://openlad.org/vocab#":"olad",
"http://www.semanticweb.org/syllabus/data/":"sylld",
"http://def.seegrid.csiro.au/ontology/om/sam-lite#":"samfl",
"http://deductions.github.io/biological-collections.owl.ttl#":"bioc",
"https://w3id.org/dot#":"dot",
"http://www.telegraphis.net/ontology/geography/geography#":"geos",
"http://imgpedia.dcc.uchile.cl/ontology#":"imo",
"http://purl.org/lex/cz#":"lexcz",
"http://www.example.org/lexicon#":"lexicon",
"http://dublincore.org/dcx/":"dcx",
"http://dx.deepcarbon.net/":"dcoid",
"http://www.s3db.org/core#":"s3db",
"http://www.w3.org/year/":"year",
"http://mlode.nlp2rdf.org/quranvocab#":"qvoc",
"http://rdaregistry.info/termList/RDACarrierType/":"rdact",
"http://purl.org/spar/datacite/":"dcite",
"http://identifiers.org/pmc/":"pmc",
"http://doc.metalex.eu/bwb/ontology/":"bwb",
"http://explain.z3950.org/dtd/2.0/":"zr",
"http://ontologydesignpatterns.org/ont/wikipedia/d0.owl#":"d0",
"http://purl.org/emmedi/hico/":"hico",
"http://purl.org/wf4ever/roevo#":"roevo",
"http://data.posccaesar.org/rdl/":"rdl",
"http://tldp.org/HOWTO/XML-RPC-HOWTO/xmlrpc-howto-java.html#":"fire",
"http://spi-fm.uca.es/spdef/models/genericTools/wikim/1.0#":"wikim",
"https://lod.milieuinfo.be/ns/waarde#":"waarde",
"http://bg.dbpedia.org/resource/":"bgdbr",
"http://dbtropes.org/ont/":"dbtont",
"http://databugger.aksw.org/ns/core#":"tddo",
"https://w3id.org/dio#":"dio",
"http://purl.org/ctdl/terms/":"ceterms",
"http://parliament.uk/ontologies/person-name/":"ppn",
"http://vocab-ld.org/vocab/static-ld#":"static",
"https://vocab.eccenca.com/geniustex/":"gt",
"http://www.bbc.co.uk/ontologies/provenance/":"bbcprov",
"http://www.ontologydesignpatterns.org/ont/lmm/LMM_L2.owl#":"lmm2",
"http://rdf.muninn-project.org/ontologies/jp1/":"jp1",
"http://agrinepaldata.com/":"agrd",
"http://purl.org/gc/":"gnvc",
"http://groundedannotationframework.org/":"gaf",
"http://www.language-archives.org/OLAC/1.0/":"olac",
"http://purl.org/vocabularies/amalgame#":"amalgame",
"http://ontoloji.galaksiya.com/vocab/":"galaksiya",
"http://plantuml.com/ontology#":"puml",
"http://iserve.kmi.open.ac.uk/ns/msm#":"msm",
"https://si-digital-framework.org/SI#":"si",
"http://www.essepuntato.it/2013/10/vagueness/":"vag",
"http://open-multinet.info/ontology/omn-federation#":"omnfed",
"http://purl.oclc.org/POIS/vcblr#":"pois",
"http://eunis.eea.europa.eu/rdf/species-schema.rdf#":"eunis",
"http://rdf.muninn-project.org/ontologies/graves#":"graves",
"https://w3id.org/roar#":"roar",
"http://purl.org/vvo/ns#":"vvo",
"http://ns.taverna.org.uk/2010/scufl2#":"scufl2",
"http://def.seegrid.csiro.au/isotc211/iso19115/2003/dataquality#":"dq",
"http://gadm.geovocab.org/ontology#":"gadm",
"http://data.legilux.public.lu/resource/ontology/jolux#":"jolux",
"http://purl.org/ctic/sector-publico/elecciones#":"elec",
"http://purl.org/wf4ever/wf4ever#":"wf4ever",
"http://kai.uni-kiel.de/":"kai",
"http://rdfunit.aksw.org/ns/core#":"rut",
"http://purl.org/locwd/schema#":"locwd",
"https://raw.githubusercontent.com/airs-linked-data/lov/latest/src/airs_vocabulary.ttl#":"airs",
"http://ldf.fi/void-ext#":"vext",
"https://w3id.org/ldpdl/ns#":"ldl",
"http://schema.geolink.org/view/":"ecglview",
"http://rdaregistry.info/termList/fontSize/":"rdafs",
"http://purl.org/procurement/public-contracts-datatypes#":"pcdt",
"http://spi-fm.uca.es/spdef/models/genericTools/vmm/1.0#":"vmm",
"http://www.openlinksw.com/ontology/products#":"oplprod",
"http://data.lirmm.fr/ontologies/poste#":"poste",
"http://vapour.sourceforge.net/vocab.rdf#":"vapour",
"http://omdoc.org/ontology/":"omdoc",
"http://sw.deri.org/2006/07/location/loc#":"location",
"http://w3id.org/vir#":"vir",
"http://www.w3.org/opengov#":"opengov",
"http://www.ontologydesignpatterns.org/ont/fred/domain.owl#":"fred",
"http://purl.oclc.org/NET/ssnx/meteo/aws#":"aws",
"http://permid.org/ontology/organization/":"pid",
"http://uis.270a.info/dataset/":"uis",
"http://verticalsearchworks.com/ontology/":"vsw",
"http://rdaregistry.info/termList/groovePitch/":"rdagrp",
"http://purl.org/biotop/biotop.owl#":"biotop",
"http://www.w3.org/2000/10/swap/grammar/bnf#":"bnf",
"http://www.movieontology.org/2009/11/09/movieontology.owl#":"moo",
"http://ontology.eil.utoronto.ca/GCI/Foundation/GCI-Foundation.owl#":"gci",
"http://www.w3.org/2006/12/owl2-xml#":"owl2xml",
"http://purl.org/co/":"coll",
"http://sws.ifi.uio.no/vocab/npd#":"npdv",
"http://www.openlinksw.com/ontology/odbc#":"odbc",
"http://rdaregistry.info/termList/typeRec/":"rdatr",
"http://sa.aktivespace.org/ontologies/aktivesa#":"aktivesa",
"http://www.newmedialab.at/fcp/":"fcp",
"http://rdfvizler.dyreriket.xyz/vocabulary/core#":"rvz",
"http://purl.org/net/provenance/integrity#":"prviv",
"http://www.semanticweb.org/ontologies/2008/11/OntologySecurity.owl#":"ontosec",
"http://jena.apache.org/fuseki#":"fuseki",
"http://topbraid.org/teamwork#":"teamwork",
"http://ns.lucid-project.org/revision/":"lcdr",
"http://www.w3.org/2006/03/wn/wn20/":"wn20",
"http://sparql.cwrc.ca/ontologies/genre#":"genre",
"http://rdflivenews.aksw.org/resource/":"rlnr",
"http://led.kmi.open.ac.uk/term/":"led",
"http://www.semanticweb.org/asow/ontologies/2013/9/untitled-ontology-36#":"mocanal",
"http://lod.taxonconcept.org/ontology/p01/Mammalia/index.owl#":"mammal",
"http://lodlaundromat.org/metrics/ontology/":"llm",
"http://purl.org/vocab/reloc/":"crime",
"http://www.ontologydesignpatterns.org/ont/framenet/abox/":"fnabox",
"http://vocab.resc.info/incident#":"incident",
"http://frb.270a.info/dataset/":"frb",
"http://mmoon.org/mmoon/":"mmoon",
"http://rdaregistry.info/Elements/i/":"rdai",
"http://promsns.org/def/proms#":"proms",
"http://cliopatria.swi-prolog.org/schema/cpack#":"cpack",
"http://purl.org/dsnotify/vocab/eventset/":"dsn",
"https://w3id.org/bpo#":"bpo",
"https://vocab.eccenca.com/auth/":"eccauth",
"http://openprovenance.org/model/opmo#":"opmo",
"http://privatealpha.com/ontology/certification/1#":"acrt",
"http://rdf123.umbc.edu/ns/":"rdf123",
"http://shex.io/ns/shex#":"sx",
"http://ns.adobe.com/pdf/1.3/":"pdf",
"http://www.lido-schema.org/":"lido",
"http://rdaregistry.info/termList/RDAColourContent/":"rdacc",
"http://www.google.com/":"beth",
"http://data.ign.fr/def/topo#":"topo",
"http://wwwiti.cs.uni-magdeburg.de/~srahman/":"saif",
"http://purl.org/voc/vrank#":"vrank",
"http://data.openbudgets.eu/ontology/":"obeu",
"http://citydata.wu.ac.at/ns#":"cd",
"http://pkgsrc.co/schema#":"pkgsrc",
"http://www.purl.org/limo-ontology/limo#":"limo",
"https://w3id.org/pfeepsa#":"pfeepsa",
"http://www.geocontext.org/publ/2013/vocab#":"geocontext",
"http://purl.org/spar/pwo/":"pwo",
"http://www.oegov.org/core/owl/cc#":"oecc",
"http://purl.allotrope.org/ontologies/result#":"afr",
"http://iflastandards.info/ns/fr/frbr/frbrer/":"frbrer",
"http://schema.geolink.org/dev/view/":"glview",
"http://volt-name.space/vocab/output#":"output",
"http://purl.org/linked-data/registry#":"reg",
"https://data.vlaanderen.be/ns/logies#":"logies",
"http://www.daml.org/services/owl-s/1.2/generic/Expression.owl#":"owlse",
"https://w3id.org/i40/sto#":"sto",
"http://reegle.info/schema#":"reegle",
"https://w3id.org/cwl/prov#":"cwlprov",
"http://vocab.sindice.net/csv/":"csv",
"http://reference.data.gov.uk/def/organogram/":"odv",
"https://w3id.org/ln#":"ln",
"http://www.niso.org/schemas/ali/1.0/":"ali",
"http://data.lirmm.fr/ontologies/passim#":"passim",
"https://w3id.org/omg#":"omg",
"http://www.kinjal.com/condition:":"condition",
"http://linked.opendata.cz/ontology/ldvm/":"ldvm",
"http://rdaregistry.info/termList/MusNotation/":"rdafmn",
"http://purl.org/resource/pilatesstudio/":"studiop",
"http://edgarwrap.ontologycentral.com/vocab/edgar#":"edgar",
"http://data.archiveshub.ac.uk/def/":"locah",
"http://jena.apache.org/text#":"text",
"http://www.re3data.org/schema/3-0#":"r3d",
"http://rdaregistry.info/termList/rofch/":"rofch",
"https://w3id.org/timebank#":"tb",
"http://registry.info/termList/recMedium/":"rdarm",
"https://vocab.eccenca.com/revision/":"eccrev",
"http://bio2rdf.org/ns/kegg#":"kegg",
"http://lemon-model.net/oils#":"oils",
"http://datos.bcn.cl/ontologies/bcn-geographics#":"bcngeo",
"http://purl.org/LiMo/0.1/":"limoo",
"http://orcid.org/":"orcid",
"http://lawd.info/ontology/":"lawd",
"http://rdaregistry.info/termList/RDAContentType/":"rdaco",
"http://www.ontologydesignpatterns.org/cp/owl/timeindexedsituation.owl#":"tis",
"http://www.openarchives.org/OAI/2.0/":"defns",
"http://www.joshuajeeson.com/":"jjd",
"http://www.iana.org/assignments/relation/":"iana",
"http://purl.org/wf4ever/roterms#":"roterms",
"http://rdvocab.info/roles/":"rdarole",
"http://purl.org/crowd/":"crowd",
"http://rdaregistry.info/termList/RDATerms/":"rdaterm",
"https://w3id.org/cocoon/v1.0#":"cocoon",
"http://def.seegrid.csiro.au/isotc211/iso19103/2005/basic#":"basic",
"http://rdaregistry.info/termList/TacNotation/":"rdaftn",
"http://parliament.uk/ontologies/legislation/":"plg",
"http://iflastandards.info/ns/fr/frsad/":"frsad",
"http://data.ifs.tuwien.ac.at/study/resource/":"tui",
"http://imf.270a.info/dataset/":"imf",
"http://www.neclimateus.org/":"nxs",
"http://voc.odw.tw/":"voc",
"http://purl.org/eem#":"eem",
"http://fedora.info/definitions/v4/webac#":"webac",
"http://www.essepuntato.it/2013/03/cito-functions#":"citof",
"http://resource.geosciml.org/ontology/timescale/gts#":"gts",
"http://www.loc.gov/zing/srw/":"sru",
"http://babelnet.org/2.0/":"babelnet",
"http://schemas.capita-libraries.co.uk/2015/acl/schema#":"caplibacl",
"http://www.ontologydesignpatterns.org/ont/framenet/tbox/":"fntbox",
"http://server.ubiqore.com/ubiq/core#":"ubiq",
"http://dbpedia.org/resource/Lyon/":"lyon",
"https://sireneld.io/vocab/sirene#":"sirene",
"http://purl.allotrope.org/ontologies/material/":"afm",
"http://iflastandards.info/ns/muldicat#":"muldicat",
"http://deductions-software.com/ontologies/forms.owl.ttl#":"form",
"http://www.omg.org/spec/FIGI/GlobalInstrumentIdentifiers/":"figigii",
"http://purl.org/NET/ordf/":"ordf",
"http://www.w3.org/ns/shacl-ui#":"shui",
"http://purl.org/healthcarevocab/v1#":"dicom",
"http://genomequest.com/":"gq",
"http://contsem.unizar.es/def/sector-publico/pproc#":"pproc",
"http://aims.fao.org/aos/agrovoc/":"agrovoc",
"http://deductions.github.io/task-management.owl.ttl#":"task",
"http://www.valuelabs.com/":"customer",
"http://spdx.org/rdf/terms#":"spdx",
"http://www.bbc.co.uk/ontologies/cms/":"bbccms",
"https://w3id.org/eepsa#":"eepsa",
"http://purl.org/legal_form/vocab#":"lofv",
"http://omerxi.com/ontologies/core.owl.ttl#":"oxi",
"http://www.w3.org/2002/07/meeting#":"meeting",
"http://contsem.unizar.es/def/sector-publico/contratacion#":"contsem",
"http://www.ebusiness-unibw.org/ontologies/hva/ontology#":"hva",
"http://purl.org/linked-data/sdmx/2009/code#":"sdmxcode",
"http://hl7.org/fhir/":"fhir",
"http://w3id.org/multidimensional-interface/ontology#":"mdi",
"http://vocab.deri.ie/csp#":"csp",
"http://www.snik.eu/ontology/bb/":"bb",
"http://iec.ch/TC57/2013/CIM-schema-cim16#":"cim",
"http://rdfs.co/bevon/":"bevon",
"http://purl.org/collections/iati/":"iati",
"http://www.openlinksw.com/ontology/ecrm#":"oplecrm",
"https://portal.gdc.cancer.gov/cases/":"gdc",
"http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper-parameters.owl#":"lswpm",
"https://yodata.io/":"yd",
"http://www.coinsweb.nl/cbim-2.0.rdf#":"cbim",
"http://ontology.eil.utoronto.ca/open311#":"open311",
"https://w3id.org/scholarlydata/ontology/conference-ontology.owl#":"conference",
"https://w3id.org/lovcube/ns/relovstats#":"rls",
"http://clirio.kaerle.com/clirio.owl#":"clirio",
"https://data.cssz.cz/ontology/ruian/":"ruian",
"http://escience.rpi.edu/ontology/semanteco/2/0/water.owl#":"water",
"http://bioportal.bioontology.org/ontologies/umls/":"umls",
"http://www.openlinksw.com/schemas/crunchbase#":"oplcb",
"http://mappings.roadmap.org/":"roadmap",
"http://lod.nl.go.kr/ontology/":"nlon",
"http://rdaregistry.info/termList/layout/":"rdalay",
"http://purl.org/net/tsn#":"tsn",
"https://onlinesocialmeasures.wordpress.com/":"owsom",
"http://volt-name.space/ontology/":"volt",
"http://eur-lex.publicdata.eu/ontology/":"eurlex",
"https://w3id.org/pep/":"pep",
"http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-modelling.owl#":"lswmo",
"http://rdfs.org/ns/void-ext#":"voidext",
"http://purl.org/essglobal/vocab/v1.0/":"essglobal",
"http://iserve.kmi.open.ac.uk/ns/hrests#":"hr",
"http://www.w3.org/ns/mls#":"mls",
"http://data.europa.eu/esco/qms#":"qms",
"https://w3id.org/tree#":"tree",
"http://openprovenance.org/ontology#":"oprovo",
"http://www.agfa.com/w3c/2009/infectiousDisorder#":"infection",
"http://myexample.org/county#":"county",
"http://bsym.bloomberg.com/sym/":"bsym",
"http://drakon.su/":"drk",
"http://purl.org/net/vgo#":"videogame",
"http://data.lirmm.fr/ontologies/vdpp#":"vdpp",
"http://peoplesplaces.de/ontology#":"pp",
"https://w3id.org/fr/def/core#":"fr",
"http://awesemantic-geo.link/ontology/":"ago",
"http://rdaregistry.info/termList/RDAReductionRatio/":"rdarr",
"http://mex.aksw.org/mex-algo#":"mexv",
"http://www.univalle.edu.co/ontologies/Organ#":"organ",
"http://rdaregistry.info/termList/rofer/":"rofer",
"http://semantic-forms.cc:9112/ldp/":"sfd",
"http://sensormeasurement.appspot.com/ont/home/homeActivity#":"ha",
"http://purl.allotrope.org/ontologies/datapackage#":"adf",
"http://linkeddata.finki.ukim.mk/lod/ontology/tao#":"trao",
"http://www.loc.gov/zing/srw/diagnostic/":"diag",
"http://w3id.org/sparql-generate/fn/":"fun",
"http://rdf.ebi.ac.uk/terms/surechembl#":"scco",
"https://w3id.org/dsv#":"dsv",
"http://standaarden.overheid.nl/owms/terms/":"owms",
"http://jena.hpl.hp.com/2005/11/Assembler#":"ja",
"http://swpatho.ag-nbi.de/context/meta.owl#":"swpatho",
"http://www.clarin.eu/cmd/":"cmdi",
"https://w3id.org/cwl/cwl#":"cwl",
"http://rdvocab.info/uri/schema/FRBRentitiesRDA/":"rdafrbr",
"http://purl.org/NET/c4dm/keys.owl#":"keys",
"http://spi-fm.uca.es/spdef/models/genericTools/itm/1.0#":"itm",
"http://www.opengis.net/def/uom/OGC/1.0/":"uom",
"http://infotech.nitk.ac.in/research-scholars/sakthi-murugan-r/":"sakthi",
"http://www.wikidata.org/prop/direct-normalized/":"wdtn",
"http://km.aifb.kit.edu/projects/numbers/":"numbers",
"http://www.bbc.co.uk/ontologies/creativework/":"cwork",
"http://rdvocab.info/ElementsGr2/":"rdag2",
"http://www.data-knowledge.org/dk/schema/rdf/latest/":"dk",
"http://hadatac.org/ont/chear#":"chear",
"http://www.ogbd.fr/2012/ontologie#":"ogbd",
"http://rdfex.org/withImports?uri=":"wimpo",
"https://w3id.org/laas-iot/adream#":"opa",
"http://bblfish.net/people/henry/card#":"bblfish",
"http://linkedmultimedia.org/sparql-mm/functions/temporal#":"mmt",
"http://td5.org/#":"td5",
"http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper.owl#":"lslife",
"http://www.opengis.net/kml/2.2#":"kml",
"http://dbpedia.org/ontology/composer/":"composer",
"http://www.bigdata.com/rdf/search#":"bds",
"http://www.demcare.eu/ontologies/demlab.owl#":"demlab",
"http://jena.apache.org/ARQ/property#":"apf",
"http://cs.dbpedia.org/":"csdbp",
"https://bioportal.bioontology.org/ontologies/ONE/":"one",
"http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/callejero#":"cjr",
"http://linkedgeodata.org/meta/":"lgdm",
"http://purl.org/dpn#":"dpn",
"http://good.dad/meaning/bob#":"bob",
"http://kulturarvsdata.se/ksamsok#":"soch",
"http://chroniclingamerica.loc.gov/terms#":"ndnp",
"http://doc.metalex.eu/id/":"mds",
"http://hadatac.org/ont/vstoi#":"vstoi",
"http://info.deepcarbon.net/sample/schema#":"dcosample",
"http://fedora.info/definitions/v4/audit#":"audit",
"http://kannel.open.ac.uk/ontology#":"door",
"http://www.radar-projekt.org/display/":"radar",
"http://www.sdshare.org/2012/extension/":"sdshare",
"https://w3id.org/people/az/":"az",
"http://rdaregistry.info/termList/rofrr/":"rofrr",
"http://deductions.github.io/seeds.owl.ttl#":"seeds",
"http://ns.inria.fr/munc#":"munc",
"http://jermontology.org/ontology/JERMOntology#":"jerm",
"http://purl.org/net/bel-epa/doacc#":"doacc",
"http://rdaregistry.info/termList/soundCont/":"rdasco",
"http://bis.270a.info/dataset/":"bis",
"http://purl.org/a-proc#":"aprov",
"https://w3id.org/ibp/CTRLont#":"ctrl",
"http://www.openlinksw.com/ontology/logging#":"opllog",
"http://academic-meta-tool.xyz/vocab#":"amt",
"http://rdaregistry.info/termList/rofem/":"rofem",
"http://rdaregistry.info/termList/rofid/":"rofid",
"http://vocab.datex.org/terms#":"datex",
"https://w3id.org/associations/vocab#":"assoc",
"http://www.eclipse.org/emf/2002/Ecore#":"ecore",
"http://www.scholarlydata.org/ontology/conference-ontology.owl#":"scho",
"https://w3id.org/navigation_menu#":"navm",
"http://vocab.org/whisky/terms/":"whisky",
"http://purl.org/olia/system.owl#":"oliasystem",
"http://biglinkeddata.com/":"bld",
"http://reference.eionet.europa.eu/faostat/schema/":"faostat",
"http://www.lingvoj.org/olca#":"olca",
"http://www.markus.com/":"markus",
"http://hadatac.org/ont/hasneto#":"hasneto",
"http://purl.bdrc.io/ontology/core/":"bdo",
"https://w3id.org/lodsight/rdf-path#":"rpath",
"http://data.vlaanderen.be/ns/mandaat#":"mandaat",
"http://streamreasoning.org/ontologies/frappe#":"frappe",
"http://www.conjecto.com/ontology/2015/lheo#":"lheo",
"http://rdaregistry.info/termList/rofrt/":"rofrt",
"http://securitytoolbox.appspot.com/MASO#":"maso",
"http://purl.org/emergel/modules#":"emergelm",
"https://purl.org/lg/":"lg",
"http://www.openlinksw.com/ontology/market#":"oplmkt",
"https://www.youtube.com/user/SuperTellAFriend/featured/":"hello",
"https://w3id.org/version/ontology#":"ver",
"https://w3id.org/lovcube/ns/lovcube#":"lovc",
"https://w3id.org/function/vocabulary/mapping#":"fnom",
"http://erlangen-crm.org/efrbroo/":"efrbroo",
"http://toptix.com/2010/esro/":"tix",
"http://www.bbc.co.uk/ontologies/coreconcepts/":"bbccore",
"http://data.wu.ac.at/ns/timex#":"timex",
"http://rdaregistry.info/termList/prodTactile/":"rdapmt",
"http://www.openlinksw.com/ontology/dbms-app-ontology#":"dbms",
"https://w3id.org/laas-iot/edr#":"edr",
"http://xxefe.de/":"erce",
"http://purl.bdrc.io/resource/":"bdr",
"http://ufal.mff.cuni.cz/conll2009-st/task-description.html#":"conll",
"http://spi-fm.uca.es/spdef/models/deployment/spcm/1.0#":"spcm",
"http://www.sensormeasurement.appspot.com/ont/transport/traffic#":"traffic",
"http://www.openlinksw.com/schemas/linkedin#":"oplli",
"http://mementoweb.org/ns#":"memento",
"http://www.astro.umd.edu/~eshaya/astro-onto/owl/physics.owl#":"physics",
"http://www.semanticweb.org/ontologia_EA#":"eame",
"http://vocab.linkeddata.es/datosabiertos/def/comercio/tejidoComercial#":"escom",
"http://statisticaldata.linkedwidgets.org/terms/":"sdt",
"http://ogd.ifs.tuwien.ac.at/vienna/geo/":"vogd",
"http://purl.org/opdm/refrigerator#":"ofrd",
"http://www.openlinksw.com/ontology/restrictions#":"oplres",
"http://gbol.life/0.1#":"gbol",
"http://purl.org/biodiversity/eol/":"eol",
"https://vocab.eccenca.com/pubsub/":"eccpubsub",
"https://www.mediawiki.org/ontology#API/":"mwapi",
"http://www.swi-prolog.org/rdf/library/":"voidex",
"http://rdaregistry.info/termList/RDACarrierEU/":"rdacarx",
"https://www.irit.fr/recherches/MELODI/ontologies/cinema#":"yaco",
"http://www.geonames.org/ontology/mappings/":"gnm",
"http://purl.org/voc/summa/":"summa",
"http://www.springernature.com/scigraph/graphs/":"sgg",
"http://schemas.varigence.com/biml.xsd#":"biml",
"http://qudt.org/vocab/dimensionvector/":"qkdv",
"http://rdaregistry.info/termList/bookFormat/":"rdabf",
"http://www.linklion.org/ontology#":"llont",
"http://rdaregistry.info/termList/emulsionMicro/":"rdaemm",
"http://rdaregistry.info/Elements/z/":"rdaz",
"http://rdaregistry.info/termList/broadcastStand/":"rdabs",
"http://lemon-model.net/lexica/uby/":"lemonuby",
"http://gogl.com/":"foaffff",
"http://www.univalle.edu.co/ontologies/System#":"system",
"https://gont.ch/":"gont",
"http://purl.org/net/cnyt-literature#":"literature",
"http://w3id.org/semiot/ontologies/semiot#":"semiot",
"https://www.cs.vu.nl/~mcaklein/onto/swrc_ext/2005/05#":"swrc2",
"http://rdf.insee.fr/geo/":"frgeo",
"http://rdf.ebi.ac.uk/resource/ensembl/":"ensembl",
"http://www.co-ode.org/roberts/travel.owl#":"travel",
"https://vocab.eccenca.com/di/":"eccdi",
"http://purl.org/ceu/eco/1.0#":"ecoll",
"https://w3id.org/opentrafficlights#":"otl",
"http://data.europa.eu/m8g/":"cpov",
"http://vidont.org/":"vidont",
"https://w3id.org/laas-iot/lmu#":"lmu",
"http://www.w3.org/ns/duv#":"duv",
"http://data.persee.fr/ontology/persee_ontology/":"persee",
"http://www.openlinksw.com/ontology/acl#":"oplacl",
"http://premon.fbk.eu/ontology/core#":"pmo",
"http://www.aifb.uni-karlsruhe.de/WBS/uhe/ontologies#":"newsevents",
"http://www.openlinksw.com/schemas/oplweb#":"oplweb",
"http://def.seegrid.csiro.au/isotc211/iso19150/-2/2012/basic#":"h2o",
"http://www.openlinksw.com/ontology/stocks#":"oplstocks",
"https://w3id.org/nno/ontology#":"nno",
"https://bmake.th-brandenburg.de/spv#":"spvqa",
"http://www.imsglobal.org/xsd/imsmd_v1p2/":"ims",
"http://deductions.github.io/vehicule-management.owl.ttl#":"vehma",
"http://rdaregistry.info/termList/rofin/":"rofin",
"http://data.vlaanderen.be/ns/besluit#":"besluit",
"http://purl.org/minim/minim#":"minim",
"http://www.disit.org/km4city/schema#":"km4c",
"http://www.openlinksw.com/ontology/benefits#":"oplbenefit",
"http://vocab.linkeddata.es/datosabiertos/def/hacienda/presupuestos#":"espresup",
"https://saref.etsi.org/saref4syst/":"s4syst",
"https://w3id.org/legal_form#":"lfov",
"http://w3id.org/sparql-generate/iter/":"iter",
"http://ontologi.es/doap-bugs#":"dbug",
"http://rdaregistry.info/termList/AspectRatio/":"rdaar",
"http://purl.org/dsw/":"dsw",
"http://purl.org/ws-mmi-dc/terms/":"dcap",
"http://ontology.cube.global/":"cubeont",
"https://w3id.org/i40/aml#":"aml",
"http://complyadvantage.com/":"ca",
"http://purl.org/puninj/2001/05/rgml-schema#":"rgml",
"http://rdaregistry.info/termList/RDAproductionMethod/":"rdapm",
"http://purl.org/olia/ubyCat.owl#":"uby",
"http://purl.obolibrary.org/obo/ido.owl#":"ido",
"http://id.esd.org.uk/list/":"ipsv",
"http://rdf.onisep.fr/resource/":"onisep",
"http://pcdm.org/models#":"pcdm",
"http://provinsi.com/":"provinsi",
"https://w3id.org/rdfp/":"rdfp",
"http://semweb.datasciencelab.be/ns/sfn#":"sfn",
"http://www.clarin.eu/cmdi/cues/display/1.0#":"cue",
"http://purl.org/ontology-use-patterns#":"oup",
"http://docs.oasis-open.org/ns/office/1.2/meta/odf#":"odf",
"http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl#":"nih",
"http://id.nlm.nih.gov/mesh/vocab#":"meshv",
"http://w3id.org/nkos#":"nkos",
"http://ontology.irstea.fr/weather/ontology#":"irsteaont",
"http://rdaregistry.info/termList/rofit/":"rofit",
"http://rdf.muninn-project.org/ontologies/religion#":"religion",
"http://www.ebusiness-unibw.org/ontologies/cpi/ns#":"cpi",
"http://ns.inria.fr/ratio4ta/v1#":"r4ta",
"http://data.posccaesar.org/ilap/":"ilap",
"http://swtmp.gitlab.io/vocabulary/templates.owl#":"tx",
"http://www.semanticweb.org/parthasb/ontologies/2014/6/vacseen1/":"vacseen1",
"http://id.loc.gov/vocabulary/graphicMaterials/":"tgm",
"http://rdaregistry.info/termList/RDACartoDT/":"rdacdt",
"http://www.lexinfo.net/lmf#":"lmf",
"http://www.fluidops.com/":"fluidops",
"http://rs.tdwg.org/dwc/iri/":"dwciri",
"http://public-contracts.nexacenter.org/id/propertiesRole/":"pcit",
"http://rdaregistry.info/termList/noteForm/":"rdafnv",
"http://purl.oclc.org/NET/ssnx/cf/cf-feature#":"cff",
"http://rdf.muninn-project.org/ontologies/naval#":"naval",
"http://mex.aksw.org/mex-core#":"mexcore",
"http://beer.com/":"beer",
"https://brickschema.org/schema/1.1.0/BrickShape#":"bsh",
"http://deductions.github.io/nature_observation.owl.ttl#":"nature",
"http://purl.org/voc/uneskos#":"uneskos",
"http://purl.jp/bio/12/glyco/glycan#":"glycan",
"http://pmhb.org/":"pmhb",
"https://w3id.org/saref4ee#":"s4ee",
"http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/aparcamiento#":"esapar",
"https://w3id.org/skgo/phy#":"phy",
"https://github.com/ali1k/ld-reactor/blob/master/vocabulary/index.ttl#":"swcomp",
"http://www.irit.fr/recherches/MELODI/ontologies/IoT-O#":"ioto",
"http://www.ifs.tuwien.ac.at/~miksa/ontologies/VPlan.owl#":"vplan",
"http://identifiers.org/":"id",
"http://semweb.mmlab.be/ns/odapps#":"odapps",
"http://purl.org/geovocamp/ontology/geovoid/":"geovoid",
"http://semweb.mmlab.be/ns/dicera#":"dicera",
"http://brk.basisregistraties.overheid.nl/def/brk#":"brk",
"https://w3id.org/beo#":"beo",
"http://vocab.linkeddata.es/datosabiertos/def/sector-publico/servicio#":"esservicio",
"http://www.w3.org/ns/wsdl-rdf#":"wsdl",
"http://merlin.phys.uni.lodz.pl/onto/physo/physo.owl#":"physo",
"http://linkeddata.finki.ukim.mk/lod/ontology/veo#":"veo",
"http://iiif.io/api/image/2#":"iiif",
"http://completeness.inf.unibz.it/sp-vocab#":"spv",
"http://aksw.org/":"aksw",
"http://tarql.github.io/tarql#":"tarql",
"http://th-brandenburg.de/ns/itcat#":"itcat",
"https://devuan.net.br/":"devuan",
"http://www.buildingsmart-tech.org/ifcOWL/IFC4_ADD2#":"ifcowl",
"http://dbpedia.org/facts/ontology#":"dbfo",
"http://www.mico-project.eu/ns/mmm/2.0/schema#":"mmm",
"http://rdaregistry.info/termList/RDARegionalEncoding/":"rdare",
"http://purl.org/net/opmv/types/xslt#":"xslopm",
"https://w3id.org/skgo/modsci#":"modsci",
"http://vocab.linkeddata.es/datosabiertos/def/sector-publico/territorio#":"esadm",
"https://budayakb.cs.ui.ac.id/ns#":"bkb",
"http://purl.org/linked-data/sdmx/2009/measure#":"sdmxm",
"http://rdf.ebi.ac.uk/terms/atlas/":"atlasterms",
"http://www.essepuntato.it/2010/06/literalreification/":"literal",
"http://citydata.wu.ac.at/qb-equations#":"qbe",
"https://www.wowman.org/index.php?id=1&type=get#":"da",
"http://www.samos.gr/ontologies/helpdeskOnto.owl#":"hdo",
"http://purl.obolibrary.org/obo/ontoneo/":"ontoneo",
"http://utpl.edu.ec/sbc/data/":"dead",
"http://www.gemeentegeschiedenis.nl/gg-schema#":"gg",
"http://purl.org/ontology/cco/core#":"cog",
"https://github.com/martynui/OGDL4M/":"ogdl4m",
"http://schema.vocnet.org/":"vocnet",
"http://jazz.net/ns/rm#":"rm",
"https://www.w3.org/TR/ldn/#":"ldn",
"http://data.nobelprize.org/terms/":"nobel",
"http://www.metmuseum.org/":"vam",
"http://w3id.org/oop#":"oop",
"http://rdaregistry.info/termList/configPlayback/":"rdacpc",
"http://w3id.org/rsp/vocals#":"vocals",
"http://www.linkeddata.es/ontology/ldq#":"ldq",
"http://rdaregistry.info/termList/rofsm/":"rofsm",
"http://purl.org/datanode/ppr/ns/":"ppr",
"http://www.w3.org/ns/legal#":"legal",
"http://vocab.fusepool.info/fp3#":"fp3",
"https://w3id.org/ro/curate#":"roc",
"http://underlay.mit.edu/ns/":"ul",
"http://purl.org/crmeh#":"crmeh",
"http://openresearch.org/vocab/":"or",
"http://purl.org/SemSur/":"semsur",
"http://www.analysispartners.org/businessmodel/":"apb",
"http://mydb.org/":"mydb",
"https://data.imjv.omgeving.vlaanderen.be/ns/imjv#":"imjv",
"http://rdaregistry.info/termList/specPlayback/":"rdaspc",
"http://topbraid.org/tosh#":"tosh",
"http://promsns.org/def/decprov#":"decprov",
"http://rdvocab.info/ElementsGr3/":"rdag3",
"http://edg.topbraid.solutions/model/":"edg",
"http://merck.github.io/Halyard/ns#":"halyard",
"http://data.doremus.org/ontology#":"mus",
"http://www.opengis.net/def/rule/geosparql/":"geor",
"http://volt-name.space/vocab/input#":"input",
"http://www.gobierno.es/gobierno/":"gobierno",
"http://www.influencetracker.com/ontology#":"it",
"http://linkedgadget.com/wiki/Property:":"lgt",
"http://www.yso.fi/onto/yso/":"yso",
"http://purl.org/net/aozora/":"aozora",
"http://aleth.io/":"alethio",
"https://w3id.org/ttla/":"ttla",
"http://iflastandards.info/ns/isbd/unc/elements/":"isbdu",
"http://rdaregistry.info/termList/rofrm/":"rofrm",
"http://www.linked2safety-project.eu/properties/":"l2sp",
"http://ethoinformatics.org/ethocore/":"ethc",
"http://mbgd.genome.ad.jp/owl/mbgd.owl#":"mbgd",
"http://dataid.dbpedia.org/ns/core#":"dataid",
"http://purl.oclc.org/NET/UNIS/fiware/iot-lite#":"iotlite",
"http://topbraid.org/swa#":"swa",
"http://assemblee-virtuelle.github.io/grands-voisins-v2/thesaurus.ttl#":"gvoith",
"http://rdaregistry.info/termList/rofim/":"rofim",
"https://data.nasa.gov/ontologies/atmonto/NAS#":"nas",
"http://www.univalle.edu.co/ontologies/Tissue#":"tissue",
"http://sweetontology.net/reprSciProvenance/":"sciprov",
"http://purl.org/db/nosql#":"nosql",
"http://purl.oclc.org/NET/muo/ucum/":"ucum",
"http://rdaregistry.info/termList/fileType/":"rdaft",
"http://ns.inria.fr/huto/":"huto",
"http://tadirah.dariah.eu/vocab/":"tadirah",
"http://purl.org/linked-data/sdmx/2009/concept#":"sdmxc",
"http://info.deepcarbon.net/datatype/schema#":"dcodt",
"http://menemeneml.com/school#":"scholl",
"http://neotec.rc.unesp.br/resource/NeotectonicsBibliography/":"neotecbib",
"http://www.w3.org/2005/sparql-results#":"srx",
"https://www.geo7.ch/":"geo7",
"http://pfclitex.com/":"cska",
"http://rdaregistry.info/Elements/x/":"rdax",
"http://loted.eu/ontology#":"loted",
"http://rdaregistry.info/termList/presFormat/":"rdapf",
"https://w3id.org/ontop/":"ontop",
"http://intelleo.eu/ontologies/user-model/ns/":"um",
"http://deductions.github.io/geoloc.owl.ttl#":"geoloc",
"http://rdfs.co/juso/":"juso",
"http://purl.org/onto-ocds/ocds#":"ocds",
"http://d-nb.info/standards/elementset/dnb#":"dnbt",
"http://www.ensias.ma/":"koly",
"http://schema.intellimind.ns/symbology#":"imind",
"http://identifiers.org/idot/":"idot",
"http://ontology.eil.utoronto.ca/ISO37120.owl#":"iso37120",
"http://edgarwrap.ontologycentral.com/cik/":"edgarcik",
"http://lod.xdams.org/ontologies/ods/":"ods",
"http://purl.org/rvl/":"rvl",
"http://reference.data.gov.uk/def/public-body/":"pbody",
"http://w3id.org/occ#":"occ",
"http://smxm.ga/":"smxm",
"http://vocab.ub.uni-leipzig.de/amsl/":"amsl",
"http://vocab.linkeddata.es/datosabiertos/def/medio-ambiente/calidad-aire#":"esair",
"http://edg.topbraid.solutions/maeco/":"maeco",
"http://uri4uri.net/vocab#":"uri4uri",
"http://www.semanticweb.org/ontologies/2012/1/Ontology1329913965202.owl#":"ondc",
"http://drakon.su/ADF#":"alg",
"http://linkedeconomy.org/ontology#":"elod",
"http://com.intrinsec//ontology#":"rfd",
"http://neotec.rc.unesp.br/resource/Neotectonics/":"neotec",
"http://www.cidoc-crm.org/cidoc-crm/CRMinf/":"crminf",
"http://www.w3.org/ns/bde/docker/":"docker",
"http://lod.b3kat.de/title/":"b3kat",
"http://linkeddata.es/resource/ldqm/":"ldqm",
"http://reactionontology.org/piero/":"piero",
"http://10.0.3.120/download/eproc_FORN_v02.owl#":"eproc",
"http://www.datatourisme.fr/ontology/core/1.0#":"dto",
"http://sweetontology.net/reprSciFunction/":"sorepsf",
"http://premon.fbk.eu/ontology/nb#":"pmonb",
"http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-edac.owl#":"edac",
"http://ogp.me/ns#video:":"ns2",
"http://rdaregistry.info/termList/rofhf/":"rofhf",
"http://citydata.wu.ac.at/Linked-UNData/data/":"undata",
"https://mail.google.com/mail/u/1/#":"connard",
"http://www.purl.org/net/remetca#":"remetca",
"http://wiki.dbpedia.org/":"pop",
"http://www.datacron-project.eu/datAcron#":"datacron",
"https://w3id.org/vocab/xbrll#":"xbrll",
"http://km.aifb.kit.edu/services/geo/ontology#":"kmgeo",
"http://sweetontology.net/humanKnowledgeDomain/":"sohukd",
"http://purl.org/net/tsnchange#":"tsnchange",
"http://data.foodanddrinkeurope.eu/ontology#":"efd",
"http://www.eyrie.org/~zednenem/2002/wail/":"wail",
"http://wab.uib.no/cost-a32_philospace/wittgenstein.owl#":"wab",
"http://kalmar32.fzi.de/triples/global-cube.ttl#":"globalcube",
"http://sda.tech/SEOontology/SEO/":"seo",
"http://info.deepcarbon.net/data/schema#":"dcodata",
"http://bag.basisregistraties.overheid.nl/bag/id/pand/":"pand",
"http://linked.data.gov.au/def/loci#":"loci",
"http://linked.data.gov.au/def/geofabric#":"geofabric",
"https://sparql.crssnky.xyz/imasrdf/URIs/imas-schema.ttl#":"imas",
"http://purl.oreilly.com/ns/meta/":"metadata",
"https://www.ica.org/standards/RiC/ontology#":"rico",
"http://sparql.cwrc.ca/ontologies/ii#":"ii",
"http://premon.fbk.eu/ontology/fn#":"pmofn",
"http://onto.dm2e.eu/schemas/dm2e/":"dm2e",
"http://vocbench.solidaridad.cloud/taxonomies#":"d3s",
"http://sweetontology.net/propTemperatureGradient/":"soproptg",
"http://identifiers.org/ncbigene/":"ncbigene",
"http://premon.fbk.eu/ontology/vn#":"pmovn",
"http://ontoview.org/schema/unspsc/1#":"unspsc",
"https://www.iab.com/guidelines/taxonomy/":"iab",
"https://w3id.org/BCI-ontology#":"bci",
"http://sweetontology.net/phenAtmoWind/":"sophatmow",
"http://vocab.linkeddata.es/datosabiertos/def/sector-publico/procedimientos#":"esproc",
"http://purl.org/net/schemarama#":"scra",
"https://w3id.org/GDPRov#":"gdprov",
"http://com.vortic3.MANTO/":"manto",
"http://www.language-archives.org/OLAC/1.1/":"olac11",
"https://w3id.org/def/saref4bldg#":"s4bldg",
"http://sweetontology.net/matr/":"soma",
"http://sweetontology.net/propSpaceDistance/":"sopropsdis",
"http://purl.org/iot/vocab/m3-lite#":"m3lite",
"http://eurostat.linked-statistics.org/data#":"eustd",
"http://vocab.sti2.at/vsearch#":"vsearch",
"https://sweetontology.net/phenAtmoWindMesoscale/":"sophatmowm",
"http://sensormeasurement.appspot.com/m3#":"m3",
"http://w3id.org/s3n/":"s3n",
"http://sweetontology.net/procStateChange/":"soprocsc",
"http://dati.gov.it/onto/clapit/":"clapit",
"https://www.tikag.com/":"tikag",
"http://brt.basisregistraties.overheid.nl/def/top10nl#":"brt",
"http://www.rechercheisidore.fr/class/":"isidore",
"http://sweetontology.net/reprSpaceReferenceSystem/":"sorepsrs",
"http://ontologycentral.com/2009/01/eurostat/ns#":"estatwrap",
"http://sweetontology.net/propTimeFrequency/":"soproptf",
"http://rdaregistry.info/termList/IllusContent/":"rdaill",
"http://sweetontology.net/reprMathOperation/":"sorepmo",
"http://rdaregistry.info/termList/rofsf/":"rofsf",
"https://w3id.org/valueflows/":"valueflows",
"http://sweetontology.net/propPressure/":"sopropp",
"http://health.data.gov/def/hospital/":"hosp",
"https://vocab.eccenca.com/gdpr/":"gdpr",
"https://w3id.org/GDPRtEXT#":"gdprtext",
"http://rdf.data-vocabulary.org/rdf.xml#":"rdfdata",
"http://ontology.irstea.fr/":"irstea",
"http://idl.u-grenoble3.fr/":"master1",
"http://premon.fbk.eu/resource/":"pm",
"http://rdaregistry.info/termList/videoFormat/":"rdavf",
"http://smart-api.io/ontology/1.0/smartapi#":"smartapi",
"http://bioentity.io/vocab/":"bioentity",
"http://dati.isprambiente.it/ontology/core#":"ispra",
"http://semweb.mmlab.be/ns/fnml#":"fnml",
"http://rimmf.com/vocab/":"rimmf",
"http://sweetontology.net/propSpaceLocation/":"sopropsl",
"http://liris.cnrs.fr/asawoo/":"asawoo",
"http://ns.taverna.org.uk/2012/tavernaprov/":"tavprov",
"http://www.linklion.org/algorithm/":"llalg",
"http://colin.maudry.com/ontologies/dgfr#":"dgfr",
"http://w3id.org/vcb/fel#":"fel",
"http://iais.fraunhofer.de/vocabs/rami#":"rami",
"http://vocab.ub.uni-leipzig.de/bibrm/":"bibrm",
"http://purl.jp/bio/01/refexo#":"refexo",
"http://www.demcare.eu/ontologies/contextdescriptor.owl#":"ctxdesc",
"http://qudt.org/vocab/quantitykind/":"qk",
"http://purl.org/emergel/core#":"emergel",
"http://www.wikidata.org/prop/statement/value/":"psv",
"https://data.cbb.omgeving.vlaanderen.be/ns/cbb#":"cbb",
"http://edg.topbraid.solutions/taxonomy/macroeconomics/":"maet",
"http://rdaregistry.info/termList/RDAGeneration/":"rdagen",
"http://softeng.polito.it/rsctx#":"rsctx",
"http://schema.stenci.la/":"stencila",
"http://sweetontology.net/stateChemical/":"sostc",
"http://sweetontology.net/humanEnvirConservation/":"sohuecons",
"http://purl.org/vocabularies/princeton/wn30/":"wn30",
"https://w3id.org/skgo/chemsci#":"chemsci",
"http://sweetontology.net/propCategorical/":"sopropcat",
"http://www.wikidata.org/prop/qualifier/":"pq",
"http://sws.ifi.uio.no/vocab/dsf/henriwi/dsf#":"dsfv",
"http://reference.data.gov.au/def/ont/iso19160-1-address#":"isoadr",
"http://www.openlinksw.com/ontology/purchases#":"oplp",
"https://data.nasa.gov/ontologies/atmonto/equipment#":"eqp",
"http://dp.la/info/developers/map/":"dpla",
"http://linked.data.gov.au/def/gnaf#":"gnaf",
"http://goaf.fr/goaf#":"goaf",
"http://lib.bit.edu.cn/ontology/1.0/":"bitl",
"http://www.openlinksw.com/schemas/angel#":"oplangel",
"http://vocab.linkeddata.es/datosabiertos/def/medio-ambiente/contaminacion-acustica#":"noise",
"https://w3id.org/skgo/pham#":"pham",
"http://purl.org/net/p-plan#":"pplan",
"http://rdaregistry.info/Elements/a/datatype/":"rdaad",
"https://w3id.org/GConsent#":"gcon",
"http://sweetontology.net/phenAtmoFog/":"sophatmofo",
"https://w3id.org/prohow#":"prohow",
"http://purl.org/wild/vocab#":"wild",
"http://sweetontology.net/propSpaceHeight/":"sopropsh",
"http://www.essepuntato.it/2008/12/earmark#":"ermrk",
"http://sweetontology.net/reprMathSolution/":"sorepmso",
"http://sweetontology.net/proc/":"soproc",
"http://sparql.sstu.ru:3030/speciality/":"losp",
"http://ont.matchdeck.com/":"mdont",
"https://w3id.org/cwl/view/git/":"cwlgit",
"http://vocab.capes.gov.br/def/vcav#":"capes",
"http://sweetontology.net/reprSciUnits/":"sorepsu",
"http://www.orpha.net/ORDO/":"ordo",
"http://requirement.ase.ru/requirements_ontology#":"aseonto",
"http://www.sysresearch.org/rda-common-dmp#":"dmp",
"http://socialarchive.iath.virginia.edu/":"snac",
"http://premon.fbk.eu/ontology/pb#":"pmopb",
"http://sweetontology.net/matrOrganicCompound/":"somaoc",
"http://sweetontology.net/reprMathFunctionOrthogonal/":"sorepmfo",
"http://datamusee.givingsense.eu/onto/":"dm",
"http://sweetontology.net/stateVisibility/":"sostv",
"http://sweetontology.net/procPhysical/":"soprocp",
"http://sweetontology.net/reprSciComponent/":"sorepsc",
"https://w3id.org/executionTechnique/ontology/":"extech",
"http://ns.inria.fr/provoc/":"provoc",
"http://sweetontology.net/propSpeed/":"sopropsp",
"http://hadatac.org/ont/lesa#":"lesa",
"http://sweetontology.net/reprDataServiceAnalysis/":"sorepdsa",
"https://www.w3.org/2019/wot/json-schema#":"jsonschema",
"http://sweetontology.net/stateTimeFrequency/":"sosttf",
"http://sweetontology.net/reprSpaceCoordinate/":"sorepscd",
"http://sweetontology.net/reprDataFormat/":"sorepdf",
"http://10.0.3.120/download/eproc_FORN_v04.owl#":"eproc2",
"http://sweetontology.net/reprSciMethodology/":"sorepsme",
"http://sweetontology.net/phenEcology/":"sophec",
"http://sweetontology.net/realmOceanFloor/":"soreaofl",
"http://purl.org/powla/powla.owl#":"powla",
"http://sweetontology.net/reprMathStatistics/":"sorepmst",
"http://daap.dsi.universite-paris-saclay.fr/wiki/":"daap",
"http://sweetontology.net/propSpaceDirection/":"sopropsdir",
"http://sweetontology.net/humanTransportation/":"sohut",
"http://vocab.ciudadesabiertas.es/def/sector-publico/agenda-municipal#":"esagen",
"http://rdaregistry.info/termList/rofet/":"rofet",
"http://sweetontology.net/phenOceanCoastal/":"sophoc",
"http://semwebquality.org/ontologies/dq-constraints#":"dqc",
"http://sweetontology.net/phenAtmoPrecipitation/":"sophatmopc",
"http://voc.odw.tw/theme/":"theme",
"http://sweetontology.net/relaMath/":"sorelm",
"http://sweetontology.net/propCharge/":"sopropcha",
"http://sweetontology.net/propEnergyFlux/":"sopropef",
"http://linked.earth/ontology#":"earth",
"http://purl.org/cwmo/#":"cwmo",
"http://sweetontology.net/reprTime/":"sorept",
"http://id.loc.gov/authorities/subjects/":"lcsh",
"http://www.wikidata.org/value/":"wdv",
"https://w3id.org/ep-plan#":"epplan",
"https://data.nasa.gov/ontologies/atmonto/general#":"atts",
"https://w3id.org/skgo/dentsci#":"dentsci",
"http://qudt.org/vocab/constant/":"constant",
"http://delicias.dia.fi.upm.es/ontologies/ObjectWithStates.owl#":"obws",
"http://guava.iis.sinica.edu.tw/r4r/":"r4r",
"https://w3id.org/bs#":"bs",
"http://standaarden.overheid.nl/dcatnl/terms/":"dcatnl",
"http://sweetontology.net/propSpace/":"soprops",
"http://sweetontology.net/reprDataProduct/":"sorepdp",
"https://www.w3.org/2019/wot/hypermedia#":"hctl",
"http://sweetontology.net/propTime/":"sopropti",
"http://datos.gob.es/sites/default/files/OntologiaDIR3/orges.owl#":"orgesv2",
"http://sweetontology.net/realmAtmo/":"soreaa",
"http://purl.jp/bio/10/gmo/":"gmo",
"http://sweetontology.net/phenSolid/":"sophso",
"http://sweetontology.net/realmLandCoastal/":"sorealc",
"http://upload.wikimedia.org/wikipedia/commons/f/f6/":"wikimedia",
"http://sweetontology.net/phenSystem/":"sophsy",
"https://w3id.org/edwin/ontology/":"esgs",
"http://sweetontology.net/reprDataServiceValidation/":"sorepdsv",
"http://sweetontology.net/propMassFlux/":"sopropmf",
"http://sweetontology.net/":"sweet",
"http://www.ics.forth.gr/isl/VoIDWarehouse/VoID_Extension_Schema.owl#":"voidwh",
"http://sweetontology.net/reprMathFunction/":"sorepmf",
"http://w3id.org/medred/medred#":"medred",
"http://ld.iospress.nl/rdf/ontology/":"iospress",
"https://identifiers.org/inchikey:":"inchikey",
"http://sweetontology.net/stateBiological/":"sostb",
"http://purl.org/cyber/stix#":"stx",
"http://sweetontology.net/reprDataServiceReduction/":"sorepdsr",
"http://sweetontology.net/relaProvenance/":"sorelpr",
"http://sweetontology.net/propSpaceMultidimensional/":"sopropsm",
"http://linkeddata.fssprus.ru/resource/":"fssp",
"http://ns.inria.fr/nrv#":"nrv",
"http://w3id.org/charta77/jup/":"jup",
"http://sweetontology.net/reprSciLaw/":"sorepsl",
"http://sweetontology.net/propDiffusivity/":"sopropdifu",
"http://purl.org/isaterms/":"isaterms",
"http://sweetontology.net/propCapacity/":"sopropcap",
"http://estatwrap.ontologycentral.com/id/nama_aux_gph#":"estatgph",
"http://odw.tw/":"odw",
"http://promsns.org/def/do#":"dprov",
"http://sweetontology.net/propQuantity/":"sopropq",
"http://sweetontology.net/realmHydroBody/":"soreahb",
"http://sweetontology.net/stateRoleImpact/":"sostri",
"http://mex.aksw.org/mex-perf#":"mexperf",
"http://sweetontology.net/propBinary/":"sopropb",
"http://sweetontology.net/propCount/":"sopropcou",
"http://sweetontology.net/matrMineral/":"somamin",
"http://sweetontology.net/phenAtmoCloud/":"sophatmoc",
"http://sweetontology.net/stateRoleRepresentative/":"sostrr",
"http://sweetontology.net/reprTimeSeason/":"sorepts",
"http://data.lblod.info/vocabularies/leidinggevenden/":"lblodlg",
"http://www.juntadeandalucia.es/datosabiertos/portal/iaph/dataset/dataset/6c199ca2-8d2e-4c12-833c-f28":"iaph",
"http://assemblee-virtuelle.github.io/grands-voisins-v2/gv.owl.ttl#":"gvoi",
"http://sweetontology.net/matrNaturalResource/":"somanr",
"http://sweetontology.net/phenFluidDynamics/":"sophfd",
"http://sweetontology.net/relaClimate/":"sorelcl",
"http://hexananas.com/pineapple#":"pineapple",
"http://sweetontology.net/propDimensionlessRatio/":"sopropdr",
"http://www.owl-ontologies.com/test.owl/ingredient/":"ingredient",
"https://tac.nist.gov/tracks/SM-KBP/2018/ontologies/SeedlingOntology#":"ldc",
"http://vocab.linkeddata.es/datosabiertos/def/transporte/trafico#":"estrf",
"https://w3id.org/":"w3id",
"https://bp4mc2.org/def/skos-lex#":"skoslex",
"http://sweetontology.net/propConductivity/":"sopropcon",
"http://sweetontology.net/reprMathGraph/":"sorepmg",
"http://sweetontology.net/relaHuman/":"sorelh",
"https://www.w3.org/2019/wot/security#":"wotsec",
"http://sweetontology.net/propMass/":"sopropm",
"http://sweetontology.net/repr/":"sorep",
"http://sweetontology.net/reprSpace/":"soreps",
"http://sweetontology.net/propEnergy/":"soprope",
"http://sweetontology.net/stateThermodynamic/":"sostth",
"http://sweetontology.net/stateOrdinal/":"sosto",
"http://www.ideotalex.eu/datos/recurso/":"ideotalex",
"http://sweetontology.net/propOrdinal/":"sopropo",
"https://w3id.org/seas/FeatureOfInterestOntology/":"foio",
"http://sweetontology.net/humanTechReadiness/":"sohutr",
"http://data.finlex.fi/schema/sfl/":"sfl",
"http://cookingbigdata.com/linkeddata/ccinstances#":"cci",
"http://sweetontology.net/realmOcean/":"soreao",
"http://sweetontology.net/realmAstroStar/":"soreaas",
"http://sweetontology.net/realmClimateZone/":"soreacz",
"http://sweetontology.net/phenAtmoSky/":"sophatmos",
"http://sweetontology.net/phenAtmoFront/":"sophatmofr",
"http://rockets.topbraid.solutions/vort/":"vort",
"http://es.dbpedia.org/resource/":"esdbpr",
"http://sweetontology.net/realmLandOrographic/":"sorealo",
"http://sweetontology.net/stateTimeGeologic/":"sosttg",
"http://sweetontology.net/propChemical/":"sopropche",
"https://w3id.org/trek/":"trek",
"http://sweetontology.net/phenAtmoLightning/":"sophatmol",
"http://sweetontology.net/phenAtmoPressure/":"sophatmops",
"http://theme-e.adaptcentre.ie/dave#":"dave",
"http://yandex.ru/":"yandex",
"http://ont-loupe.linkeddata.es/def/core/":"loupe",
"http://sweetontology.net/propIndex/":"sopropi",
"http://sweetontology.net/phenPlanetClimate/":"sophpc",
"http://sweetontology.net/propRotation/":"sopropr",
"http://www.ontotext.com/proton/":"proton",
"http://sweetontology.net/reprMath/":"sorepm",
"http://id.learning-provider.data.ac.uk/terms#":"lprov",
"http://sweetontology.net/propFraction/":"sopropfr",
"http://sweetontology.net/reprSpaceDirection/":"sorepsd",
"http://sweetontology.net/phenStar/":"sophst",
"https://w3id.org/d2s/":"d2s",
"http://iflastandards.info/ns/fr/frbr/frbroo/":"frbroo",
"http://sweetontology.net/relaSci/":"sorelsc",
"http://www.deutsche-digitale-bibliothek.de/edm/":"ddb",
"http://data.europa.eu/54i/":"eccf",
"http://sweetontology.net/humanJurisdiction/":"sohuj",
"http://sweetontology.net/matrInstrument/":"somains",
"http://linkeddata.finki.ukim.mk/lod/ontology/cfrl#":"cfrl",
"http://sweetontology.net/phenCryo/":"sophcr",
"http://sweetontology.net/humanEnvirStandards/":"sohues",
"http://sweetontology.net/stateRoleGeographic/":"sostrg",
"http://sweetontology.net/matrAerosol/":"somaae",
"http://sweetontology.net/matrCompound/":"somac",
"http://sweetontology.net/realmRegion/":"sorear",
"http://sweetontology.net/stateSolid/":"sostso",
"http://sweetontology.net/phenWaveNoise/":"sophwn",
"http://taxref.mnhn.fr/lod/taxon/":"taxref",
"http://sweetontology.net/propFunction/":"sopropfu",
"http://sweetontology.net/humanResearch/":"sohur",
"http://sweetontology.net/propDifference/":"sopropdife",
"http://ecowlim.tfri.gov.tw/lode/resource/":"ecowlim",
"http://sweetontology.net/matrFacility/":"somaf",
"http://ont.biglinkeddata.com/":"bldont",
"http://sweetontology.net/state/":"sost",
"http://sweetontology.net/realmSoil/":"soreas",
"http://sweetontology.net/phenAtmo/":"sophatmo",
"http://sweetontology.net/matrPlant/":"somapl",
"http://sweetontology.net/relaPhysical/":"sorelph",
"http://sweetontology.net/matrBiomass/":"somab",
"https://www.openstreetmap.org/meta/":"osmm",
"http://sweetontology.net/realmAtmoWeather/":"soreaaw",
"http://sweetontology.net/realmLandProtected/":"sorealp",
"http://sweetontology.net/procWave/":"soprocw",
"http://sweetontology.net/reprDataModel/":"sorepdm",
"http://sweetontology.net/stateRoleTrust/":"sostrt",
"http://sweetontology.net/reprSpaceGeometry3D/":"sorepsg3",
"https://w3id.org/hdgi#":"hdgi",
"http://sweetontology.net/phenMixing/":"sophm",
"https://w3id.org/gaia-x/development#":"gx",
"http://sweetontology.net/phenCycleMaterial/":"sophcm",
"http://sweetontology.net/relaTime/":"sorelt",
"http://pcdm.org/use#":"pcdmuse",
"http://sweetontology.net/human/":"sohu",
"https://pastebin.com/ThBfphb8#":"mbkeys",
"http://sweetontology.net/stateRoleChemical/":"sostrc",
"http://thebiogrid.org/":"biogrid",
"http://sweetontology.net/stateTimeCycle/":"sosttc",
"http://sweetontology.net/realmEarthReference/":"soreaer",
"http://sweetontology.net/matrEnergy/":"somaen",
"http://sweetontology.net/matrElementalMolecule/":"somaem",
"http://sweetontology.net/reprDataServiceGeospatial/":"sorepdsg",
"http://reference.data.gov.au/def/ont/dataset#":"donto",
"http://sweetontology.net/matrRock/":"somarock",
"http://rhizomik.net/ontologies/PlantHealthThreats.owl.ttl#":"phto",
"http://sweetontology.net/phenElecMag/":"sophel",
"http://data.ggbn.org/schemas/ggbn/terms/":"ggbn",
"http://sweetontology.net/propSpaceThickness/":"sopropst",
"https://w3id.org/pnv#":"pnv",
"http://linked.data.gov.au/def/asgs#":"asgs",
"http://sweetontology.net/realmAtmoBoundaryLayer/":"soreaabl",
"http://sweetontology.net/phenReaction/":"sophr",
"http://purl.org/cyber/misp#":"misp",
"http://sweetontology.net/matrIndustrial/":"somaind",
"http://sweetontology.net/rela/":"sorel",
"http://sweetontology.net/matrRockIgneous/":"somarocki",
"http://sweetontology.net/phen/":"soph",
"http://sweetontology.net/phenCycle/":"sophcy",
"http://sweetontology.net/stateDataProcessing/":"sostdp",
"http://sweetontology.net/relaChemical/":"sorelch",
"http://sweetontology.net/stateSystem/":"sostsy",
"http://sweetontology.net/phenFluidTransport/":"sophft",
"http://www.probonto.org/ontology#":"probont",
"http://sweetontology.net/propTemperature/":"sopropt",
"http://purl.org/net/dbm/ontology#":"dbm",
"http://sweetontology.net/realmLandform/":"soreal",
"http://sweetontology.net/stateSpace/":"sostsp",
"https://purl.org/trak/metamodel/vocab#":"trak",
"http://sweetontology.net/realmCryo/":"soreac",
"http://sweetontology.net/phenAtmoTransport/":"sophatmot",
"http://sweetontology.net/realmOceanFeature/":"soreaofe",
"http://sweetontology.net/matrIsotope/":"somais",
"https://wiki.openstreetmap.org/wiki/Key:":"osmt",
"http://sweetontology.net/sweetAll/":"soall",
"http://sweetontology.net/humanCommerce/":"sohuc",
"http://sweetontology.net/realmAstroHelio/":"soreaah",
"http://api.ohdsi.org/WebAPI/vocabulary/concept/":"omop",
"http://sweetontology.net/reprTimeDay/":"soreptd",
"http://ldf.fi/schema/mmm/":"mmms",
"http://lv2plug.in/ns/lv2core/":"lv2",
"http://sweetontology.net/procChemical/":"soprocc",
"https://sireneld.io/vocab/compub#":"compub",
"http://shacleditor.org/":"she",
"http://sweetontology.net/reprSciModel/":"sorepsmo",
"http://sweetontology.net/reprDataService/":"sorepds",
"http://sweetontology.net/phenSystemComplexity/":"sophsyc",
"https://w3id.org/cto#":"cto",
"http://sweetontology.net/phenOceanDynamics/":"sophod",
"http://purl.jp/bio/10/mccv#":"mccv",
"http://sweetontology.net/phenEnvirImpact/":"sophei",
"http://sweetontology.net/matrSediment/":"somas",
"http://sweetontology.net/relaSpace/":"sorelsp",
"http://purl.bioontology.org/ontology/SNOMEDCT/":"snomedct",
"http://sweetontology.net/phenBiol/":"sophb",
"https://w3id.org/idsa/code/":"idsc",
"http://stocktwits.com/":"twitter",
"http://sweetontology.net/prop/":"soprop",
"http://sweetontology.net/matrEquipment/":"somaeq",
"http://sweetontology.net/phenHydro/":"sophhy",
"http://sweetontology.net/matrWater/":"somaw",
"http://sweetontology.net/stateRoleBiological/":"sostrb",
"http://sweetontology.net/stateSpectralBand/":"sostsb",
"https://saref.etsi.org/saref4city/":"s4city",
"https://saref.etsi.org/saref4agri/":"s4agri",
"http://sweetontology.net/humanEnvirControl/":"sohueccont",
"https://say.data.gift/ns/":"say",
"http://www.wikidata.org/entity/statement/":"wds",
"http://sweetontology.net/matrIon/":"somaio",
"http://sweetontology.net/phenGeolTectonic/":"sophgt",
"http://www.ontotext.com/owlim/RDFRank#":"rank",
"http://sweetontology.net/humanEnvirAssessment/":"sohuea",
"http://sweetontology.net/realmBiolBiome/":"soreabb",
"http://sweetontology.net/realmLandTectonic/":"sorealt",
"http://sweetontology.net/stateRole/":"sostro",
"http://purl.bioontology.org/ontology/OMIM/":"omim",
"https://w3id.org/oc/ontology/":"oco",
"http://vocab.ciudadesabiertas.es/def/transporte/bicicleta-publica#":"esbici",
"http://www.ontologyrepository.com/CommonCoreOntologies/Mid/":"ccomid",
"http://sweetontology.net/stateEnergyFlux/":"sostef",
"http://sweetontology.net/phenEnergy/":"sophen",
"http://www.openlinksw.com/ontology/software#":"oplsoft",
"http://ns.inria.fr/semed/eduprogression#":"edupro",
"https://w3id.org/scholarlydata/ontology/indicators-ontology.owl#":"schoi",
"https://www.openstreetmap.org/relation/":"osmrel",
"https://w3id.org/ldes#":"ldes",
"http://datafoodconsortium.org/ontologies/DFC_FullModel.owl#":"dfc",
"http://sweetontology.net/phenWave/":"sophw",
"http://data.diekb.org/def/ocsw#":"ocsw",
"http://betalinkeddata.cbs.nl/def/cbs#":"cbs",
"https://data.nasa.gov/ontologies/atmonto/data#":"atd",
"https://w3id.org/brot#":"brot",
"http://sweetontology.net/stateFluid/":"sostf",
"http://sweetontology.net/statePhysical/":"sostp",
"http://www.bigdata.com/rdf/gas#":"gas",
"http://taxref.mnhn.fr/lod/property/":"taxrefprop",
"http://sweetontology.net/phenGeolSeismicity/":"sophgs",
"http://purl.org/hercules/asio/core#":"asio",
"http://sweetontology.net/realmLandFluvial/":"sorealf",
"http://lei.info/gleio/":"gleio",
"http://sweetontology.net/stateTime/":"sostti",
"http://sweetontology.net/realmLandGlacial/":"sorealg",
"http://sweetontology.net/matrElement/":"somael",
"http://ciao.it/":"ciao",
"http://elite.polito.it/ontologies/eupont.owl#":"eupont",
"https://data.nasa.gov/ontologies/atmonto/ATM#":"atm",
"http://sweetontology.net/phenGeolGeomorphology/":"sophgg",
"http://sweetontology.net/stateRealm/":"sostre",
"http://sweetontology.net/realmLandAeolian/":"soreala",
"http://purl.org/ontology/places/":"place",
"http://schema.org/birthDate/":"birthdate",
"http://sweetontology.net/matrAnimal/":"soman",
"http://sweetontology.net/phenFluidInstability/":"sophfi",
"http://sweetontology.net/stateSpaceScale/":"sostss",
"http://example.org/dummydata/":"dd",
"http://stream-ontology.com/matvoc/":"matvoc",
"http://sweetontology.net/matrMicrobiota/":"somamic",
"https://www.docam.ca/glossaurus/":"docam",
"http://data.vlaanderen.be/ns/persoon#":"persoon",
"http://vocab.sti2.at/wasa/":"wasa",
"https://iaco.me/":"io",
"http://sweetontology.net/humanDecision/":"sohud",
"http://sweetontology.net/stateSpaceConfiguration/":"sostsc",
"https://data.istex.fr/ontology/istex#":"istex",
"http://sweetontology.net/phenOcean/":"sopho",
"http://sweetontology.net/realmAstroBody/":"soreaab",
"http://sweetontology.net/phenHelio/":"sophhe",
"https://privatealpha.com/ontology/content-inventory/1#":"ci",
"https://data.vlaanderen.be/ns/mobiliteit#":"mobiliteit",
"http://george.gr/":"malaka",
"http://sweetontology.net/matrParticle/":"somapa",
"https://spec.edmcouncil.org/fibo/ontology/master/latest/":"fibo",
"https://sparql.crssnky.xyz/Ogura_Hyakunin_Isshu_LinkedRDF/URIs/Ogura_Hyakunin_Isshu_schema.ttl#":"ogura",
"https://www.openstreetmap.org/node/":"osmnode",
"http://cookingbigdata.com/linkeddata/ccregions#":"ccr",
"http://cookingbigdata.com/linkeddata/ccsla#":"ccsla",
"http://sweetontology.net/stateSpectralLine/":"sostsl",
"http://sweetontology.net/phenGeolVolcano/":"sophgv",
"http://purl.oclc.org/NET/WebApiAuthentication#":"waa",
"http://sweetontology.net/stateStorm/":"sostst",
"http://rl.com/resources/":"rl",
"http://sweetontology.net/phenGeol/":"sophg",
"https://metadata.moe/toaru-sparql/elements/":"toaru",
"http://sweetontology.net/humanAgriculture/":"sohua",
"https://saref.etsi.org/saref4ener/":"s4ener",
"http://dbepedia.org/ontology/":"dbonto",
"http://www.openlinksw.com/ontology/features#":"oplfeat",
"https://gd.eppo.int/taxon/":"eppo",
"http://semantic.komc/usu/2020/knows#":"knows",
"http://datafoodconsortium.org/ontologies/DFC_BusinessOntology.owl#":"dfcb",
"http://sweetontology.net/phenGeolFault/":"sophgf",
"https://www.openstreetmap.org/way/":"osmway",
"http://sweetontology.net/realmLandVolcanic/":"sorealv",
"http://sparql.xyz/facade-x/ns/":"fx",
"http://kbpedia.org/kko/rc/":"kko",
"http://www.arpenteur.org/ontology/Arpenteur.owl#":"arp",
"http://fernanda.nl/":"fernanda",
"http://vocab.sti2.at/uimo/":"uimo",
"https://vlueprint.org/schema/":"vlueprint",
"http://www.w3.org/ns/lemon/lexicog#":"lexicog",
"http://sweet.jpl.nasa.gov/2.3/humanJurisdiction.owl#":"jur",
"https://ontology.uis-speleo.org/ontology/#":"karstlink",
"http://rdaregistry.info/termList/RDARecordingSources/":"rdasource",
"http://marineregions.org/ns/ontology#":"mr",
"http://rdf.cdisc.org/ct/schema#":"cts",
"http://purl.org/wot-catalogue#":"wotc",
"http://movie.com/ontology/":"movieo",
"http://opendata.aragon.es/def/ei2a#":"ei2a",
"http://data.businessgraph.io/ontology#":"ebg",
"https://prismdb.takanakahiko.me/prism-schema.ttl#":"prismdb",
"http://rdaregistry.info/termList/RDAPolarity/":"rdapol",
"http://sweetontology.net/realm/":"sorea",
"http://www.bioassayontology.org/bao#":"bao",
"https://ns.gs1.org/epcis/":"epcis",
"https://saref.etsi.org/saref4envi/":"saref4envi",
"http://data.amadeus.com/":"ams",
"http://mangaview.fr/mgv#":"mgv",
"http://linkeddata.ru/":"ld",
"http://vocab.rapidthings.eu/ns/ble.ttl#":"ble",
"https://textgridrep.org/":"textgrid",
"http://purl.jp/bio/12/glyco/conjugate#":"gco",
"https://devuan.net.br/wiki/mpg123/":"mpg123",
"https://w3id.org/gom#":"gom",
"https://www.w3.org/ns/i18n#":"i18n",
"http://vocab.rapidthings.eu/ns/apple/ibeacon.ttl#":"ibeacon",
"http://sparql.xyz/facade-x/data/":"xyz",
"http://purl.org/cld/freq/":"freq",
"http://dbpedia.org/resource/Lyon#":"contry",
"https://w3id.org/hpont#":"hpont",
"https://w3id.org/tso#":"tso",
"https://w3id.org/bop#":"bop",
"https://w3id.org/bcom#":"bcom",
"https://id.loc.gov/vocabulary/marcgt/":"marcgt",
"http://cso.kmi.open.ac.uk/schema/cso/":"cso",
"https://w3id.org/srr#":"srr",
"https://makg.org/property/":"mag",
"http://khalidaloufi.sa/quran#":"quran",
"http://rdaregistry.info/Elements/t/":"rdat",
"http://vocab.ciudadesabiertas.es/def/transporte/trafico#":"estraf",
"http://www.motogp.com/":"motogp",
"http://ns.inria.fr/pgxo/":"pgxo",
"http://rdaregistry.info/termList/rofchrda/":"rofchrda",
"http://pid.accurids.com/":"accid",
"http://www.opensilex.org/vocabularies/oeso#":"oeso",
"http://fr.dbpedia.org/page/Maroc/":"maroc",
"https://mltd.pikopikopla.net/mltd-schema#":"mltd",
"https://rdf.ag/o/hops#":"hops",
"http://univ.io/":"univ",
"https://www.w3.org/2018/credentials/v1/":"vr",
"https://ns.gs1.org/cbv/":"cbv",
"http://rdaregistry.info/termList/RDAUnitOfTime/":"rdaut",
"https://w3id.org/con-tax#":"contax",
"https://linked.art/ns/terms/":"la",
"https://moodle.insa-lyon.fr/course/view.php?id=":"hola",
"http://purl.org/ozo/vph.owl#":"vph",
"http://vocab.rapidthings.eu/ns/ble/adapter.ttl#":"bleadapter",
"https://awslabs.github.io/smithy/rdf-1.0#":"smithy",
"http://data.bigdatagrapes.eu/resource/ontology/":"bdg",
"http://lod.archaeology.link/data/samian/":"samian",
"https://html.spec.whatwg.org/#":"dom",
"http://vocab.ciudadesabiertas.es/def/sector-publico/convenio#":"esconv",
"http://rdaregistry.info/termList/RDAExtensionPlan/":"rdaep",
"http://id.nlm.nih.gov/mesh/2021/":"mesh2021",
"http://purl.org/aspect/":"aspect",
"https://mdcs.monumentenkennis.nl/damageatlas/ontology#":"mdcs",
"https://w3id.org/stax/ontology#":"stax",
"http://purl.oclc.org/NET/ssnx/ssn#":"ssnx",
"http://pornhub.com/":"check",
"http://purl.org/kpd/":"kpd",
"http://rdaregistry.info/Elements/n/object/":"rdano",
"http://data.europa.eu/930/":"geodcat",
"http://rpg.data.is4.site/":"rpg",
"https://neuroshapes.org/":"nsg",
"http://purl.bioontology.org/ontology/STY/":"sty",
"http://rdaregistry.info/Elements/m/datatype/":"rdamd",
"http://urn.fi/URN:NBN:fi:au:slm:":"slm",
"http://rdaregistry.info/Elements/i/object/":"rdaio",
"http://rdaregistry.info/Elements/x/datatype/":"rdaxd",
"http://semantic-faas.com/ontology#":"faas",
"https://rdf.metanetx.org/schema/":"mnx",
"https://w3id.org/citedcat-ap/":"citedcat",
"http://lblod.data.gift/vocabularies/automatische-melding/":"melding",
"http://rdaregistry.info/Elements/a/object/":"rdaao",
"http://archaeology.link/ontology#":"lado",
"http://rdaregistry.info/termList/roffgrda/":"roffgrda",
"http://IBCNServices.github.io/Folio-Ontology/Folio.owl#":"folio",
"http://vocab.ciudadesabiertas.es/def/transporte/autobus#":"esautob",
"http://rdaregistry.info/termList/RDATypeOfBinding/":"rdatb",
"http://purl.org/signify/ns#":"signify",
"http://rdaregistry.info/Elements/i/datatype/":"rdaid",
"http://rdaregistry.info/Elements/t/object/":"rdato",
"https://data.grottocenter.org/ldp/":"datagc",
"https://w3id.org/idpo#":"idpo",
"http://www.w3.org/ns/spec#":"spec",
"https://ld.admin.ch/":"ch",
"http://rdaregistry.info/termList/RDATasks/":"rdatask",
"http://rdf.ag/o/cerealstoo#":"cerealstoo",
"http://www.w3.org/ns/solid/oidc#":"oidc",
"http://semweb.mmlab.be/ns/rml-compression#":"comp",
"https://vocab.eccenca.com/itops/":"itops",
"http://www.semanticweb.org/julien/morgann/cinema#":"cinema",
"http://qudt.org/vocab/sou/":"sou",
"http://www.mydomain.org/Mrk-ns#":"mrk",
"http://www.ontotext.com/sparql/functions/":"ofn",
"http://rdaregistry.info/termList/rofitrda/":"rofitrda",
"https://openenergyplatform.org/ontology/oeo/":"oeo",
"http://rdaregistry.info/Elements/t/datatype/":"rdatd",
"http://rdaregistry.info/Elements/n/":"rdan",
"http://vocab.ciudadesabiertas.es/def/sector-publico/empleo#":"esempleo",
"https://solid.ti.rw.fau.de/public/ns/arena#":"arena",
"http://rdaregistry.info/Elements/m/object/":"rdamo",
"http://rdaregistry.info/Elements/e/datatype/":"rdaed",
"http://www.semanticweb.org/magma-core/user#":"magmauser",
"http://www.semanticweb.org/magma-core/ontologies/hqdm#":"hqdmontol",
"https://w3id.org/lbs/tci#":"tci",
"http://rdaregistry.info/Elements/p/datatype/":"rdapd",
"https://w3id.org/react#":"react",
"http://ontology.ogham.link/":"oghamonto",
"https://www.luigiusai.it/wp#":"luigiusai",
"http://rdaregistry.info/Elements/w/object/":"rdawo",
"http://rdaregistry.info/termList/RDAMaterial/":"rdamat",
"http://memorix.io/ontology#":"memorix",
"http://matrycs.com/":"matrycs",
"http://marineregions.org/ns/placetypes#":"mrt",
"http://rdaregistry.info/termList/RDAInteractivityMode/":"rdaim",
"https://www.feedipedia.org/":"feed",
"http://rdaregistry.info/Elements/x/object/":"rdaxo",
"http://rdaregistry.info/termList/rofsfrda/":"rofsfrda",
"https://data.epo.org/linked-data/def/cpc/":"cpc",
"http://www.w3.org/2021/XMLSchema#":"xmlns",
"http://semRAT.edu/":"encargado",
"http://rdaregistry.info/termList/scale/":"rdasca",
"http://lod.ogham.link/data/":"ogham",
"https://w3id.org/eep#":"eep",
"https://schema.edu.ee/":"edu",
"http://data.bioontology.org/ontologies/NBO/":"nbo",
"http://w3id.org/nfdi4ing/metadata4ing#":"m4i",
"http://lbd.arch.rwth-aachen.de/bcfOWL#":"bcfowl",
"https://pokemonkg.org/ontology#":"poke",
"http://rdaregistry.info/Elements/n/datatype/":"rdand",
"https://paf.link/":"paf",
"http://rdaregistry.info/Elements/p/":"rdap",
"https://w3id.org/affectedBy#":"aff",
"http://www.w3id.org/def/caso#":"caso",
"http://www.w3.org/ns/solid/interop#":"interop",
"http://data.europa.eu/s66#":"eurio",
"http://modellingdh.github.io/ont/odp/pgc/":"cpg",
"http://data.ashrae.org/standard223#":"s223",
"http://purl.obolibrary.org/obo/UBERON_":"uberon",
"http://ethoinformatics.org/":"ewg",
"http://ldf.fi/schema/bioc/":"biocrm",
"https://w3id.org/nsd#":"nsd",
"https://www.tno.nl/agrifood/ontology/common-greenhouse-ontology#":"cgo",
"https://w3id.org/sds#":"sds",
"https://w3id.org/rc#":"rc",
"https://w3id.org/srmo#":"srmo",
"http://purl.org/datajourneys/":"djo",
"http://w3id.org/srt#":"srt",
"https://solid.ti.rw.fau.de/public/ns/linked-data-structures#":"lds",
"https://solid.ti.rw.fau.de/public/ns/event-sourcing-containers#":"esc",
"http://rdaregistry.info/termList/RDARecordingMethods/":"rdapath",
"https://sso.godaddy.com/":"godaddy",
"https://w3id.org/TRO/":"tro",
"https://w3id.org/dsd#":"dsd",
"http://rdaregistry.info/Elements/w/datatype/":"rdawd",
"https://kerndatensatz-forschung.de/version1/technisches_datenmodell/owl/kdsf.owl#":"kdsf",
"https://w3id.org/eb#":"eb",
"https://www.stm-assoc.org/asf/":"asf",
"https://terminology.fraunhofer.de/voc/bau#":"bau",
"https://w3id.org/quid/":"quid",
"http://w3id.org/ghga/":"ghga",
"https://purl.org/fidbaudigital/subjects#":"bdsubj",
"http://example.com/":"meat",
"http://w3id.org/gaia-x/core#":"gax",
"https://w3id.org/emmo/domain/characterisation-methodology/chameo#":"chameo",
"https://www.inf.bi.rub.de/srtun#":"srtun",
"https://solid.ti.rw.fau.de/public/ns/stream-containers#":"ldpsc",
"http://eaontology.protect.linkeddata.es/def/":"ea",
"https://w3id.org/lbdserver#":"lbds",
"http://rdf4j.org/shacl-extensions#":"rsx",
"https://w3id.org/tern/ontologies/tern/":"tern",
"https://www.amazon.de/":"walmart",
"https://w3id.org/wfont#":"wfont",
"http://www.semanticweb.org/fefar/ontologies/ontobras#":"ontobras",
"https://w3id.org/ofo#":"ofo",
"https://archivo.dbpedia.org/onto#":"archivo",
"https://w3id.org/rail/topo#":"rto",
"http://parliament.uk/ontologies/peerage/":"ppeer",
"https://universaldependencies.org/format.html#":"conllu",
"https://w3id.org/stirdata/vocabulary/":"stirdata",
"https://data.vlaanderen.be/ns/generiek#":"generiek",
"http://www.semanticweb.org/magma-core/rdl#":"magmardl",
"https://w3id.org/OSDU#":"osdu",
"http://www.wikidata.org/prop/novalue/":"wdno",
"http://emmo.info/emmo/application/maeo/experts#":"experts",
"http://bag.basisregistraties.overheid.nl/def/bag#":"bag2",
"http://www.semanticweb.org/hqdm#":"hqdm",
"http://www.openlinksw.com/schemas/twitter#":"opltw",
"https://w3id.org/dmo#":"dmo",
"https://purls.helmholtz-metadaten.de/diso#":"diso",
"http://data.nobelprize.org/resource/laureate/":"nprl",
"https://w3id.org/linkml/":"linkml",
"http://www.loc.gov/MARC21/slim/":"marc",
"http://purl.org/twc/vocab/setl/":"setl",
"http://semweb.mmlab.be/ns/rml-target#":"rmlt",
"http://www.cidoc-crm.org/extensions/crmsci/":"crmsci",
"http://www.filmstandards.org/schemas/filmportal_relations#":"fpr",
"https://w3id.org/fso#":"fso",
"https://lod.mediathek-tanz-theater.de/schema/paam/":"paam",
"https://w3id.org/express#":"express",
"https://nomenclature.info/nom/ontology/":"nomo",
"https://w3id.org/CovidO#":"covido",
"http://www.researchspace.org/resource/":"rsp",
"http://semanticweb.org/patricia/ontologies/rro#":"rro",
"http://rdaregistry.info/Elements/e/object/":"rdaeo",
"http://lsq.aksw.org/":"lsqr",
"http://www.w3.org/ns/json-ld#":"jsonld",
"https://collectiedata.hetnieuweinstituut.nl/":"hni",
"http://w3id.org/roh#":"roh",
"https://terminology.fraunhofer.de/voc/raum#":"raum",
"http://rism.online/":"rism",
"http://gfgfd.vs/":"value",
"http://ns.inria.fr/kg/index#":"kgi",
"http://ii.uwb.edu.pl/pgo#":"pgo",
"http://landregistry.data.gov.uk/def/common/":"lrcommon",
"https://ultragaz24horas.com/":"ultragaz",
"https://data.cultureelerfgoed.nl/id/rnce#":"rnce",
"https://w3id.org/chemrof/":"chemrof",
"https://w3id.org/respond#":"respond",
"https://data.vlaanderen.be/ns/besluitvorming#":"besluitvor",
"http://purl.org/nemo/gufo#":"gufo",
"http://purl.org/tempo/":"tempo",
"http://purl.obolibrary.org/obo/cido.owl/":"cido",
"http://purl.org/NET/rdfchess/ontology/":"chess",
"https://w3id.org/iddo#":"iddo",
"https://nomenclature.info/nom/":"nom",
"https://version.link/":"vl",
"https://w3id.org/consolid#":"consolid",
"https://data.dsi.omgeving.vlaanderen.be/ns/dsi#":"dsi",
"https://purl.org/vimmp/osmo#":"osmo",
"https://w3id.org/icon/ontology/":"icon",
"http://purl.org/eduo/rtedurp/":"rtedurp",
"http://semantics.id/ns/example/film/":"film",
"http://www.semanticweb.org/minhn/ontologies/2021/0/vntourism#":"vntourism",
"https://www.gbif.org/grscicoll/collection/":"grscicoll",
"https://w3id.org/peco#":"peco",
"http://www.openlinksw.com/schemas/graphql#":"gql",
"https://w3id.org/TTRpg#":"ttrpg",
"https://collection.rcgs.jp/terms/":"rcgs",
"https://solid.ti.rw.fau.de/public/ns/robotArm#":"robotarm",
"http://rdfs.org/resume-rdf/base.rdfs#":"cvb",
"http://purl.obolibrary.org/obo/MONDO_":"mondo",
"http://activitypods.org/ns/core#":"apods",
"http://jena.apache.org/function/spatial#":"spatialf",
"http://onlyfans.com/veelana/":"veelana",
"https://pubchem.ncbi.nlm.nih.gov/":"pubchem",
"https://perscido.univ-grenoble-alpes.fr/":"perscido",
"https://w3id.org/lbd/aec3po/":"aec3po",
"http://dbpedia.org/datatype/":"dbd",
"https://w3id.org/nen2660/def#":"nen2660",
"https://raadzaam.nl/schema/":"raad",
"https://w3id.org/fdp/fdp-o#":"fdp",
"http://www.koko.t/":"kokot",
"https://data.norge.no/vocabulary/dqvno#":"dqvno",
"https://w3id.org/vhbieo#":"vhbieo",
"http://yanice-boady.webflow.io/":"yanice",
"http://data.europa.eu/949/":"era",
"https://w3id.org/iot-tta#":"iottta",
"https://lod.nal.usda.gov/nalt/":"nalt",
"http://w3id.org/bmp#":"bmp",
"http://rds.posccaesar.org/ontology/lis14/rdl/":"lis",
"https://schema.coypu.org/global#":"coy",
"http://ufo.com/#":"ufo",
"http://www.w3.org/2004/02/skos/mapping#":"skosm",
"https://sbalot.github.io/lol/":"lol",
"http://docbook.org/ns/docbook/":"docbook",
"http://w3id.org/emmo-bto/bto#":"bto",
"http://data.europa.eu/a4g/ontology#":"epo",
"http://example.org/plant/":"plant",
"https://w3id.org/fdof/ontology#":"fdof",
"http://vocabularis.crai.ub.edu/thub/":"thub",
"http://data.europa.eu/r5r/":"dcatap",
"http://purl.obolibrary.org/obo/ZP_":"bcgo",
"https://w3id.org/emmo#":"emmo",
"https://w3id.org/ecfo#":"ecfo",
"https://data.norge.no/vocabulary/dcatno#":"dcatno",
"https://purl.org/hmas/":"hmas",
"https://www.compliancequest.com/training-management-software-system-solutions/":"fs",
"http://www.marineinfo.org/ns/ontology#":"mi",
"http://data.europa.eu/nuts/code/":"nutscode",
"http://dbpedia.org/page/":"dbpg",
"https://data.vlaanderen.be/ns/chemische_stof#":"vcs",
"https://w3id.org/ontouml#":"ontouml",
"http://purl.obolibrary.org/obo/TO_":"to",
"https://w3id.org/asbingowl/core#":"asb",
"https://w3id.org/ro/terms/workflow-run#":"wrroc",
"https://id.agschemas.org/":"ags",
"https://w3id.org/simulation/data/":"hyr",
"http://ldf.fi/schema/ammo/":"ammo",
"https://cve.mitre.org/":"threat",
"http://purl.org/coreo#":"coreo",
"http://bio2rdf.org/goa_vocabulary:":"goavoc",
"http://www.w3.org/ns/solid/acp#":"acp",
"https://w3id.org/baf#":"baf",
"https://www.atcc.org/products/":"atcc",
"https://schema.finto.fi/ntp#":"ntp",
"http://qudt.org/2.1/vocab/currency/":"cur",
"http://materialsmine.org/ns/":"matmine",
"https://personsincontext.org/model#":"pico",
"https://www.w3id.org/risk#":"risk",
"http://id.unece.org/def/coos#":"coos",
"https://w3id.org/iadopt/ont/":"iop",
"https://data.crow.nl/imbor/def/":"imbor",
"http://id.loc.gov/authorities/names/":"lcnaf",
"http://marineinfo.org/ns/library/bibcodes#":"mibc",
"https://dataid.dbpedia.org/databus#":"databus",
"https://w3id.org/sense#":"sense",
"http://data.ashrae.org/bacnet/2020#":"bacnet",
"https://purl.org/p2p-o#":"p2po",
"https://w3id.org/inesdata#":"ind",
"https://scch.org/technical_standards#":"tsso",
"https://mail.google.com/":"hu",
"https://www.mitre.org/mparmelee/ontologies/2023/6/UserIntentOntology/":"uio",
"https://linkeddata.cultureelerfgoed.nl/def/ceox#":"ceox",
"https://rb.gy/ntg7l/":"quest",
"https://www.mindat.org/":"mindat",
"https://w3id.org/riverbench/schema/metadata#":"rb",
"http://keyelements.ltd/ontologies/keyon/#":"keyon",
"https://ifitkau.github.io/fisa/":"fisa",
"http://art.uniroma2.it/coda/contracts/":"coda",
"https://w3id.org/ontouml-models/vocabulary#":"ocmv",
"https://marineinfo.org/ns/library/bibtypes#":"mibt",
"https://w3id.org/coswot/":"coswot",
"http://data.elsevier.com/vocabulary/ElsevierPubItemTypes/":"pit",
"https://raw.githubusercontent.com/nsai-uio/ExeKGOntology/main/ds_exeKGOntology.ttl#":"exekg",
"http://bsdd.buildingsmart.org/def#":"bsdd",
"https://bioschemas.org/":"bioschemas",
"https://app.korfin.de/ontology/into/":"into",
"https://seznam.cz/":"koko",
"https://w3id.org/riverbench/schema/documentation#":"rbdoc",
"http://data.norge.no/vocabulary/cpsvno#":"cpsvno",
"http://purl.org/nemo/doce#":"doce",
"https://w3id.org/sssom/":"sssom",
"https://api.hyprdia.com/":"hy",
"http://www.w3.org/ns/solid/notifications#":"notify",
"https://www.ncbi.nlm.nih.gov/":"ncbi",
"https://w3id.org/mifesto#":"mifesto",
"https://cercabib.ub.edu/":"cercabib",
"https://linkedpaperswithcode.com/class/":"lpwcc",
"https://w3id.org/semapv/vocab/":"semapv",
"https://www.ddeworld.org/":"dde",
"https://w3id.org/plasma#":"plasma",
"https://w3id.org/pbac#":"pbac",
"http://emmo.info/doam#":"doam",
"http://www.w3.org/":"w3",
"http://ub.edu/dades/ontologia/Cinema#Cinemes#":"ontologia",
"http://schemas.openxmlformats.org/package/2006/metadata/core-properties/":"cp",
"http://quit.aksw.org/vocab/":"quit",
"https://w3id.org/emmo/domain/battery/battery#":"battery",
"http://purl.obolibrary.org/obo/PdumDv_":"pdumdv",
"http://data.norge.no/skosno#":"skosno",
"https://onto.kul.pl/ontohgis/":"ontohgis",
"http://w3id.org/ioc#":"ioc",
"https://www.ebi.ac.uk/ols4/ontologies/nmrcv/terms?short_form=NMR:":"nmr",
"http://purl.obolibrary.org/obo/HsapDv_":"hsapdv",
"http://w3id.org/topologicpy#":"top",
"https://w3id.org/isoprops#":"isoprops",
"https://w3id.org/sri#":"sri",
"https://pcp-on-web.de/ontology/0.2/index-en.html#":"pcp",
"http://purl.obolibrary.org/obo/LOGGERHEAD_":"loggerhead",
"https://ch.paf.link/":"chpaf",
"http://ns.inria.fr/sure#":"sure",
"http://ies.data.gov.uk/ontology/ies4#":"ies",
"https://www.ebi.ac.uk/interpro/entry/InterPro/":"interpro",
"http://emmo.info/emmo/application/bmo#":"batmanont",
"http://www.gramene.org/db/ontology/search?id=GRO:":"gramene",
"http://marineinfo.org/ns/person/roles#":"mir",
"https://linkedpaperswithcode.com/property/":"lpwc",
"http://purl.obolibrary.org/obo/ORNASEQ_":"ornaseq",
"http://lod.openaire.eu/vocab/":"oav",
"http://purl.obolibrary.org/obo/UPHENO_":"upheno",
"http://purl.obolibrary.org/obo/HOM_":"hom",
"http://purl.obolibrary.org/obo/APOLLO_SV_":"apollosv",
"http://eurovoc.europa.eu/":"eurovoc",
"https://foundry.ai.mil/ontology/nas/fro/":"fro",
"http://w3id.org/emmo-maeo/maeo#":"maeo",
"https://paul.ti.rw.fau.de/~jo00defe/ble/sbo#":"sbo",
"http://purl.obolibrary.org/obo/DDPHENO_":"ddpheno",
"http://purl.obolibrary.org/obo/PROCO_":"proco",
"http://onlyfans.com/emiliaszymanska/":"przecieki",
"https://www.w3.org/2018/credentials#":"cred",
"http://purl.obolibrary.org/obo/FOVT_":"fovt",
"http://purl.obolibrary.org/obo/SOPHARM_":"sopharm",
"https://ns.dublincore.org/openwemi/":"openwemi",
"https://w3id.org/def/nyon#":"nyon",
"https://w3id.org/iicongraph/data/":"iig",
"http://www.w3.org/ns/tdmrep#":"tdm",
"https://w3id.org/msl#":"msl",
"http://m.imdb.com/":"imdb",
"https://dbpedia.org/page/Cergy/":"cergy",
"https://id.kb.se/marc/":"kbmarc",
"http://purl.obolibrary.org/obo/COB_":"cob",
"http://olis.dev/":"olis",
"https://semopenalex.org/ontology/":"soa",
"http://purl.obolibrary.org/obo/WBls_":"wbls",
"http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/":"iptc4xmpc",
"http://purl.obolibrary.org/obo/VT_":"vt",
"https://domestic-beethoven.eu/ontology/1.0/music-annotation-ontology.ttl#":"mao",
"https://loinc.org/":"loinc",
"https://jpsearch.go.jp/term/property#":"jps",
"http://purl.obolibrary.org/obo/GALLONT_":"gallont",
"https://ontologie.capdataculture.fr/v1/owl/#":"capdata",
"http://w3id.org/lpto#":"lpto",
"http://purl.obolibrary.org/obo/MRO_":"mro",
"https://deonta.linkedmodel.org/deonta/":"deonta",
"http://www.w3.org/ns/pim/meeting#":"mee",
"http://nikunj.org/ontology/occupatioin#":"occupation",
"http://purl.obolibrary.org/obo/TAXRANK_":"taxrank",
"https://w3id.org/oseg/ont/osh#":"osh",
"http://purl.obolibrary.org/obo/ICEO_":"iceo",
"https://credit.niso.org/":"credit",
"http://www.w3.org/ns/shacl-shacl#":"shsh",
"https://w3id.org/dgaterms#":"dgaterms",
"https://w3id.org/emmo/domain/chemical-substance#":"chems",
"https://w3id.org/emmo/domain/electrochemistry#":"echem",
"http://purl.obolibrary.org/obo/DOID_":"doid",
"http://schema.geolink.org/1.0/base/main#":"geolink",
"http://purl.obolibrary.org/obo/PLANP_":"planp",
"https://datacommons.org/browser/":"dcid",
"http://purl.obolibrary.org/obo/MOP_":"mop",
"http://purl.obolibrary.org/obo/EMAP_":"emap",
"http://purl.obolibrary.org/obo/MCO_":"mco",
"http://purl.obolibrary.org/obo/HAO_":"hao",
"http://purl.obolibrary.org/obo/VHOG_":"vhog",
"http://purl.obolibrary.org/obo/AAO_":"aao",
"http://purl.obolibrary.org/obo/FBdv_":"fbdv",
"http://purl.obolibrary.org/obo/OBI_":"obi",
"https://iflastandards.info/ns/lrm/lrmoo/":"lrm",
"http://purl.obolibrary.org/obo/SPD_":"spd",
"http://purl.obolibrary.org/obo/CLAO_":"clao",
"http://purl.obolibrary.org/obo/PROPREO_":"propreo",
"https://w3id.org/oseg/ont/okh#":"okh",
"https://gallosiciliani.unict.it/ns/lpont#":"liph",
"http://www.ics.forth.gr/isl/CRMgeo/":"crmgeo",
"https://w3id.org/mbl#":"mbl",
"http://purl.obolibrary.org/obo/FBbt_":"fbbt",
"http://www.topbraid.org/tops#":"tops",
"https://mutual-aid.app/ns/core#":"maid",
"http://purl.obolibrary.org/obo/CMF_":"cmf",
"http://apmwg.ovh/":"apmwg",
"http://purl.obolibrary.org/obo/FBcv_":"fbcv",
"http://w3id.org/firebim#":"firebim",
"https://kibanshoe.com/":"foaa",
"http://purl.obolibrary.org/obo/OMO_":"omo",
"http://w3id.org/emmo-hpo/hpo#":"hpo",
"https://graph.interoptx.org/meas/":"meas",
"http://purl.obolibrary.org/obo/SEPIO_":"sepio",
"https://www.qualityze.com/document-management/":"qualityze",
"http://purl.obolibrary.org/obo/IDOMAL_":"idomal",
"https://ontology.fiafcore.org/":"fiaf",
"http://purl.obolibrary.org/obo/UO_":"uo",
"http://www.ebu.ch/metadata/ontologies/ebucoreplus#":"ecp",
"https://w3id.org/oseg/ont/tsdc/req#":"tsdcreq",
"http://purl.obolibrary.org/obo/ONS_":"ons",
"http://purl.obolibrary.org/obo/OGSF_":"ogsf",
"http://purl.obolibrary.org/obo/CVDO_":"cvdo",
"http://purl.obolibrary.org/obo/ECOCORE_":"ecocore",
"http://purl.obolibrary.org/obo/PAO_":"pao",
"http://purl.obolibrary.org/obo/FOODON_":"foodon",
"http://purl.obolibrary.org/obo/OVAE_":"ovae",
"https://w3id.org/aimaix#":"aimaix",
"http://purl.obolibrary.org/obo/ONTOAVIDA_":"ontoavida",
"http://www.inoh.org/ontology-viewer/cgi-bin/InohOVAttr.php?type=IMR&id=":"imr",
"http://purl.obolibrary.org/obo/TTO_":"tto",
"https://www.goudatijdmachine.nl/def#":"gtm",
"http://www.w3id.org/urban-iot/core#":"uiot",
"http://kcoyle.net/cwo/":"cwo",
"http://purl.org/net/multionto/":"multionto",
"https://standards.buildingsmart.org/DataDictionary/":"dictionary",
"http://cacax.fun/":"cacax",
"http://purl.obolibrary.org/obo/MFOEM_":"mfoem",
"http://datos.bcn.cl/ontologies/bcn-resources#":"bcnres",
"https://marineinfo.org/ns/progress#":"miprog",
"http://purl.obolibrary.org/obo/PGDSO_":"pgdso",
"http://purl.obolibrary.org/obo/BOOTSTREP_":"bootstrep",
"http://purl.obolibrary.org/obo/DUO_":"duo",
"https://w3id.org/open-bom/ont/open-bom#":"obom",
"https://w3id.org/HHT#":"hht",
"http://purl.obolibrary.org/obo/MAT_":"mat",
"http://id.loc.gov/datatypes/EDTFScheme/":"edtf",
"http://purl.obolibrary.org/obo/XCO_":"xco",
"http://guez.fr/":"guez",
"https://credit.niso.org/contributor-roles/":"crcr",
"http://purl.obolibrary.org/obo/MmusDv_":"mmusdv",
"http://purl.obolibrary.org/obo/BSPO_":"bspo",
"http://purl.obolibrary.org/obo/TGMA_":"tgma",
"http://ns.inria.fr/pwkso/":"pwkso",
"https://w3id.org/libeas#":"libeas",
"https://w3id.org/vair#":"vair",
"http://purl.obolibrary.org/obo/GEO_":"geogeo",
"http://www.embrc.eu/emobon/EmoBonOntology#":"emobon",
"http://purl.obolibrary.org/obo/XAO_":"xao",
"http://purl.obolibrary.org/obo/SYMP_":"symp",
"http://purl.obolibrary.org/obo/NCRO_":"ncro",
"http://purl.obolibrary.org/obo/EUPATH_":"eupath",
"https://w3id.org/oseg/ont/tsdc/core#":"tsdc",
"http://example.org/joe/":"joe",
"http://purl.obolibrary.org/obo/MPATH_":"mpath",
"http://purl.obolibrary.org/obo/OBA_":"oba",
"http://rds.posccaesar.org/ontology/plm/ds/":"after",
"https://w3id.org/amv/":"amv",
"http://purl.obolibrary.org/obo/MFOMD_":"mfomd",
"http://purl.obolibrary.org/obo/OHPI_":"ohpi",
"http://vtw.elsevier.com/data/ns/properties/PromotionalAccess-1/":"pa",
"https://w3id.org/duodrl#":"duodrl",
"https://qaecy.com/dev/ont#":"qcy",
"http://www.semanticweb.org/sunsr/ontologies/2024/ypc#":"ypc",
"http://purl.obolibrary.org/obo/LABO_":"labo",
"https://graph.interoptx.org/cams/schema/":"cams",
"https://w3id.org/oseg/ont/otrl#":"otrl",
"https://mre.zcu.cz/ontology/nihss.owl#":"nihss",
"http://purl.obolibrary.org/obo/ZEA_":"zea",
"http://purl.obolibrary.org/obo/EHDAA_":"ehdaa",
"http://google.com/":"luffy",
"https://register.ld.admin.ch/termdat/":"termdat",
"http://purl.obolibrary.org/obo/PDRO_":"pdro",
"https://w3id.org/moont/":"moont",
"http://purl.obolibrary.org/obo/GSSO_":"gsso",
"http://purl.obolibrary.org/obo/APO_":"apo",
"https://w3id.org/dob/id/":"did",
"http://example.org/ckg#":"ckg",
"http://purl.obolibrary.org/obo/CHMO_":"chmo",
"http://purl.obolibrary.org/obo/LIPRO_":"lipro",
"http://purl.obolibrary.org/obo/DISDRIV_":"disdriv",
"http://purl.obolibrary.org/obo/OGG_":"ogg",
"http://semanticweb.org/edo#":"edo",
"http://purl.obolibrary.org/obo/OPMI_":"opmi",
"http://purl.obolibrary.org/obo/KISAO_":"biomodels",
"http://purl.obolibrary.org/obo/CTENO_":"cteno",
"http://purl.obolibrary.org/obo/DIDEO_":"dideo",
"https://ekgf.github.io/dprod/":"dprod",
"https://animaldiversity.org/accounts/":"adw",
"https://semanticweb.inesctec.pt/ontologies/pes/":"pes",
"http://purl.obolibrary.org/obo/CHIRO_":"chiro",
"http://mlcommons.org/croissant/":"cr",
"http://purl.obolibrary.org/obo/HANCESTRO_":"hancestro",
"http://purl.obolibrary.org/obo/CEPH_":"ceph",
"http://purl.obolibrary.org/obo/FLOPO_":"flopo",
"http://purl.obolibrary.org/obo/ICO_":"ico",
"http://purl.obolibrary.org/obo/OGMS_":"ogms",
"http://purl.obolibrary.org/obo/AMPHX_":"amphx",
"http://purl.obolibrary.org/obo/PCL_":"pcl",
"http://purl.obolibrary.org/obo/PW_":"pw",
"https://paul.ti.rw.fau.de/~jo00defe/voc/spa#":"spa",
"https://w3id.org/dob/voc/prop#":"dop",
"http://purl.obolibrary.org/obo/LEPAO_":"lepao",
"http://purl.obolibrary.org/obo/VariO_":"vario",
"https://nyanneko.com/":"nyanneko",
"http://purl.obolibrary.org/obo/OARCS_":"oarcs",
"http://purl.obolibrary.org/obo/PSDO_":"psdo",
"https://vocab.noeldemartin.com/crdt/":"crdt",
"https://w3id.org/aksw/norse#":"norse",
"http://purl.obolibrary.org/obo/FBbi_":"fbbi",
"http://purl.obolibrary.org/obo/FLU_":"flu",
"http://vocab.rpi.edu/whyis/":"whyis",
"http://purl.obolibrary.org/obo/VBO_":"vbo",
"http://4dx.embl.de/4DXpress/reg/all/cview/gene.do?geneID=":"bila",
"http://www.openlinksw.com/schemas/github#":"oplgit",
"http://purl.obolibrary.org/obo/NOMEN_":"nomen",
"https://w3id.org/rdf-lens/ontology#":"rdfl",
"http://purl.obolibrary.org/obo/OOSTT_":"oostt",
"https://w3id.org/aix#":"aix",
"https://purl.org/psn/vocab#":"psn",
"http://purl.obolibrary.org/obo/TAHE_":"tahe",
"http://purl.obolibrary.org/obo/OMIT_":"omit",
"http://example.org/makeup#":"makeup",
"https://paul.ti.rw.fau.de/~jo00defe/SemWoT/aio#":"aio",
"http://purl.obolibrary.org/obo/ADO_":"ado",
"http://purls.helmholtz-metadaten.de/cmso/":"cmso",
"http://purl.obolibrary.org/obo/OMRSE_":"omrse",
"http://purl.obolibrary.org/obo/YPO_":"ypo",
"https://w3id.org/airo#":"airo",
"http://purl.obolibrary.org/obo/FIX_":"fix",
"http://purl.obolibrary.org/obo/EHDAA2_":"ehdaa2",
"http://purl.obolibrary.org/obo/OCCO_":"occo",
"http://purl.obolibrary.org/obo/SLSO_":"slso",
"http://purl.obolibrary.org/obo/TAHH_":"tahh",
"http://www.openlinksw.com/schemas/opengraph#":"oplog",
"https://w3id.org/dob/voc#":"dob",
"http://w3id.org/loin#":"loin",
"http://iflastandards.info/ns/lrm/lrmer/":"lrmer",
"https://linkeddata.cultureelerfgoed.nl/def/ceosp/":"ceosp",
"http://purl.obolibrary.org/obo/ZECO_":"zeco",
"http://i-na-reg.musikinstrumentenbau.eu/ns/musi/":"musi",
"https://www.ebi.ac.uk/ols4/ontologies/mcro/classes?obo_id=MCRO:":"mcro",
"http://purl.obolibrary.org/obo/ENVO_":"envo",
"http://purl.obolibrary.org/obo/CDNO_":"cdno",
"http://purl.obolibrary.org/obo/TADS_":"tads",
"https://ror.org/":"ror",
"https://w3id.org/imec/rml/ns/extensions#":"rmle",
"http://purl.obolibrary.org/obo/OlatDv_":"olatdv",
"http://purl.obolibrary.org/obo/VSAO_":"vsao",
"http://purl.obolibrary.org/obo/OHMI_":"ohmi",
"http://purl.obolibrary.org/obo/OGI_":"ogi",
"http://purl.obolibrary.org/obo/WBbt_":"wbbt",
"http://purl.obolibrary.org/obo/PLANA_":"plana",
"http://purl.obolibrary.org/obo/ZFA_":"zfa",
"http://purl.obolibrary.org/obo/EO_":"eo",
"http://purl.obolibrary.org/obo/GENO_":"geno",
"http://purl.obolibrary.org/obo/EHDA_":"ehda",
"http://purl.obolibrary.org/obo/AfPO_":"afpo",
"https://graphql.org/":"graphql",
"https://w3id.org/reloc#":"reloc",
"https://purl.org/npc#":"npc",
"http://purl.obolibrary.org/obo/VTO_":"vto",
"https://dblp.org/rdf/docu/#":"dblpdocu",
"http://purl.obolibrary.org/obo/EPIO_":"epio",
"https://stgermain.ebsi.umontreal.ca/miron/":"miron",
"http://purl.obolibrary.org/obo/T4FS_":"t4fs",
"http://purl.obolibrary.org/obo/HSO_":"hso",
"http://purl.obolibrary.org/obo/OMIABIS_":"omiabis",
"https://w3id.org/womo#":"womo",
"http://www.exemple.org/ontologia/":"oip",
"http://www.grenoble.prabi.fr/obiwarehouse/unipathway/upa?upid=":"upa",
"http://purl.obolibrary.org/obo/SCDO_":"scdo",
"http://purl.obolibrary.org/obo/CIO_":"cio",
"http://server.topbraidlive.org/web/2009/config#":"cfg",
"http://purl.obolibrary.org/obo/COLAO_":"colao",
"http://purl.obolibrary.org/obo/FBSP_":"fbsp",
"http://purl.obolibrary.org/obo/FOBI_":"fobi",
"http://purl.obolibrary.org/obo/VO_":"vo",
"http://purl.obolibrary.org/obo/MFMO_":"mfmo",
"https://vwgroup.leanix.net/Volkswagen/external/leanixId/":"vwlid",
"https://w3id.org/ssv/":"ssv",
"http://purl.obolibrary.org/obo/GENEPIO_":"genepio",
"https://paul.ti.rw.fau.de/~jo00defe/ont/psm#":"psm",
"http://purl.obolibrary.org/obo/GAZ_":"gaz",
"http://purl.obolibrary.org/obo/ATO_":"ato",
"https://w3id.org/geosrs#":"geosrs",
"http://purl.obolibrary.org/obo/FYPO_":"fypo",
"http://purl.obolibrary.org/obo/OBCS_":"obcs",
"http://purl.obolibrary.org/obo/MIAPA_":"miapa",
"https://kvasir.discover.ilabt.imec.be/vocab#":"kvasir",
"http://purl.obolibrary.org/obo/GNO_":"gno",
"https://data.wikitrek.org/prop/direct/":"dtkt",
"http://purl.obolibrary.org/obo/TRANS_":"trans",
"https://bohoaff.com/a34fd6fba/":"freespins",
"https://softwarehorsepower.com/product/brand24/":"jabel54303",
"http://purl.obolibrary.org/obo/ZFS_":"zfs",
"https://proteininformationresource.org/cgi-bin/resid?id=":"resid",
"http://data.sparna.fr/ontologies/volipi#":"volipi",
"http://purl.obolibrary.org/obo/REX_":"rex",
"http://purl.obolibrary.org/obo/MAXO_":"maxo",
"http://meta-pfarrerbuch.evangelische-archive.de/vocabulary#":"mpbv",
"http://www.openlinksw.com/schemas/googleplus#":"oplgp",
"https://www.niso.org/schemas/jav/1.0/":"jav",
"http://www.inoh.org/ontology-viewer/cgi-bin/InohOVAttr.php?type=IEV&id=":"iev",
"http://purl.obolibrary.org/obo/DRON_":"dron",
"http://purl.obolibrary.org/obo/XPO_":"xpo",
"http://purl.obolibrary.org/obo/AISM_":"aism",
"http://purl.obolibrary.org/obo/MICRO_":"micro",
"https://w3id.org/HHT/Change#":"hhtchange",
"https://w3id.org/fair4ml#":"fair4ml",
"https://schema.ld.admin.ch/":"aschema",
"http://purl.obolibrary.org/obo/AERO_":"aero",
"https://w3id.org/ftr#":"ftr",
"http://ddialliance.org/Specification/DDI-CDI/1.0/RDF/":"cdi",
"http://purl.obolibrary.org/obo/PORO_":"poro",
"http://purl.obolibrary.org/obo/ECAO_":"ecao",
"http://w3id.org/oseg/ont/tsdc/requirements#":"tsdcr",
"http://purl.obolibrary.org/obo/MIRO_":"miro",
"https://codemeta.github.io/terms/":"codemeta",
"http://purl.obolibrary.org/obo/DDANAT_":"ddanat",
"http://www.example.com/myvData/":"myv",
"http://purl.obolibrary.org/obo/EMAPA_":"emapa",
"http://purl.obolibrary.org/obo/FIDEO_":"fideo",
"http://purl.obolibrary.org/obo/NGBO_":"ngbo",
"http://purl.obolibrary.org/obo/INO_":"ino",
"http://purl.obolibrary.org/obo/STATO_":"stato",
"https://linkeddata.cultureelerfgoed.nl/def/zo/":"zo",
"https://data.digichecks.eu/def/":"checks",
"http://purl.obolibrary.org/obo/XLMOD_":"xlmod",
"http://purl.obolibrary.org/obo/RNAO_":"rnao",
"http://purl.obolibrary.org/obo/PHIPO_":"phipo",
"https://purl.org/cityexplorer#":"ce",
"https://purl.org/supply-network/onto#":"sn",
"https://w3id.org/OntoGSN/ontology#":"gsn",
"http://purl.obolibrary.org/obo/CARO_":"caro",
"http://w3id.org/aicat#":"aicat",
"http://purl.obolibrary.org/obo/OBIB_":"obib",
"http://w3id.org/aiup#":"aiup",
"http://purl.org/creon/":"creon",
"https://data.wikitrek.org/entity/":"dtk",
"https://w3id.org/dob/voc/epsg-27700#":"bng",
"http://w3id.org/CEON/":"ceon",
"https://linkeddata.cultureelerfgoed.nl/def/azo/":"azo",
"https://cutt.ly/3ry8LMcK/":"onlyfans",
"http://w3id.org/podio#":"podio",
"http://www.w3.org/ns/lemon/frac#":"frac",
"http://purl.obolibrary.org/obo/ECTO_":"ecto",
"http://data.europa.eu/ux2/nace2/":"nace2",
"http://purl.obolibrary.org/obo/MIRNAO_":"mirnao",
"https://vwgroup.leanix.net/Volkswagen/factsheet/Process/":"vwlpr",
"http://demo.openlinksw.com/schemas/Northwind/":"northwind",
"https://semanticweb.inesctec.pt/ontologies/encom/":"encom",
"https://onlyfans.com/sammuwuu/":"fugas",
"http://purl.obolibrary.org/obo/ARO_":"aro",
"https://nepalpassport.gov.np/":"passport",
"http://purl.obolibrary.org/obo/AEO_":"aeo",
"http://www.hds.utc.fr/tg#":"tgc",
"https://www.w3id.org/virtual-treasury/ontology#":"vrti",
"http://franz.com/ns/allegrograph/2.2/textindex/":"fti",
"https://regulacomp.unige.ch/ns/regcomp#":"regcomp",
"http://vtw.elsevier.com/data/voc/ns/bam-vtw-1/":"bam",
"https://w3id.org/spot#":"spot",
"https://w3id.org/arco/ontology/arco/":"arco",
"http://prismstandard.org/namespaces/prismusagerights/2.1/":"pur",
"http://vocabularies.unesco.org/thesaurus/":"unesco",
"http://purl.org/terminology-guide-for-move/testvocab/":"tgfm",
"http://purl.org/nsoluti/oqs#":"oqs",
"https://vwgroup.leanix.net/Volkswagen/factsheet/Application/":"vwlap",
"https://w3id.org/ishikawa-diagram-ontology#":"ishi",
"http://www.purl.org/drammar#":"drammar",
"http://w3id.org/awslabs/neptune/SPARQL-CDTs/":"scdt",
"http://jats.nlm.nih.gov/":"jats",
"http://w3id.org/def/och/":"och",
"http://example.org/bambara#":"bambara",
"https://w3id.org/foodwaste/ontology#":"fwo",
"http://data.europa.eu/c4p/data/":"debias",
"https://w3id.org/NPO/ontology/":"npo",
"http://turism.com/":"turism",
"https://w3id.org/NCL/ontology/":"ncl",
"http://www.semanticweb.org/pedri/ontologies/2025/3/IntelligentTourismAndRecommendations#":"itandrec",
"https://www.librorum.fr/ontology/":"libro",
"https://ptb.de/si#":"dsio",
"https://know.dev/":"know",
"https://mestergruppen.no/ontologies/projectproductionmanagement/":"ppm",
"http://de.dbpedia.org/property/":"dbpde",
"http://id.nlm.nih.gov/datmm/":"datmm",
"http://research-info-systems.com/schema/ris/":"ris",
"http://purl.obolibrary.org/obo/RBO_":"rbo",
"http://purl.bioontology.org/ontology/ICD9CM/":"icd",
"https://purl.semanticip.org/linked-data/":"sip",
"https://group-wiki.wob.vw.vwg/wikis/pages/viewpage.action?pageId=":"vwgw",
"http://iirds.tekom.de/iirds#":"iirds",
"https://ptb.de/sis/":"sis",
"https://elsst.cessda.eu/id/":"elsst",
"https://eliasempresas.com/":"eliasempre",
"https://w3id.org/riskman/ontology#":"riskman",
"https://w3id.org/reno#":"reno",
"https://w3id.org/sulo/":"sulo",
"https://vwdmsweb.wob.vw.vwg/groupdms/?docbase=vwdms&locateId=":"vwdms",
"http://visual-meaning.com/rdf/":"vm",
"http://borhan-onto.ir/ontology/upper#":"bu",
"https://purl.org/muno/onto/":"muno",
"https://w3id.org/golem/ontology#":"golem",
"http://www.dbs.cs.uni-duesseldorf.de/RDF/relational#":"rdb",
"http://bdi.whu.edu.cn/":"whu",
"http://purl.org/genex#":"genex",
"https://w3id.org/semts/ontology#":"semts",
"https://w3id.org/DQA#":"dqa",
"http://w3id.org/coso/v1/contaminoso#":"coso",
"http://ponymusic.wiki/ns#":"pmw",
"http://data.ub.uib.no/ontology/":"ubbont",
"http://www.bootstrep.eu/ontology/GRO#":"gro",
"https://purl.archive.org/akco#":"akco",
"https://w3id.org/tribont/core#":"tribont",
"http://w3id.org/evorao/":"evorao",
"http://purl.org/coar/resource_type/":"coar",
"https://w3id.org/csro/ontology#":"csro",
"http://purl.obolibrary.org/obo/EXMO_":"exmo",
"http://data.europa.eu/snb/model/elm/":"elm",
"https://w3id.org/rdf-connect#":"rdfc",
"http://purl.org/org/iode/po/voc/cruise-summary-reports#":"csr",
"https://devtoolkit.space/ontology#":"dtool",
"http://dcat-ap.de/def/dcatde/":"dcatde",
"https://w3id.org/afy#":"afy",
"http://idpf.org/epub/vocab/package/a11y/#":"a11y",
"https://github.com/senzing-garage/sz-semantics/wiki/ns#":"sz",
"http://purl.obolibrary.org/obo/BMONT_":"bmont",
"http://w3id.org/bodi#":"bodi",
"https://ontology.seadatanet.org/#":"sdn",
"https://w3id.org/pghdprovo#":"pghdprovo",
"https://homosaurus.org/v4/":"homoit",
"https://w3id.org/mobilitydcat-ap#":"mdcat",
"https://data.banenor.no/ontology/":"bno",
"http://www.loc.gov/mods/rdf/v1#":"modsrdf",
"http://topbraid.org/tbs#":"tbs",
"https://data.banenor.no/data/":"bnd",
"https://w3id.org/time-fn#":"tfn",
"http://ontology.railml.org/railtopomodel#":"rtm",
"https://w3id.org/rdf-tensor/vocab#":"tensor",
"http://ontology.railml.org/railml3#":"railml3",
"https://www.stratcom.mil/ontologies/electromagnetic-spectrum/adversary-radar-detection-ontology/":"ard",
"https://ptb.de/dccs/":"dccs",
"http://omeka.org/s/vocabs/o#":"omekas",
"https://ns.verisav.fr/dpp#":"dpp",
"https://terms.codata.org/rdmt/":"rdm",
"https://ontology.swissartresearch.net/aaao/":"aaao",
"http://uispin.org/let#":"let",
"https://w3id.org/dpv/pd#":"dpvpd",
"https://cours.iut-orsay.fr/":"iut",
"https://data.vlaanderen.be/ns/":"vlaanderen",
"https://www.openstreetmap.org/wiki/Key:":"osmkey",
"https://data.elsevier.com/e/identifier/":"idtype",
"https://w3id.org/whg/id/":"whg",
"http://w3id.org/mdo/":"mdo",
"https://w3id.org/plato#":"plato",
"http://data.esante.gouv.fr/ansm/medicament/":"med",
"https://takumifujimoto.com/schema/":"tf",
"https://w3id.org/mdr#":"mdr",
"http://qudt.org/vocab/coordinate/":"coord",
"https://w3id.org/mlca/":"mlca",
"http://www.w3id.org/animl/ontology/":"animl",
"https://inspirewrap.ontologycentral.com/adv/gid/7.1#":"gid",
"https://www.darrinbaines.org/ns/identity#":"dbn",
"https://vocab.lifetidy.com/":"lth",
"https://data.riepr.omgeving.vlaanderen.be/ns/riepr#":"riepr",
"http://w3id.org/iaam/i40fd#":"i40fd",
"https://globalwordnet.github.io/schemas/wn#":"gwn",
"https://purl.net/climatesense/lack/ns#":"lack",
"http://data.elsevier.com/publishing/schema/puv/":"puv",
"http://data.europa.eu/s1n/":"statdcatap",
"https://w3id.org/mqto#":"mqto",
"https://w3id.org/def/norma-o#":"norma",
"https://w3id.org/aic#":"aic",
"https://w3id.org/spectra#":"spectra",
"http://xml.zope.org/namespaces/tal/":"tal",
"https://w3id.org/bcore/":"bcore",
"https://devstack.vwgroup.com/":"vwag",
"https://semanticweb.tools/ont/multi#":"multi",
"https://w3id.org/batcat#":"lbco",
"http://opendata.inrae.fr/PO2/Ontology/TransformON/":"tfo",
"http://tecnolettra.uji.es/ontodic#":"ontodic",
"https://w3id.org/bedo/":"bedo",
"https://wik.jp/haishutsu/":"haishutsu",
"https://devstack.vwgroup.com/confluence/rest/api/content/":"vwcds",
"https://wik.jp/kasen/":"kasen",
"https://faptica.com/":"faptica",
"https://w3id.org/bedro/":"bedro",
"https://www.inf.ufrgs.br/ontologies/copi/":"copi",
"https://prismdiscovery.ai/ontology/aeo#":"aeovis",
"https://w3id.org/sstim#":"sstim",
"https://laos.world/ns/khetsetthakit/":"laosez",
"https://wik.jp/denchi/":"denchi",
"https://wik.jp/dengen/":"dengen",
"https://w3id.org/refract#":"fract",
"https://wik.jp/kobutsu/":"kobutsu",
"https://wik.jp/law/ns#":"wjl",
"https://w3id.org/standards/smart/ontologies/core/":"smart",
"https://wik.jp/bousai/":"bousai",
"https://w3id.org/uogto/core#":"uogto",
"https://w3id.org/eautonome/":"eau",
"https://honoria.co.uk/id/honours#":"hon",
"https://w3id.org/uogto/extensions#":"uogtox",
"https://w3id.org/fair-o#":"fairo",
"https://wik.jp/gakkou/":"gakkou",
"https://wik.jp/tokutei/":"tokutei",
"https://laos.world/ns/khoueng/":"laokhoueng",
"https://w3id.org/imo/manufacturing#":"mnf",
"http://modellen.mim-standaard.nl/def/mim#":"mim",
"https://laos.world/ns/muang/":"laomuang",
"https://w3id.org/statbarnsdc#":"sdc",
"https://laos.world/ns/pasa/":"laopasa",
"https://wik.jp/gijutsu/":"gijutsu",
"https://wik.jp/shokugyo/":"shokugyo",
"https://w3id.org/campop/":"campop",
"https://wik.jp/jgs/":"jgs",
"https://wik.jp/hojin/":"hojin",
"https://wik.jp/houki/":"houki",
"https://laos.world/ns/sonphao/":"laosonphao",
"https://wik.jp/todofuken/":"todofuken",
"https://wik.jp/kunishitei/":"kunishitei",
"https://laos.world/ns/boun/":"laoboun",
"https://wik.jp/hinshi/":"hinshi",
"https://laos.world/ns/moladok/":"laomoladok",
"https://wik.jp/kikaku/":"kikaku",
"https://wik.jp/hinmoku/":"hinmoku",
"https://w3id.org/bsdo#":"bsdo",
"https://realcharacterlanguage.world/":"rcl",
"https://wik.jp/sangyo/":"sangyo",
"https://wik.jp/koyomi/":"koyomi",
"https://wik.jp/cbam/":"cbam",
"https://wik.jp/tani/":"tani",
"https://purl.org/supplybench#":"sb",
"https://w3id.org/standards/smart/schema/data/":"smartsh",
"https://w3id.org/gso/1.0/common/":"gsoc",
"https://w3id.org/gso/1.0/element/":"gsel",
"https://wik.jp/kagaku/":"kagaku",
"https://w3id.org/rewt/":"rewt",
"https://w3id.org/gso/1.0/mineral/":"gsmin",
"https://w3id.org/gso/1.0/geologicevent/":"gsev",
"https://w3id.org/gso/1.0/rockmaterial/":"gsrm",
"https://w3id.org/gso/1.0/geologiccontact/":"gscn",
"https://w3id.org/gso/1.0/geologicfault/":"gsfa",
"https://hanami.app/ontology#":"hanami",
"https://portejunes.com/ns/core#":"g1",
"https://w3id.org/xwkont/core#":"xwkont",
"https://w3id.org/cmod/ocp#":"ocp",
"https://w3id.org/didl#":"didl",
"https://w3id.org/dedl#":"dedl",
"https://spdx.org/rdf/3/terms/":"spdx3",
"http://data.cenova.org/ontology/":"cenova"}
